<template>
    <div>
        <a-spin :spinning="spinning">
            <h2 v-if="promo.promo_type == '1' && profileId == 0">Create Item and Pool Discounts - {{promo.name}}</h2>
            <h2 v-else-if="promo.promo_type == '1' && profileId > 0">{{(viewOnly) ? "View" : "Edit" }} Item and Pool Discounts - {{promo.name}}</h2>
            <h2 v-if="promo.promo_type == '2' && profileId == 0">Create Purchase with Purchase - {{promo.name}}</h2>
            <h2 v-else-if="promo.promo_type == '2' && profileId > 0">{{(viewOnly) ? "View" : "Edit" }} Purchase with Purchase - {{promo.name}}</h2>
            <h2 v-if="promo.promo_type == '3' && profileId == 0">Create Seasonal - {{promo.name}}</h2>
            <h2 v-else-if="promo.promo_type == '3' && profileId > 0">{{(viewOnly) ? "View" : "Edit" }} Seasonal - {{promo.name}}</h2>
            <h2 v-if="promo.promo_type == '4' && profileId == 0">Create Coupon Barcode - {{promo.name}}</h2>
            <h2 v-else-if="promo.promo_type == '4' && profileId > 0">{{(viewOnly) ? "View" : "Edit" }} Coupon Barcode - {{promo.name}}</h2>
            <h2 v-if="promo.promo_type == '5' && profileId == 0">Create Coupon Stub - {{promo.name}}</h2>
            <h2 v-else-if="promo.promo_type == '5' && profileId > 0">{{(viewOnly) ? "View" : "Edit" }} Coupon Stub - {{promo.name}}</h2>
            <h2 v-if="promo.promo_type == '6' && profileId == 0">Create Reward Point - {{promo.name}}</h2>
            <h2 v-else-if="promo.promo_type == '6' && profileId > 0">{{(viewOnly) ? "View" : "Edit" }} Reward Point - {{promo.name}}</h2>
            <h2 v-if="promo.promo_type == '7' && profileId == 0">Create Group Bonus - {{promo.name}}</h2>
            <h2 v-else-if="promo.promo_type == '7' && profileId > 0">{{(viewOnly) ? "View" : "Edit" }} Group Bonus - {{promo.name}}</h2>

            <base-alert v-if="errors.length" type="danger">
                <b>You have the following error(s):</b>
                <li v-for="error in errors" :key="error">{{ error }}</li>
            </base-alert>

            <a-modal title="Mass Assign" :visible="modalVisible" :confirm-loading="confirmLoading" @ok="handleOk" @cancel="handleCancel" ok-text="Apply All">
                <fieldset :disabled="viewOnly">
                    <base-input label="Required" v-if="(promo.promo_type == '2' && promo.reward_type != '1')|| promo.promo_type == '3' || promo.promo_type == '5' || promo.promo_type == '6'">
                        <a-input v-model="massRequired" placeholder="Enter Required" />
                    </base-input>
                    <base-input label="Discount" v-if="((promo.promo_type != '6' && promo.promo_type != '3') && promo.promo_type != '4' && promo.promo_type != '5') || (promo.promo_type == '3' && promo.reward_type == '1')" >
                        <a-input v-model="massDiscount" placeholder="Enter Discount" />
                    </base-input>
                    <base-input label="Limit" v-if="(promo.promo_type != '6' && promo.promo_type != '3' && promo.promo_type != '5') || (promo.promo_type == '3' && promo.reward_type == '1')">
                        <a-input v-model="massLimit" placeholder="Enter Limit" />
                    </base-input>
                    <base-input label="Round" v-if="(promo.promo_type != '6' && promo.promo_type != '3' && promo.promo_type != '5') || (promo.promo_type == '3' && promo.reward_type == '1')" >
                        <a-input v-model="massRound" placeholder="Enter Round" value="1" />
                    </base-input>
                </fieldset>
            </a-modal>

            <!-- Available Fields Modal -->
            <a-modal title="Available Fields" :visible="modalAvailableFields"
            @cancel="handleCancel">
                <template slot="footer">
                    <a-button key="back" @click="handleCancel">Close</a-button>
                </template>
                <VueTabulator v-model="couponAvailableFieldsData" :options="couponAvailableFieldsOption"/>
            </a-modal>

            <hr>
            <div class="row no-gutters">
                <div class="col-md-2" style="border-right: 1px solid rgb(224, 224, 224);">
                    <a-steps direction="vertical" :current="current">
                        <a-step title="Info" />
                        <a-step title="Apply Promotion" />
                        <a-step title="Customers" />
                        <a-step title="Payment Types" />
                        <a-step title="Sites" />
                    </a-steps>
                </div>
                <div class="col-md-10">
                    <div class="card mb-3 border-0">
                        <!-- {{coupon}} -->
                        <!-- <form id="form-proper"> -->
                            <div v-if="current == 0" class="card-body">
                                <div class="row">
                                    <div class="col-md-6">
                                        <h2 class="card-title">Promo Information</h2>
                                    </div>
                                    <div class="col-md-6">
                                        <base-dropdown
                                            class="ellisis-cont nav-link pr-0 float-right"
                                            position="right">

                                            <div class="media align-items-center" slot="title">
                                                <i class="fa fa-ellipsis-v float-right ml-2 btn-sm"></i>
                                            </div>

                                            <template>
                                                <div class="dropdown-header noti-title">
                                                <h6 class="text-overflow m-0">Export</h6>
                                                </div>
                                                <div
                                                    class="dropdown-item"
                                                    @click.prevent="exportExcel">
                                                    <i class="fa fa-download"></i>
                                                    <span>Excel</span>
                                                </div>
                                            </template>
                                            </base-dropdown>
                                    </div>
                                </div>
                                <div class="row ml-3">
                                    <div class="col-md-12">
                                        <a-input label="Promo Name" v-model="promo.name" input-classes="form-control" style="margin-bottom: 0px;" placeholder="Enter a description for your promo" required :disabled="viewOnly" />
                                        <small>Example: 10% Off All Shirts</small>
                                        <br><br>
                                        <a-input label="Promo Shortcode" v-model="promo.code" input-classes="form-control" style="margin-bottom: 0px;" placeholder="Enter a short code to identify your promo" required :disabled="viewOnly" @keypress="validatePromoCodeInput" @input="validatePromoCode" maxlength="100" />
                                        <small>Example: PROMO10 (alphanumeric only, no spaces or special characters)</small>
                                        <br><br>
                                        <base-input label="Status"><br>
                                            <a-select  v-model="promo.status" style="width: 100%" @change="replaceStatus" :key="keyComp" :disabled="viewOnly">
                                                <a-select-option key="A" value="A">Active</a-select-option>
                                                <a-select-option key="I" value="I">In-Active</a-select-option>
                                                <a-select-option key="U" value="U" disabled>On-Going-Upload</a-select-option>
                                                <a-select-option key="E" value="E">Error</a-select-option>
                                            </a-select>
                                        </base-input>
                                        <base-checkbox class="mb-3 mt-3" v-model="include_3p_items" :disabled="viewOnly">
                                                <b>Include 3P Items</b>
                                        </base-checkbox>
                                        <base-checkbox class="mb-3 mt-3" v-model="include_mark_down_items" :disabled="viewOnly">
                                                <b>Include Mark Down Items</b>
                                        </base-checkbox>
                                    </div>
                                </div>
                                <h2 class="card-title">Promo Duration</h2>
                                <div class="row ml-3">
                                    <div class="col-md-12">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <base-input label="Start Date">
                                                    <br><a-date-picker v-model="promo.start_at" :format="dateFormat" style="width: 100%" :disabled="viewOnly"/>
                                                    <small>Enter a valid start date</small>
                                                </base-input>
                                            </div>
                                            <div class="col-md-6">
                                                <base-input label="End Date">
                                                    <br><a-date-picker v-model="promo.end_at" :format="dateFormat" style="width: 100%" :disabled="viewOnly"/>
                                                    <small>Enter a valid end date</small>
                                                </base-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <base-input label="Start Time"><br>
                                                    <a-time-picker use12Hours v-model="promo.start_at" format="hh:mm A" style="width: 100%" :disabled="viewOnly"/>
                                                    <small>Enter a valid start time</small>
                                                </base-input>
                                            </div>
                                            <div class="col-md-6">
                                                <base-input label="End Time"><br>
                                                    <a-time-picker use12Hours v-model="promo.end_at" format="hh:mm A" style="width: 100%" :disabled="viewOnly"/>
                                                    <small>Enter a valid end time</small>
                                                </base-input>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="d-flex justify-content-center mt-4">
                                    <button type="button" class="btn btn-sm btn-outline-secondary" @click='showAdvancedInfoDiv' >
                                        Advanced Information {{showAdvancedInfo? '↟' : '↡'}}
                                    </button>
                                </div>
                                <div v-if="showAdvancedInfo == true">
                                    <h2 class="card-title" style="margin-bottom: 0px;">Specify Valid Date &amp; Time</h2>
                                    <p>Set specific days and hours when this promotion is available (when not enabled, promotion is valid on all days and hours by default)</p>
                                    <div class="row ml-3">
                                        <div class="col-md-12">
                                            <base-checkbox class="mb-3 mt-3" v-model="is_specify_date" :disabled="viewOnly">
                                                <b>Specify Valid Days</b>
                                            </base-checkbox>
                                            <div class="ml-3">
                                                <span>Promos will only be enable on the days selected</span><br><br>
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <base-checkbox v-model="valid_days.mon" :disabled="is_specify_date == false || viewOnly">
                                                            Monday
                                                        </base-checkbox>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <base-checkbox v-model="valid_days.thu" :disabled="is_specify_date == false || viewOnly">
                                                            Thursday
                                                        </base-checkbox>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <base-checkbox v-model="valid_days.sun" :disabled="is_specify_date == false || viewOnly">
                                                            Sunday
                                                        </base-checkbox>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <base-checkbox v-model="valid_days.tue" :disabled="is_specify_date == false || viewOnly">
                                                            Tuesday
                                                        </base-checkbox>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <base-checkbox v-model="valid_days.fri" :disabled="is_specify_date == false || viewOnly">
                                                            Friday
                                                        </base-checkbox>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <base-checkbox v-model="valid_days.wed" :disabled="is_specify_date == false || viewOnly">
                                                            Wednesday
                                                        </base-checkbox>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <base-checkbox v-model="valid_days.sat" :disabled="is_specify_date == false || viewOnly">
                                                            Saturday
                                                        </base-checkbox>
                                                    </div>
                                                </div>
                                            </div>

                                            <base-checkbox class="mb-3 mt-3" v-model="is_specify_time" :disabled="viewOnly">
                                                <b>Specify Valid Time</b>
                                            </base-checkbox>
                                            <div class="ml-3">
                                                <span>Promos will only be enable on the hours specified</span><br><br>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <base-input label="Start Time"><br>
                                                            <a-time-picker use12Hours v-model="picker_date.valid_start_time" format="hh:mm A" style="width: 100%" :disabled="is_specify_time == false || viewOnly"/>
                                                            <small>Enter a valid start time</small>
                                                        </base-input>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <base-input label="End Time"><br>
                                                            <a-time-picker use12Hours v-model="picker_date.valid_end_time" format="hh:mm A" style="width: 100%" :disabled="is_specify_time == false || viewOnly"/>
                                                            <small>Enter a valid end time</small>
                                                        </base-input>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="current == 1" class="card-body">
                                <!-- <div v-if="promo.promo_type == '2'">
                                    <h2 class="card-title">PWP Config</h2>
                                    <base-input label="Items in Promo are:"><br>
                                        <base-radio value="exclusive" name="exclusive" v-model="promo.apply_level">
                                            Exclusive
                                        </base-radio>
                                        <base-radio value="inclusive" name="inclusive" v-model="promo.apply_level">
                                            Inclusive
                                        </base-radio>
                                    </base-input>
                                </div> -->

                                <h2 class="card-title">Apply Promotion</h2>

                                <fieldset :disabled="viewOnly" v-if="promo.promo_type == '2'" >
                                <base-input label="Items in Promo are:"><br>
                                    <base-radio value="exclusive" name="exclusive" v-model="promo.apply_level">
                                        Exclusive
                                    </base-radio>
                                    <base-radio value="inclusive" name="inclusive" v-model="promo.apply_level">
                                        Inclusive
                                    </base-radio>
                                </base-input>

                                <base-input label="Computation Mode"><br>
                                    <base-radio value="every" name="every" v-model="promo.compute_mode">
                                        For Every
                                    </base-radio>
                                    <base-radio value="minimum" name="minimum" v-model="promo.compute_mode">
                                        For minimum Amount
                                    </base-radio>
                                </base-input>
                                
                                <div v-if="promo.compute_mode == 'every'">
                                    <base-input label="For every amount of" >
                                        <a-input type="number" min="0" v-model="promo.reward_trigger_amount" :disabled="viewOnly"/>
                                    </base-input>
                                    <base-input label="Max Application (0 for unlimited)" >
                                        <a-input type="number" min="0" v-model="promo.reward_trigger_frequency" :disabled="viewOnly"/>
                                    </base-input>
                                </div>

                                <div v-else>
                                    <base-input label="Minimum amount" >
                                        <a-input type="number" min="0" v-model="promo.reward_trigger_amount" :disabled="viewOnly"/>
                                    </base-input>
                                </div>
                                
                                </fieldset>

                                <div class="row ml-3">
                                    <div class="col-md-12">{{ promo.promo_type }}
                                        <base-input label="Promotion Type"><br>
                                            <a-select v-if="promo.promo_type == '1'" v-model="promo.reward_type" style="width: 100%" @change="replaceDiscount" :disabled="viewOnly">
                                                <a-select-option v-for="option in itemPoolOptions" :key="option.key" :value="option.key">{{option.value}}</a-select-option>
                                            </a-select>
                                            <a-select v-if="['2', '7'].includes(promo.promo_type)" v-model="promo.reward_type" style="width: 100%" @change="replaceDiscount" :disabled="viewOnly">
                                                <a-select-option v-for="option in pwpOptions" :key="option.key" :value="option.key">{{option.value}}</a-select-option>
                                            </a-select>
                                            <small>{{reward_type_description}}</small>
                                        </base-input>
                                    </div>
                                </div>

                                <div class="row ml-3">
                                    <div class="col-md-6">
                                        <base-input label="Priority" >
                                            <a-input type="number" min="0" v-model="promo.priority_level" placeholder="Enter Priority Number" @change="isUpdatePromoRewardAndCondition = true" :disabled="viewOnly"/>
                                        </base-input>
                                    </div>
                                </div>
                                
                                <div class="row ml-3" v-if="replaceDiscountKey == '3' && promo.promo_type == '6' ">
                                    <div class="col-md-6">
                                        <base-input :label="'Target '+ (PoolOptionKey == 'TQ' ? 'Quantity' : 'Amount')" >
                                            <a-input-group compact>
                                                <a-select v-model="PoolOptionKey">
                                                    <a-select-option value="TQ">Quantity</a-select-option>
                                                    <a-select-option value="TA">Amount</a-select-option>
                                                </a-select>
                                                <a-input  type="number" min="1" v-model="PoolOptionValue" :placeholder="'Enter '+(PoolOptionKey == 'TQ' ? 'Quantity' : 'Amount')" :disabled="viewOnly" style="width: 87.5%"/>
                                            </a-input-group>
                                        </base-input>
                                    </div>
                                </div>
                                
                                <h2 class="card-title">Select Items</h2>
                                <div class="row ml-3">
                                    <div class="col-md-12">

                                        <!-- START - ITEM POOL & PWP DISCOUNT -->
                                        <div v-if="['1', '2'].includes(promo.promo_type)" class="col p-0">
                                            
                                            <!--  START - INCLUDE ITEM OPTIONS -->
                                            <div class="col-md-6">
                                                <base-input label="Include Items" v-if="['1'].includes(promo.reward_type)"><br>
                                                    <a-select v-model="include_item" style="width: 100%" :disabled="viewOnly" @change="isUpdatePromoRewardAndCondition = true">
                                                        <a-select-option v-for="option in includeItemOptions" :key="includeItemOptionsKey" :value="option.key">{{option.value}}</a-select-option>
                                                    </a-select>
                                                </base-input>
                                            </div>
                                            <!--  END - INCLUDE ITEM OPTIONS -->

                                            <!--  START - SUPPLIER -->
                                            <div v-if="include_item == '2'" class="col-md-6">
                                                <base-input label="Select Supplier" :disabled="viewOnly"><br>
                                                    <a-select v-model="allItem.supplier_id" showSearch placeholder="Select Supplier" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :notFoundContent="fetching ? undefined : null" @search="searchSupplier" @change="isUpdatePromoRewardAndCondition = true">
                                                    <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                                                    <a-select-option v-for="option in supplierOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                                    </a-select>
                                                </base-input>
                                            </div>
                                            <!--  END - SUPPLIER -->

                                            <!--  START - BRAND -->
                                            <div v-if="include_item == '3'" class="col-md-6">
                                                <base-input label="Select Brand" :disabled="viewOnly"><br>
                                                    <a-select v-model="allItem.brand_id" showSearch placeholder="Select Brand" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :notFoundContent="fetching ? undefined : null" @search="searchBrand" @change="isUpdatePromoRewardAndCondition = true" mode="multiple">
                                                    <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                                                    <a-select-option v-for="option in brandOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                                    </a-select>
                                                </base-input>
                                            </div>
                                            <!--  END - BRAND-->

                                            <!--  START - CATEGORIES -->
                                            <div v-if="include_item == '4'" class="col-md-6">
                                                <base-input label="Select Category" :disabled="viewOnly"><br>
                                                    <a-cascader v-model="inputCategory" :options="categoriesOptions" :showSearch="{filter}"
                                                    placeholder="All Categories" style="width: 100%" changeOnSelect @change="isUpdatePromoRewardAndCondition = true" :key="inputCategoryKey"/>
                                                </base-input>
                                            </div>
                                            <!--  END - CATEGORIES -->

                                            <!--  START - NOT SPECFIC ITEMS - All, by supplier, by brand, by category -->
                                            <div v-if="include_item <= 5" class="col-md-12">
                                                <base-input v-if="promo.reward_type == '1'" label="Percent Discount" >
                                                    <a-input type="number" min="0" max="100" v-model="discount" addonAfter="%" placeholder="Enter Percent Discount" :disabled="viewOnly" @change="isUpdatePromoRewardAndCondition = true"/>
                                                </base-input>
                                                <base-input v-else-if="promo.reward_type == '2'" label="Amount Discount" v-model="discount" input-classes="form-control" placeholder="Enter Amount Discount" :disabled="viewOnly" @change="isUpdatePromoRewardAndCondition = true"/>

                                                <base-input v-if="['1', '2'].includes(promo.reward_type)" label="Limit" v-model="max_application_all" input-classes="form-control" placeholder="Enter Max Application" :disabled="viewOnly" @change="isUpdatePromoRewardAndCondition = true"/>

                                            </div>
                                             <!--  END - NOT SPECFIC ITEMS - All, by supplier, by brand, by category -->

                                             <!-- START - ALL ITEMS EXCEPT -->
                                            <div v-if="include_item == 5" class="col-md-12">
                                                <base-button
                                                  v-if="!viewOnly"
                                                  type="default"
                                                  class="btn btn-sm float-right mr-10"
                                                  style="background-color: #394A5D; color: white;"
                                                  @click="openPromoExceptionsDrawer = !openPromoExceptionsDrawer"
                                                  >
                                                  Add Exception
                                                </base-button>

                                                <br>

                                                <!-- Add Table Here -->
                                                <a-table :columns="promoExceptionsOptions" :dataSource="promoExceptions">
                                                  <template slot="render-select" slot-scope="exception_type_display, record">
                                                    <div v-if="exception_type_display == 'Supplier'">
                                                        <a-select v-model="record['exception_value']" placeholder="Select Supplier" optionFilterProp="children" style="width: 100%" disabled>
                                                            <a-select-option v-for="option in supplierOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                                        </a-select>
                                                    </div>
                                                    <div v-else-if="exception_type_display == 'Brand'">
                                                        <a-select v-model="record['exception_value']" placeholder="Select Brand" optionFilterProp="children" style="width: 100%" disabled>
                                                            <a-select-option v-for="option in brandOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                                        </a-select>
                                                    </div>
                                                    <div v-else>
                                                        <a-cascader disabled :key="drawerKey" v-model="record['exception_value_display']" :options="categoriesOptions"
                                                            placeholder="All Categories" style="width: 100%"/>
                                                    </div>
                                                  </template>
                                                  <template slot="render-action" slot-scope="exception_value, record">
                                                        <button
                                                          class="btn btn-sm mr-10"
                                                          style="background-color: #f70909; color: white;"
                                                          @click.prevent="deleteException(record)">
                                                          Delete 
                                                        </button>
                                                  </template>
                                                </a-table>

                                                <!-- <VueTabulator ref="tabulator" v-model="promoExceptions" :options="promoExceptionsOptions"/> -->
                                            </div> 
                                            <!-- END - ALL ITEMS EXCEPT -->

                                            <!--  START - SPECFIC ITEMS  -->
                                            <div class="col-md-12" v-if="(parseInt(promo.reward_type) < 3 && ['6'].includes(include_item)) || (parseInt(promo.reward_type) > 2)">
                                                <a-tabs default-active-key="1" v-model="activeKey">
                                                    <!-- START - ITEM SELECT -->
                                                    <a-tab-pane key="1">
                                                        <span slot="tab">
                                                            <span class="numberCircle">1</span>
                                                            Search
                                                        </span>

                                                        <div class="row no-gutters">
                                                            <div class="col-md-12 mb-3">
                                                                <b-input-group>
                                                                    <template v-slot:prepend>
                                                                        <b-dropdown :text="filterCaption" variant="outline-default">
                                                                            <b-dropdown-item @click.prevent="changeFilter('name')">Name</b-dropdown-item>
                                                                            <b-dropdown-item @click.prevent="changeFilter('id')">Product Code</b-dropdown-item>
                                                                            <b-dropdown-item @click.prevent="changeFilter('barcode')">Barcode</b-dropdown-item>
                                                                            <b-dropdown-item @click.prevent="changeFilter('stock_no')">Stock No</b-dropdown-item>
                                                                            <b-dropdown-item @click.prevent="changeFilter('reference_code')">Reference Code</b-dropdown-item>
                                                                            <b-dropdown-item @click.prevent="changeFilter('shelf_code')">Shelf Code</b-dropdown-item>
                                                                        </b-dropdown>
                                                                    </template>
                                                                    <b-form-input style="padding:5px; height: 44px;" @keypress.enter="allProductsData" v-model="searchText">{{searchText}}</b-form-input>
                                                                
                                                                    <div v-if="toggleAdvanceFilter" id="hide" class="col-md-12" style="border-top: 1px solid #e0e0e0; width: 100%">
                                                                        <product-advance-filter :currentFilter="currentFilter" :parentParams="filterParams" :massUpdateMode="massUpdateMode" @changeParams="changeParams" @closeFilter="closeFilter" :key="filterKey"> </product-advance-filter>
                                                                    </div>
                                                                
                                                                    <div class="filter-cont">
                                                                        <button
                                                                          class="btn btn-sm float-right mr-10"
                                                                          style="background-color: #394A5D; color: white;"
                                                                          @click.prevent="advanceFilter(true)">
                                                                          {{toggleLabel}}
                                                                        </button>&nbsp;&nbsp;
                                                                    
                                                                        <base-button
                                                                          v-if="!viewOnly"
                                                                          type="default"
                                                                          class="btn btn-sm float-right mr-10"
                                                                          style="background-color: #394A5D; color: white;"
                                                                          @click.prevent="addAll">
                                                                          Add All
                                                                        </base-button>
                                                                    
                                                                        <base-dropdown
                                                                          class="ellisis-cont nav-link pr-0 float-right"
                                                                          position="right">

                                                                          <div class="media align-items-center" slot="title">
                                                                            <i class="fa fa-ellipsis-v float-right ml-2 btn-sm"></i>
                                                                          </div>

                                                                          <template>
                                                                            <div class="dropdown-header noti-title">
                                                                              <h6 class="text-overflow m-0">PRODUCT LIST ACTIONS</h6>
                                                                            </div>
                                                                            <div
                                                                              v-if="canUploadProduct"
                                                                              class="dropdown-item"
                                                                              @click.prevent="toggleUploadProductsDrawer(true)">
                                                                              <i class="fa fa-upload"></i>
                                                                              <span>Import</span>
                                                                            </div>
                                                                            <div
                                                                              v-if="canExportProduct"
                                                                              class="dropdown-item"
                                                                              @click.prevent="exportProduct">
                                                                              <i class="fa fa-download"></i>
                                                                              <span>Export</span>
                                                                            </div>
                                                                          </template>
                                                                        </base-dropdown>
                                                                    </div>
                                                                </b-input-group>
                                                            </div>
                                                         </div>

                                                        <!-- <base-checkbox class="ml-1" v-model="is_ref_code">
                                                            View promotion by reference code
                                                        </base-checkbox> -->
                                                    
                                                        <div v-if="changeDisplay == true" class="table-responsive">
                                                            <div id="product-table" ></div>
                                                            <VueTabulator ref="tabulator" v-model="productData" :options="productOptions" style="display:none;" :key="refKey"/>
                                                        </div>
                                                    
                                                        <div v-else class="table-responsive">
                                                            <div id="product-table" style="display:none;"></div>
                                                            <VueTabulator ref="tabulator" v-model="productData" :options="productOptions" :key="refKey"/>
                                                        </div>

                                                    </a-tab-pane>
                                                    <!-- END - ITEM SELECT -->
                                                    
                                                    <!-- START - PROMO PROPER -->
                                                    <a-tab-pane key="2">
                                                        <span slot="tab">
                                                            <span class="numberCircle">2</span>
                                                            Item List
                                                        </span>

                                                        <!-- START - TABLE SELECTED PRODUCTS -->
                                                        <div class="row no-gutters" v-if="parseInt(promo.reward_type) < 4">
                                                            <div class="col-md-12 mb-3">
                                                                <b-input-group>
                                                                    <template v-slot:prepend>
                                                                        <b-dropdown :text="filterCaption1" variant="outline-default">
                                                                            <b-dropdown-item @click.prevent="changeFilter1('name')">Name</b-dropdown-item>
                                                                            <b-dropdown-item @click.prevent="changeFilter1('product_id')">Product Code</b-dropdown-item>
                                                                            <b-dropdown-item @click.prevent="changeFilter1('barcode')">Barcode</b-dropdown-item>
                                                                            <b-dropdown-item @click.prevent="changeFilter1('reference_code')">Reference Code</b-dropdown-item>
                                                                            <b-dropdown-item @click.prevent="changeFilter1('stock_no')">Stock No</b-dropdown-item>
                                                                        </b-dropdown>
                                                                    </template>
                                                                    <b-form-input style="padding:5px; height: 44px;" @keypress.enter="searchItemListProduct" v-model="searchText1">{{searchText1}}</b-form-input>

                                                                    <div class="filter-cont">
                                                                        <base-button @click.prevent="DeleteAll" v-if="selectedRowCount > 0" class="btn btn-sm float-right mr-10"  size="sm">Delete All</base-button>
                                                                        &nbsp;&nbsp;
                                                                        <base-button v-if="(promo.promo_type == '5' && promo.reward_type == '2') == false" type="default" class="btn float-right mr-0" size="sm" :disabled="viewOnly" @click.prevent="massAssign">Mass Assign</base-button>
                                                                    </div>
                                                                </b-input-group>
                                                            </div>
                                                        </div>

                                                        <div class="table-responsive" v-if="parseInt(promo.reward_type) < 4">
                                                          <div v-if="showAddedProductTabulator">
                                                            <fieldset :disabled="viewOnly">
                                                                <!-- && promo.reward_type != '1' && reward.apply_level == 'IL'" -->
                                                                <VueTabulator v-if="promo.promo_type == '2' "
                                                                ref="addedProductTabulator"
                                                                v-model="selectedProductData"
                                                                :options="selectedInlineProductOptions"
                                                                :key="refKey"
                                                                :integration="{ updateStrategy: 'UPDATE' }"
                                                                @cell-click="isUpdatePromoRewardAndCondition = true"
                                                                />
                                                                
                                                                <VueTabulator v-else-if="promo.promo_type == '3' && promo.reward_type == '2'"
                                                                ref="addedProductTabulator"
                                                                v-model="selectedProductData"
                                                                :options="selectedBuyXGetYProductOptions"
                                                                :key="refKey"
                                                                :integration="{ updateStrategy: 'UPDATE' }"
                                                                @cell-click="isUpdatePromoRewardAndCondition = true"
                                                                />

                                                                <VueTabulator v-else-if="promo.promo_type == '6'"
                                                                ref="addedProductTabulator"
                                                                v-model="selectedProductData"
                                                                :options="selectedBuyXGetYProductOptions"
                                                                :key="refKey"
                                                                :integration="{ updateStrategy: 'UPDATE' }"
                                                                @cell-click="isUpdatePromoRewardAndCondition = true"
                                                                />

                                                                <VueTabulator v-else
                                                                ref="addedProductTabulator"
                                                                v-model="selectedProductData"
                                                                :options="selectedProductOptions"
                                                                :key="refKey"
                                                                :integration="{ updateStrategy: 'UPDATE' }"
                                                                @cell-click="isUpdatePromoRewardAndCondition = true"
                                                                />

                                                            </fieldset>
                                                          </div>
                                                        </div>

                                                        <div class="table-responsive" v-if="parseInt(promo.reward_type) == 6">
                                                          <div v-if="showAddedProductTabulator">
                                                            <fieldset :disabled="viewOnly">
                                                                <VueTabulator 
                                                                ref="addedProductTabulator"
                                                                v-model="selectedProductData"
                                                                :options="selectedBuyXGetXProductOptions"
                                                                :key="refKey"
                                                                :integration="{ updateStrategy: 'UPDATE' }"
                                                                @cell-click="isUpdatePromoRewardAndCondition = true"
                                                                />
                                                            </fieldset>
                                                          </div>
                                                        </div>
                                                        <!-- END - TABLE SELECTED PRODUCTS -->

                                                        <!-- START - TABLE SELECTED PRODUCTS (RELATIVE & BUNDLE) -->
                                                        <div v-if="promo.promo_type == '1' && ['4', '5'].includes(promo.reward_type)" class="row">
                                                            <div class="col-7">
                                                                <h3>PRODUCT LIST</h3>
                                                                <small>Please select a product to edit</small>
                                                                <fieldset :disabled="viewOnly">
                                                                    <VueTabulator ref="addedProductTabulator" v-model="selectedProductData" :options="schemeOptions" @row-click="setActiveProductId" :key="refKey"/>
                                                                </fieldset>
                                                            </div>
                                                            <div class="col-5">
                                                                <button type="button" class="btn btn-sm btn-primary float-right" style="margin-bottom: 0px" @click.prevent="levelHandleAdd">ADD LEVEL</button>
                                                                <h3>LEVELS</h3>
                                                                <small>{{activeProductName}}</small>
                                                                <a-table :columns="levelColumns" :dataSource="levelDataFilter" :pagination="false" :scroll="{ y: 400 }">
                                                                    <template v-for="col in ['qty', 'price']"
                                                                        :slot="col" slot-scope="text, record">
                                                                        <div :key="col">
                                                                            <div>
                                                                                <a-input v-if="record.editable" type="number" min="0" style="margin: -5px 0" :value="text"
                                                                                    @change="e => levelHandleChangeTable(e.target.value, record.key, col)" />
                                                                                <template v-else>{{text}}</template>
                                                                            </div>
                                                                        </div>
                                                                    </template>
                                                                    <template slot="operation" slot-scope="text, record">
                                                                        <div class="editable-row-operations">
                                                                            <a-dropdown>
                                                                                <a class="ant-dropdown-link">
                                                                                    <span class="fa fa-ellipsis-v"></span>
                                                                                </a>
                                                                                <a-menu slot="overlay">
                                                                                    <a-menu-item key=1 v-if="levelDataFilter.length">
                                                                                        <a-popconfirm title="Sure to delete?" @confirm="() => levelOnDelete(record.key)">
                                                                                            <a href="javascript:;">Delete</a>
                                                                                        </a-popconfirm>
                                                                                    </a-menu-item>
                                                                                </a-menu>
                                                                            </a-dropdown>
                                                                        </div>
                                                                    </template>
                                                                </a-table>
                                                            </div>
                                                        </div>
                                                        <!-- START - END SELECTED PRODUCTS (RELATIVE & BUNDLE) -->

                                                    </a-tab-pane>
                                                    <!-- END - PROMO PROPER-->

                                                </a-tabs>
                                                
                                            </div>
                                            <!--  END - SPECFIC ITEMS  -->


                                        </div>
                                         <!-- END - ITEM POOL & PWP DISCOUNT -->

                                        <!-- START - GROUP BONUS DISCOUNT -->
                                        <div v-if="['7'].includes(promo.promo_type)" class="col p-0">
                                            <div class="col-md-12">
                                                <a-tabs default-active-key="100" v-model="activeKey2">
                                                    <a-tab-pane :key="gBonusKey1">
                                                        <span slot="tab">
                                                            <span class="numberCircle">1</span>
                                                            Select Pre-requisite Items
                                                        </span>

                                                        <fieldset :disabled="viewOnly" >
                                                            
                                                            <div class="row">
                                                                <div class="col-md-6">
                                                                    <base-input label="For any item in the group,"><br>
                                                                        <base-radio value="every_amt" name="every_amt" v-model="promo.compute_mode">
                                                                            every amount of
                                                                        </base-radio>
                                                                        <base-radio value="every_qty" name="every_qty" v-model="promo.compute_mode">
                                                                            every quantity of
                                                                        </base-radio>
                                                                    </base-input>

                                                                    
                                                                </div>

                                                                <div class="col-md-6">

                                                                    <div v-if="promo.compute_mode == 'every_amt'">
                                                                        <base-input label="Amount" >
                                                                            <a-input type="number" min="1" v-model="promo.reward_trigger_amount" :disabled="viewOnly"/>
                                                                        </base-input>
                                                                    </div>

                                                                    <div v-else>
                                                                        <base-input label="Quantity" >
                                                                            <a-input type="number" min="1" v-model="promo.reward_trigger_amount" :disabled="viewOnly"/>
                                                                        </base-input>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </fieldset>

                                                        <div class="row no-gutters">
                                                            <div class="col-md-12 mb-3">
                                                                <b-input-group>
                                                                    <template v-slot:prepend>
                                                                        <b-dropdown :text="filterCaption" variant="outline-default">
                                                                            <b-dropdown-item @click.prevent="changeFilter('name')">Name</b-dropdown-item>
                                                                            <b-dropdown-item @click.prevent="changeFilter('id')">Product Code</b-dropdown-item>
                                                                            <b-dropdown-item @click.prevent="changeFilter('barcode')">Barcode</b-dropdown-item>
                                                                            <b-dropdown-item @click.prevent="changeFilter('stock_no')">Stock No</b-dropdown-item>
                                                                            <b-dropdown-item @click.prevent="changeFilter('reference_code')">Reference Code</b-dropdown-item>
                                                                            <b-dropdown-item @click.prevent="changeFilter('shelf_code')">Shelf Code</b-dropdown-item>
                                                                        </b-dropdown>
                                                                    </template>

                                                                    <b-form-input style="padding:5px; height: 44px;" @keypress.enter="allProductsDataGB" v-model="searchText">{{searchText}}</b-form-input>
                                                                   
                                                                    <div v-if="toggleAdvanceFilter" id="hide" class="col-md-12" style="border-top: 1px solid #e0e0e0; width: 100%">
                                                                        <product-advance-filter :currentFilter="currentFilter" :parentParams="filterParams" :massUpdateMode="massUpdateMode" @changeParams="changeParams" @closeFilter="closeFilter" :key="filterKey"> </product-advance-filter>
                                                                    </div>
                                                                
                                                                    <div class="filter-cont">
                                                                        <button
                                                                          class="btn btn-sm float-right mr-10"
                                                                          style="background-color: #394A5D; color: white;"
                                                                          @click.prevent="advanceFilter(true)">
                                                                          {{toggleLabel}}
                                                                        </button>&nbsp;&nbsp;
                                                                    
                                                                        <base-button
                                                                          v-if="!viewOnly"
                                                                          type="default"
                                                                          class="btn btn-sm float-right mr-10"
                                                                          style="background-color: #394A5D; color: white;"
                                                                          @click.prevent="addAllGroupBonus">
                                                                          Add All
                                                                        </base-button>
                                                                    
                                                                        <base-dropdown
                                                                          class="ellisis-cont nav-link pr-0 float-right"
                                                                          position="right">
                                                                          <div class="media align-items-center" slot="title">
                                                                            <i class="fa fa-ellipsis-v float-right ml-2 btn-sm"></i>
                                                                          </div>
                                                                          <template>
                                                                            <div class="dropdown-header noti-title">
                                                                              <h6 class="text-overflow m-0">PRODUCT LIST ACTIONS</h6>
                                                                            </div>
                                                                            <div
                                                                              v-if="canUploadProduct"
                                                                              class="dropdown-item"
                                                                              @click.prevent="toggleUploadProductsDrawer(true)">
                                                                              <i class="fa fa-upload"></i>
                                                                              <span>Import</span>
                                                                            </div>
                                                                            <div
                                                                              v-if="canExportProduct"
                                                                              class="dropdown-item"
                                                                              @click.prevent="exportProduct">
                                                                              <i class="fa fa-download"></i>
                                                                              <span>Export</span>
                                                                            </div>
                                                                          </template>
                                                                        </base-dropdown>
                                                                    </div>
                                                                </b-input-group>
                                                            </div>
                                                         </div>
                                                         
                                                        <div class="table-responsive">
                                                            <div id="product-tableB" style="display:none;"></div>
                                                            <VueTabulator id="product-tableB-orig" ref="tabulator" v-model="productDataB" :options="productOptionsB2"/>              
                                                        </div>

                                                    </a-tab-pane>

                                                    <a-tab-pane :key="gBonusKey2">
                                                        <span slot="tab">
                                                            <span class="numberCircle">2</span>
                                                            Review Pre-requisite Items
                                                        </span>

                                                        <fieldset :disabled="viewOnly">
                                                            <!-- <div id="product-tableB" ></div> -->
                                                            <VueTabulator :key="selectedProductBRefKey" ref="addedProductTabulator" v-model="selectedProductDataB" :options="preReqOptions"/>
                                                        </fieldset>
                                                    </a-tab-pane>

                                                    <a-tab-pane :key="gBonusKey3" >
                                                        <span slot="tab">
                                                            <span class="numberCircle">3</span>
                                                            Select Promotion Items
                                                        </span>

                                                        <div class="row no-gutters">
                                                            <div class="col-md-12 mb-3">
                                                                <b-input-group>
                                                                    <template v-slot:prepend>
                                                                        <b-dropdown :text="filterCaptionB" variant="outline-default">
                                                                            <b-dropdown-item @click.prevent="changeFilterB('name')">Name</b-dropdown-item>
                                                                            <b-dropdown-item @click.prevent="changeFilterB('id')">Product Code</b-dropdown-item>
                                                                            <b-dropdown-item @click.prevent="changeFilterB('barcode')">Barcode</b-dropdown-item>
                                                                            <b-dropdown-item @click.prevent="changeFilterB('stock_no')">Stock No</b-dropdown-item>
                                                                            <b-dropdown-item @click.prevent="changeFilterB('reference_code')">Reference Code</b-dropdown-item>
                                                                            <b-dropdown-item @click.prevent="changeFilterB('shelf_code')">Shelf Code</b-dropdown-item>
                                                                        </b-dropdown>
                                                                    </template>

                                                                    <b-form-input style="padding:5px; height: 44px;" @keypress.enter="allProductsDataB" v-model="searchTextB">{{searchTextB}}</b-form-input>
                                                                   
                                                                    <div v-if="toggleAdvanceFilter" id="hide" class="col-md-12" style="border-top: 1px solid #e0e0e0; width: 100%">
                                                                        <product-advance-filter :currentFilter="currentFilter" :parentParams="filterParams" :massUpdateMode="massUpdateMode" @changeParams="changeParams" @closeFilter="closeFilter" :key="filterKey"> </product-advance-filter>
                                                                    </div>
                                                                
                                                                    <div class="filter-cont">
                                                                        <button
                                                                          class="btn btn-sm float-right mr-10"
                                                                          style="background-color: #394A5D; color: white;"
                                                                          @click.prevent="advanceFilter(true)">
                                                                          {{toggleLabel}}
                                                                        </button>&nbsp;&nbsp;
                                                                    
                                                                        <base-button
                                                                          v-if="!viewOnly"
                                                                          type="default"
                                                                          class="btn btn-sm float-right mr-10"
                                                                          style="background-color: #394A5D; color: white;"
                                                                          @click.prevent="addAll">
                                                                          Add All
                                                                        </base-button>
                                                                    
                                                                        <base-dropdown
                                                                          class="ellisis-cont nav-link pr-0 float-right"
                                                                          position="right">
                                                                          <div class="media align-items-center" slot="title">
                                                                            <i class="fa fa-ellipsis-v float-right ml-2 btn-sm"></i>
                                                                          </div>
                                                                          <template>
                                                                            <div class="dropdown-header noti-title">
                                                                              <h6 class="text-overflow m-0">PRODUCT LIST ACTIONS</h6>
                                                                            </div>
                                                                            <div
                                                                              v-if="canUploadProduct"
                                                                              class="dropdown-item"
                                                                              @click.prevent="toggleUploadProductsDrawer(true)">
                                                                              <i class="fa fa-upload"></i>
                                                                              <span>Import</span>
                                                                            </div>
                                                                            <div
                                                                              v-if="canExportProduct"
                                                                              class="dropdown-item"
                                                                              @click.prevent="exportProduct">
                                                                              <i class="fa fa-download"></i>
                                                                              <span>Export</span>
                                                                            </div>
                                                                          </template>
                                                                        </base-dropdown>
                                                                    </div>

                                                                    <!-- <b-form-input style="padding:5px; height: 44px;" @keypress.enter="allProductsDataB" v-model="searchTextB">{{searchTextB}}</b-form-input> -->
                                                                </b-input-group>
                                                            </div>
                                                        </div>

                                                        <div class="table-responsive">
                                                            <div id="product-table" style="display:none;"></div>
                                                            <VueTabulator id="product-table-orig" ref="tabulator" v-model="productData" :options="productOptions"/>              
                                                        </div>

                                                        <!-- <div v-if="changeDisplayB == true" class="table-responsive">
                                                            <div id="product-table" ></div>
                                                            <VueTabulator ref="tabulator" v-model="productData" :options="productOptions" style="display:none;" :key="refKey"/>
                                                        </div>

                                                        <div v-else class="table-responsive">
                                                            <div id="product-table" style="display:none;"></div>
                                                            <VueTabulator ref="tabulator" v-model="productData" :options="productOptions" :key="refKey"/>
                                                        </div> -->

                                                    </a-tab-pane>

                                                    <a-tab-pane :key="gBonusKey4" >
                                                        <span slot="tab">
                                                            <span class="numberCircle">4</span>
                                                            Set Promo
                                                        </span>

                                                        <fieldset :disabled="viewOnly" >
                                                            
                                                            <div class="row">
                                                                
                                                                <div class="col-md-4">
                                                                    <base-input label="Limit (Max Application)" >
                                                                            <a-input type="number" min="0" v-model="promo.promo_text" :disabled="viewOnly"/>
                                                                    </base-input>
                                                                </div>
                                                                
                                                                <div class="col-md-4">
                                                                    <base-input :label="discountLabel" >
                                                                            <a-input type="number" min="0" v-model="promo.promo_discount" :disabled="viewOnly"/>
                                                                    </base-input>
                                                                </div>
                                                                <div class="col-md-4">
                                                                    <base-input :label="groupRoundToNearestLabel" >
                                                                            <a-input type="number" min="0" v-model="promo.group_round_to_nearest" :disabled="viewOnly"/>
                                                                    </base-input>
                                                                </div>
                                                            </div>
                                                        </fieldset>

                                                        <div class="row no-gutters" v-if="parseInt(promo.reward_type) < 4">
                                                            <div class="col-md-12 mb-3">
                                                                <b-input-group>
                                                                    <template v-slot:prepend>
                                                                        <b-dropdown :text="filterCaption1" variant="outline-default">
                                                                            <b-dropdown-item @click.prevent="changeFilter1('name')">Name</b-dropdown-item>
                                                                            <b-dropdown-item @click.prevent="changeFilter1('product_id')">Product Code</b-dropdown-item>
                                                                            <b-dropdown-item @click.prevent="changeFilter1('barcode')">Barcode</b-dropdown-item>
                                                                            <b-dropdown-item @click.prevent="changeFilter1('reference_code')">Reference Code</b-dropdown-item>
                                                                            <b-dropdown-item @click.prevent="changeFilter1('stock_no')">Stock No</b-dropdown-item>
                                                                        </b-dropdown>
                                                                    </template>
                                                                    
                                                                    <b-form-input style="padding:5px; height: 44px;" @keypress.enter="searchItemListProduct" v-model="searchText1">{{searchText1}}</b-form-input>

                                                                    <div class="filter-cont">
                                                                        <base-button @click.prevent="DeleteAll" v-if="selectedRowCount > 0" class="btn btn-sm float-right mr-10"  size="sm">Delete All</base-button>
                                                                        &nbsp;&nbsp;
                                                                        <base-button v-if="selectedRowCount > 0"  type="default" class="btn float-right mr-0" size="sm" :disabled="viewOnly" @click.prevent="massAssign">Mass Assign</base-button>
                                                                    </div>
                                                                </b-input-group>
                                                            </div>
                                                        </div>

                                                        <div class="table-responsive" v-if="parseInt(promo.reward_type) < 4">
                                                          <div v-if="showAddedProductTabulator">
                                                            <fieldset :disabled="viewOnly">
                                                                
                                                                <VueTabulator 
                                                                ref="addedProductTabulator"
                                                                :key="refKey" 
                                                                v-model="selectedProductData"
                                                                :options="selectedProductOptions"
                                                                :integration="{ updateStrategy: 'UPDATE' }"
                                                                @cell-click="isUpdatePromoRewardAndCondition = true"
                                                                />

                                                            </fieldset>
                                                          </div>
                                                        </div>

                                                    </a-tab-pane>
                                                </a-tabs>
                                            </div>
                                        </div>
                                        <!-- END - GROUP BONUS DISCOUNT -->
                                         
                                    </div>
                                </div>

                            </div>

                            <div v-if="current == 2" class="card-body">
                                <fieldset :disabled="viewOnly">
                                    <h2 class="card-title">Select Customers</h2>
                                    <div class="row ml-3">
                                        <div class="col-md-12">
                                            <base-radio name="$ALL$" v-model="customer_type">
                                                All Customers (Members and Non-Members)
                                                <br><small>Default Section</small>
                                            </base-radio>
                                            <br>
                                            <base-radio name="$MEMBERSONLY$" v-model="customer_type">
                                                Members Only
                                            </base-radio>
                                            <br>
                                            <base-radio name="$NONMEMBERSONLY$" v-model="customer_type">
                                                Non-Members Only
                                            </base-radio>
                                            <br>
                                            <base-radio name="S" v-model="customer_type">
                                                Members of Specific Card Types Only
                                            </base-radio>
                                            <a-select v-if="customer_type == 'S'" mode="multiple" v-model="customer_card_type_ids" showSearch placeholder="All Customer Card Types" optionFilterProp="children" class="mt-3 ml-3" style="width: 100%" :filterOption="filterOption">
                                                <a-select-option v-for="option in customerCardTypeOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                            </a-select>
                                           
                                            <hr>
                                            <!-- <base-radio name="$CLPMEMBERLEVEL$" v-model="customer_type">
                                                CLP Membership Level
                                            </base-radio>
                                            <a-select v-if="customer_type == '$CLPMEMBERLEVEL$'" mode="multiple" v-model="clp_level_ids" showSearch placeholder="All CLP Member Levels" optionFilterProp="children" class="mt-3 ml-3" style="width: 100%" :filterOption="filterOption">
                                                <a-select-option v-for="option in clpLevelOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                            </a-select>
                                            <br><br>
                                            <base-radio name="$CLPMEMBERTAG$" v-model="customer_type">
                                                CLP Member Tags
                                            </base-radio>
                                            <a-select v-if="customer_type == '$CLPMEMBERTAG$'" mode="multiple" v-model="clp_tag_ids" showSearch placeholder="All CLP Membership Tags" optionFilterProp="children" class="mt-3 ml-3" style="width: 100%" :filterOption="filterOption">
                                                <a-select-option v-for="option in clpTagOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                            </a-select> -->

                                            <base-input v-if="customer_type !== '$NONMEMBERSONLY$'" style = "display: none" :key="customer_type" label="CLP Membership Level">
                                                <a-select  mode="multiple" v-model="clp_level_ids" showSearch placeholder="All CLP Member Levels" optionFilterProp="children" class="mt-3 ml-3" style="width: 100%" :filterOption="filterOption">
                                                <a-select-option v-for="option in clpLevelOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                            </a-select>
                                            </base-input>
                                            <base-input v-if="customer_type !== '$NONMEMBERSONLY$'" style = "display: none" :key="customer_type" label="CLP Member Tags">
                                                <a-select mode="multiple" v-model="clp_tag_ids" showSearch placeholder="All CLP Membership Tags" optionFilterProp="children" class="mt-3 ml-3" style="width: 100%" :filterOption="filterOption">
                                                    <a-select-option v-for="option in clpTagOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                                </a-select>
                                            </base-input>
                                        </div>
                                    </div>
                                </fieldset>
                            </div>

                            <div v-if="current == 3" class="card-body">
                                <fieldset :disabled="viewOnly">
                                    <h2 class="card-title">Select Payment Types</h2>

                        
                                    <div v-if="promo.promo_type == '2'" class="row ml-3">
                                        <div class="col-md-12">

                                            <base-input alternative="" label="Select Payment Type">
                                                <a-select :disabled="viewOnly" v-model="promo.payment_type_code" showSearch placeholder="Select Payment Type" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                                    <a-select-option v-for="option in paymentTypeOptions" :key="option.code" :value="option.code">{{option.name}}</a-select-option>
                                                </a-select>
                                            </base-input>
                                        </div>
                                    </div>


                                    <div v-else class="row ml-3">
                                        <div class="col-md-12">
                                            <base-input alternative="" label="Select Payment Type">
                                                <a-select disabled v-model="payment_type_code" showSearch placeholder="All Payment Types" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                                    <a-select-option key="ALL" value="ALL">All Payment Types</a-select-option>
                                                    <a-select-option v-for="option in paymentTypeOptions" :key="option.code" :value="option.code">{{option.name}}</a-select-option>
                                                </a-select>
                                            </base-input>
                                        </div>
                                    </div>
                                </fieldset>
                            </div>

                            <div v-if="current == 4" class="card-body">
                                <h2 class="card-title">Select Sites</h2>
                                <div class="row ml-3">
                                    <div class="col-md-12">
                                        <base-radio name="A" v-model="site_selection">
                                            All Sites (default)
                                        </base-radio>
                                        <br>
                                        <base-radio name="S" v-model="site_selection">
                                            Specific Site
                                        </base-radio>
                                        <!-- <a-select v-if="site_selection == 'S'" mode="multiple" v-model="site_ids" showSearch placeholder="All Sites" optionFilterProp="children" class="mt-3 ml-3" style="width: 100%" :filterOption="filterOption">
                                            <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                        </a-select> -->
                                        <!-- site products location tagging -->
                                        <div v-if="site_selection == 'S'">
                                            <br/>
                                            <div class="col-md-8">
                                                <!--
                                                        * selected row keys accepts parents key
                                                        * parent_key change to location name which is string .
                                                        * filter selected row keys to remove string which is the parent key on create and update method
                                                        -->
                                                <div class="col">
                                                    <a-input-search
                                                        placeholder="Search Sites"
                                                        v-model="searchQuery"
                                                        @input="filterSites"
                                                        :allowClear="true"
                                                        style="width: 100%; margin-bottom: 10px;"
                                                    />
                                                </div>
                                                <div class="col mb-3">
                                                    <h6 class="heading-small text-muted">Enter Site Reference Codes</h6>
                                                    <a-input v-model="siteCodesInput" placeholder="Enter site reference codes separated by commas" style="width: 100%;" />
                                                    <p class="text-muted" style="font-size: 14px; margin-top: 5px;">Note: Enter site reference codes separated by commas. Example: BIRKFSAABZ,AETRKIAATC</p>
                                                    <a-button @click="processSiteCodesInput" type="default">Tag Sites</a-button>
                                                    <a-button @click="clearSiteCodes" type="danger" style="margin-left: 10px;">Clear</a-button>
                                                    <a-button @click="showSelectedSites" type="primary" style="margin-left: 10px;">View Selected Sites</a-button>
                                                </div>
                                                <a-tree ref="tree"
                                                    checkable
                                                    :defaultCheckedKeys="selectedRowKeys"
                                                    :checkedKeys="selectedRowKeys"
                                                    :treeData="filteredLocationData"
                                                    :disabled="viewOnly"
                                                    @check="onCheckSiteId"
                                                />
                                                <div v-if="this.filteredLocationData.length === 0" class="col text-muted" style="font-size: 14px; padding-top: 30px;">
                                                    No results found for the given search query.
                                                </div>
                                                <a-modal
                                                    v-model:visible="isModalVisible"
                                                    title="Selected Sites"
                                                    @ok="handleOk_"
                                                    @cancel="handleCancel"
                                                >
                                                    <ul>
                                                        <li v-for="site in selectedSites" :key="site.key">{{ site.title }}</li>
                                                    </ul>
                                                </a-modal>
                                            </div>
                                        </div>
                                        <!-- end site products location tagging -->
                                    </div>
                                </div>
                            </div>
                        <!-- </form> -->
                    </div>
                </div>
            </div>
        </a-spin>

        <a-drawer title="ADD EXCEPTION" :width="480" placement="right" :closable="false" :visible="typeVisible" @close="onClose">
            <base-input label="Select Exception" >
                <select class="form-control" size="large" v-model="exceptionText">
                    <option v-for="option in exceptionOptions" v-bind:value="option.key" v-bind:key="option.key">
                        {{ option.value }}
                    </option>
                </select>
            </base-input>

             <div v-if="exceptionText == 'SP'">
                <base-input label="Select Supplier"><br>
                    <a-select v-model="exceptSupplier" showSearch placeholder="Select Supplier" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :notFoundContent="fetching ? undefined : null" @search="searchSupplier">
                    <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                    <a-select-option v-for="option in supplierOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                    </a-select>
                </base-input>
            </div>

            <div v-else-if="exceptionText == 'BR'">
                <base-input label="Select Brand"><br>
                    <a-select v-model="exceptBrand" showSearch placeholder="Select Brand" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :notFoundContent="fetching ? undefined : null" @search="searchBrand"  mode="multiple">
                    <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                    <a-select-option v-for="option in brandOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                    </a-select>
                </base-input>
            </div>

            <div v-else>
                <base-input label="Select Category"><br>
                    <a-cascader v-model="exceptCategory" :options="categoriesOptions" :showSearch="{filter}"
                    placeholder="All Categories" style="width: 100%" changeOnSelect />
                </base-input>
            </div>
            <div :style="{ position: 'absolute', right: 0, bottom: 0, width: '100%', borderTop: '1px solid #e9e9e9', padding: '10px 16px', background: '#fff', textAlign: 'right', zIndex: 1}">
                <a-button type="primary" @click="addException">
                    APPLY
                </a-button>
            </div>
        </a-drawer>

        <PromoExceptions
            :key="promoExceptionKey"
            :promotionId="profileId"
            :visible="openPromoExceptionsDrawer"
            :promoType="promo.promo_type"
            :rewardType="promo.reward_type"
            :includeItem="include_item"
            :filterOption="filterOption"
            :supplierOptions="supplierOptions"
            :brandOptions="brandOptions"
            :categoriesOptions="categoriesOptions"
            :promoExceptions="promoExceptions"
            :onClose="togglePromoExceptionsDrawer"
            @updateExceptions="updateExceptions"
        />

        <UploadProducts
            ref="uploadProductKey"
            :promotionId="profileId"
            :selectedProducts="selectedProductData"
            :visible="openUploadProductsDrawer"
            :onClose="toggleUploadProductsDrawer"
            :addProducts="addMassProducts"
            :promoType="promo.promo_type"
            :rewardType="promo.reward_type"
            :includeItem="include_item"
            :coupleType="coupleType"/>

        <div :style="{ position: 'absolute', right: 0, bottom: 0, width: '100%', borderTop: '1px solid #e9e9e9', padding: '10px 16px', background: '#fff', textAlign: 'right', zIndex: 1}">
            <a-button v-if="current == 0" type="default" @click="cancel">CANCEL</a-button>
            <a-button v-if="current > 0" type="default" @click="backPage(current)">BACK</a-button>
            <a-button v-if="current < 4" class="ml-3" type="primary" :disabled="spinning" @click="nextPage(current)">NEXT</a-button>
            <a-button v-if="current == 4 && !viewOnly" class="ml-3" type="primary" :disabled="spinning" :loading="doneLoading" @click.prevent="done">DONE</a-button>
            <a-button v-if="current == 4 && viewOnly" class="ml-3" type="primary" @click.prevent="close">CLOSE</a-button>
        </div>

        <vue-json-to-csv
          :labels="csvHeaders"
          :json-data="exportData"
          @success="clearExportJsonData"
          :csv-title="`${exportFileName}.csv`">
          <span ref="exportCsvBtn"></span>
        </vue-json-to-csv>
        <download-excel :data="JsonData" name="promoExport" type="xlsx">
            <span ref="exportExcelBtn"> </span>
        </download-excel>
    </div>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import ValidateField from '../../components/validateFormUtils.js'
    import secureStorage from '../../controllers/secureStorage';
    import Autocomplete from 'vuejs-auto-complete'
    import ProductAdvanceFilter from '../Products/ProductAdvanceFilter.vue'
    import { mapState, mapActions } from 'vuex'
    import moment from 'moment';
    import Tabulator from 'tabulator-tables';
    import UploadProducts from './Drawers/UploadProductsV2.vue';
    import PromoExceptions from './Drawers/PromoExceptions.vue';
    import VueJsonToCsv from 'vue-json-to-csv';
    import { exportProductCSV } from './Utilities/promotionExport';
    import { uploadToS3, uploadToS3BackgroundProcess,objectToFormData } from '../../utilities';
    import axios from 'axios';
    // import { uploadToS3, objectToFormData } from '../../utilities';

    
    var component_x;
    const productLocationData = [];
    export default {
        computed: {
            ...mapState(['endPoint', 'profileId', 'serverType',
                         'categoriesOptions', 'awsEndPoint']),
        },
        components: {
          Autocomplete,
          ProductAdvanceFilter,
          UploadProducts,
          VueJsonToCsv,
          PromoExceptions
        },
        mounted: async function () {
            // initialize filteredLocationData with productLocationData
            this.filteredLocationData = this.productLocationData;

            if(this.serverType == 'branch' || this.$attrs.viewMode == true){
                this.viewOnly = true
            }

            this.canUploadProduct = this.showUploadCSVButton();
            this.canExportProduct = this.showExportProductButton();

            if(this.$attrs.promoType == '1'){
                this.selectedProductOptions.columns[4].title = "PERCENT DISCOUNT"
                this.reward_type_description = "Apply an discount to an item by percentage (e.g 10%)"
            } else if(this.$attrs.promoType == '2'){
                this.selectedProductOptions.columns[4].title = "PERCENT DISCOUNT"
                this.reward_type_description = "Apply multi-level discount without conditions"
            } else if(this.$attrs.promoType == '3'){
                this.reward_type_description = "Buy quantity of item X to receive a specified quantity of the same item (e.g Buy 2 of T-Shirt, Get 1 Free)"
            } else if(this.$attrs.promoType == '4'){
                this.reward_type_description = "For quantity exceeding X, discount X"
            } else if(this.$attrs.promoType == '5'){
                this.reward_type_description = "Coupon will be printed if the customer purchases a minimum or specific quantity of items listed (e.g. Buy 2 Shirts, Get 200 Reward Points)"
            } else if(this.$attrs.promoType == '6'){
                this.reward_type_description = "Buy all item on list get item X (e.g Buy all item on the list, Get Discounted or Free Umbrella)"
            } else if(this.$attrs.promoType == '7'){
                this.reward_type_description = "Group Discount - Less Percent"
                this.selectedProductOptions.columns[1].width = "40%"
                this.selectedProductOptions.columns[2].width = "30%"
                this.selectedProductOptions.columns[5].visible = false
                this.selectedProductOptions.columns[4].visible = false

            }

            this.productOptions.ajaxURL = this.endPoint + 'products?all=0'
            this.productOptions.ajaxConfig = {
                method:"GET",
                headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") },
            }

            this.productOptionsB2.ajaxURL = this.endPoint + 'products?all=0'
            this.productOptionsB2.ajaxConfig = {
                method:"GET",
                headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") },
            }

            this.levelData = []
            this.levelDataFilter = []
            this.levelCount = 1;
            this.levelGDData = []
            this.levelGDDataFilter = []
            this.levelGDCount = 1;

            component_x = this

            let payment_types = await HTTPRequest.getRequest(component_x.endPoint + "payment_types/get_valid_payment_types?pos_payments=1", null);
            component_x.paymentTypeOptions = payment_types;
            component_x.paymentTypeOptions.push({"id": 0, "code": "ALL", "name": "ALL"})
            component_x.sort(component_x.paymentTypeOptions);
            if(component_x.profileId == 0){
                let siteId = secureStorage.getItem("defaultSiteId");
                component_x.selectedRowKeys.push(siteId);
                component_x.getLocationTreeData();
            }
            // component_x.getLocationTreeData();


            if (component_x.profileId > 0){
                this.spinning = true
                var promo_data = await HTTPRequest.getRequest(component_x.endPoint + 'promos/' + component_x.profileId, null)

                component_x.getLocationTreeData();
                component_x.productLocationData =[];
                component_x.productLocationData.children = [];
                // component_x.selectedRowKeys = [];

                if(promo_data == undefined){
                    component_x.$router.go()
                } else {
                    if(promo_data["error"] == undefined){
                        Object.assign(component_x.promo, promo_data)
                        if (promo_data.promo_type == null){
                            component_x.promo.promo_type = "1"
                        }

                        component_x.promo.reward_type = promo_data.reward_type.split('|')[1]

                        if (promo_data.reward_type == null){
                            component_x.promo.reward_type = "1"
                        }

                        component_x.getYData = []
                        // console.log(promo_data)
                        component_x.getYData = [];
                        component_x.promo.start_at = moment(promo_data.start_at)
                        component_x.promo.end_at = moment(promo_data.end_at)

                        //CLP Include 3P & Mark Down Items
                        component_x.include_3p_items = /\binclude_3p_items\b/.test(this.promo.promo_text || '')
                        component_x.include_mark_down_items = /\binclude_mark_down_items\b/.test(this.promo.promo_text || '')


                        console.log("INCLUDE ITEM CHECKER")
                        console.log(promo_data.promo_lines)
                        if (promo_data.promo_lines != undefined && promo_data.promo_lines.length > 0 && promo_data.promo_lines[0].include_field != undefined){
                            if(promo_data.promo_lines[0].include_field == "all"){
                                console.log("Should be here... include item is all items")
                                component_x.include_item = "1"
                            }
                            
                            else if( promo_data.promo_lines[0].include_field.includes("ex_")){
                                console.log("Should be here... include item is all items except")
                                component_x.include_item = "5"
                            }

                            else if(promo_data.promo_lines[0].include_field == ("supplierId")){
                                console.log("Should be here... include item all supplierId")
                                component_x.include_item = "2"
                            }

                            else if(promo_data.promo_lines[0].include_field == ("brandId")){
                                console.log("Should be here... include item is all brandId")
                                component_x.include_item = "3"
                            }

                            else{
                                component_x.include_item = component_x.promo.include_item || "6"
                            }
                        }else{
                            component_x.include_item = component_x.promo.include_item || "6"
                        }
                        
                        
                        // check if DAYS
                        let days_array = (promo_data.valid_day != null) ? promo_data.valid_day.split("") : []
                        if(days_array.length > 0){
                            component_x.is_specify_date = true
                            component_x.showAdvancedInfo = true
                            component_x.valid_days = { sun: false, mon: false, tue: false,
                                wed: false, thu: false, fri: false, sat: false}

                            for (let index = 0; index < days_array.length; index++) {
                                const element = days_array[index];
                                switch(parseInt(element)) {
                                case 1:
                                    Object.assign(component_x.valid_days, {sun: true})
                                    break;
                                case 2:
                                    Object.assign(component_x.valid_days, {mon: true})
                                    break;
                                case 3:
                                    Object.assign(component_x.valid_days, {tue: true})
                                    break;
                                case 4:
                                    Object.assign(component_x.valid_days, {wed: true})
                                    break;
                                case 5:
                                    Object.assign(component_x.valid_days, {thu: true})
                                    break;
                                case 6:
                                    Object.assign(component_x.valid_days, {fri: true})
                                    break;
                                case 7:
                                    Object.assign(component_x.valid_days, {sat: true})
                                    break;
                                }
                            }
                        }
                        delete component_x.promo.valid_days

                        component_x.replaceDiscount(component_x.promo.reward_type)

                        if(promo_data.valid_start_time != null && promo_data.valid_end_time != null){
                            component_x.is_specify_time = true
                            component_x.showAdvancedInfo = true
                            component_x.picker_date = {
                                valid_start_time: moment(promo_data.valid_start_time, 'HH:mm'),
                                valid_end_time: moment(promo_data.valid_end_time, 'HH:mm')
                            }
                        }
                        delete component_x.promo.valid_times

                        let level_assign = false
                        let coupon_assign = false
                        

                        let expected_value = [];

                        console.log("ITEM CHECKER")
                        console.log(component_x.include_item)

                        //Brand & Categ
                        if(component_x.include_item == '3' || component_x.include_item == '7'){
                            // Pushing the include_value from the promo_lines array to expected_value array
                            promo_data.promo_lines.forEach(promoLine => {
                                expected_value.push(parseInt(promoLine.include_value));
                            });
                            // this.brandOptions.filter(x => expected_value.includes(x.id)).map(x => x.name)
                            // console.log(expected_value,this.brandOptions)
                            component_x.allItem.brand_id = expected_value
                        // }else if(component_x.include_item == '4'){
                        //     // inputCategory
                        //     promo_data.promo_lines.forEach(promoLine => {
                        //         expected_value.push(parseInt(promoLine.include_value));
                        //     });

                        //     component_x.inputCategory = expected_value
                        }
                        
                        // Supplier
                        else if(component_x.include_item == '2'){
                            // Pushing the include_value from the promo_lines array to expected_value array
                            promo_data.promo_lines.forEach(promoLine => {
                                expected_value.push(parseInt(promoLine.include_value));
                            });

                            component_x.allItem.supplier_id = expected_value
                        }
                        
                        // Except
                        else if(component_x.include_item == '5'){
                            console.log("Processing exceptions...")
                            let promo_lines_saved = promo_data.promo_lines
                            for(var y = 0; y < promo_lines_saved.length; y++){
                                let promo_line_saved = promo_lines_saved[y]
                                let exception_item = {}
                                switch(promo_line_saved.include_field){
                                    case "ex_supplierId":
                                        exception_item = {
                                            "exception_type_display": "Supplier",
                                            "exception_type": promo_line_saved.include_field,
                                            "exception_value": parseInt(promo_line_saved.include_value),
                                            "exception_value_display": ""
                                        }  
                                    break;
                                    case "ex_brandId":
                                         exception_item = {
                                                "exception_type_display": "Brand",
                                                "exception_type": promo_line_saved.include_field,
                                                "exception_value": parseInt(promo_line_saved.include_value),
                                                "exception_value_display": ""
                                            }
                                    break;
                                    case "ex_divisionId":
                                         exception_item = {
                                                "exception_type_display": "Division",
                                                "exception_type": promo_line_saved.include_field,
                                                "exception_value": promo_line_saved.include_value,
                                                "exception_value_display": JSON.parse(promo_line_saved.integration_settings)
                                            }
                                    break;
                                    case "ex_departmentId":
                                         exception_item = {
                                                "exception_type_display": "Department",
                                                "exception_type": promo_line_saved.include_field,
                                                "exception_value": promo_line_saved.include_value,
                                                "exception_value_display":  JSON.parse(promo_line_saved.integration_settings)
                                            }
                                    break;
                                    case "ex_sectionId":
                                         exception_item = {
                                                "exception_type_display": "Section",
                                                "exception_type": promo_line_saved.include_field,
                                                "exception_value": promo_line_saved.include_value,
                                                "exception_value_display":  JSON.parse(promo_line_saved.integration_settings)
                                            }
                                    break;
                                    case "ex_categoryId":
                                         exception_item = {
                                                "exception_type_display": "Category",
                                                "exception_type": promo_line_saved.include_field,
                                                "exception_value": promo_line_saved.include_value,
                                                "exception_value_display": JSON.parse(promo_line_saved.integration_settings)
                                            }
                                    break;
                                }
                                console.log("Pushing to exceptions..")
                                console.log(exception_item)
                                component_x.promoExceptions.push(exception_item)
                            }
                        }
                        
                        delete component_x.promo.reward_items

                        //Populate Items
                        if(promo_data.promo_lines.length > 0){
                            
                            // Item and Pool Discounts
                            if(['1', '2'].includes(promo_data.promo_type) ){
                                console.log("Populating Items for Item and Pool Discounts...")

                                component_x.selectedProductData = []
                                component_x.selectedProd = []

                                // Additional Processing for PWP
                                if(promo_data.promo_type == '2'){
                                    console.log("Getting Promo text Values for PWP")
                                    let header_promo_text = promo_data.promo_text.split(";")
                                    component_x.promo.compute_mode = header_promo_text[2]
                                    component_x.promo.payment_type_code = header_promo_text[1]
                                    component_x.promo.apply_level = header_promo_text[0]
                                }
                                if (promo_data.promo_lines !=undefined && promo_data.promo_lines[0].include_field !=undefined){

                                    // BY SUPPLIER
                                    if(promo_data.promo_lines[0].include_field == "supplierId"){
                                        component_x.include_item = "2"
                                        
                                        let p_line = promo_data.promo_lines[0]
                                        // Process Promo text
                                        let promo_value = ((p_line.promo_text.split(':')[2]).split(';')[0]).match(/(\d+)/)[0]
                                        component_x.discount = promo_value

                                        component_x.max_application_all = p_line.promo_text.split('@')[1].replace(")", "")
                                        component_x.allItem.supplier_id = parseInt(p_line.include_value)
                                    }
                                    // EXCEPT 
                                    if(promo_data.promo_lines[0].include_field.includes("ex_")){
                                        component_x.include_item = "5"
                                        
                                        let p_line = promo_data.promo_lines[0]
                                        // Process Promo text
                                        let promo_value = ((p_line.promo_text.split(':')[2]).split(';')[0]).match(/(\d+)/)[0]
                                        component_x.discount = promo_value
                                        component_x.max_application_all = p_line.promo_text.split('@')[1].replace(")", "")
                                    }

                                    // BY BRAND
                                    else if(promo_data.promo_lines[0].include_field == "brandId"){
                                        console.log("BRAND")
                                        component_x.include_item = "3"

                                        this.searchBrand()
                                    
                                        let p_line = promo_data.promo_lines[0]
                                        // Process Promo text
                                        let promo_value = ((p_line.promo_text.split(':')[2]).split(';')[0]).match(/(\d+)/)[0]
                                        component_x.discount = promo_value
                                        component_x.max_application_all = p_line.promo_text.split('@')[1].replace(")", "")

                                        // promo_data.promo_lines.map(p_line => {
                                        //     component_x.allItem.brand_id.push( parseInt(p_line.include_value)  )
                                        // })

                                        // console.log(component_x.allItem.brand_id)
                                        // component_x.allItem.brand_id = parseInt(p_line.include_value)
                                    }

                                    // BY CATEGORY
                                    else if(["divisionId", "departmentId", "sectionId", "categoryId"].includes(promo_data.promo_lines[0].include_field)){
                                        console.log(">>> Process Categories")
                                        
                                        component_x.include_item = "4"

                                        console.log("Categories")
                                        console.log(this.categoriesOptions)

                                        if(component_x.categoriesOptions.length == 0){
                                        //   let options = await HTTPRequest.getRequest(this.endPoint + 'categories/cascader_view_2', null);
                                            let options = await HTTPRequest.getRequest(this.endPoint + 'categories/cascader_view', null);
                                            this.updateCategoriesOptions(options)
                                        }

                                        let p_line = promo_data.promo_lines[0]
                                        // Process Promo text
                                        let promo_value = ((p_line.promo_text.split(':')[2]).split(';')[0]).match(/(\d+)/)[0]
                                        component_x.discount = promo_value

                                        // (1:E1:5%;@2) 
                                        component_x.max_application_all = p_line.promo_text.split('@')[1].replace(")", "")
                                        component_x.inputCategory = JSON.parse(p_line.integration_settings)//.split(",").map(x => parseInt(x))


                                        // component_x.inputCategoryKey++;
                                        // console.log(">>> INPUT CATEGORY CHECK")
                                        // console.log(p_line.include_field_ex)
                                        // console.log(component_x.inputCategory)
                                    }
                                    else{
                                                                        
                                        // component_x.include_item = "6"
                                        //Loop products
                                        component_x.levelData = []
                                        promo_data.promo_lines.map(product => {

                                            

                                            component_x.selectedProd.push(product.product_id)

                                            let promo_value = ''
                                            let product_required_value = ''
                                            let round_to_nearest = 1

                                            //PERCENT, AMOUNt & CHANGE PRICE
                                            if(['1','2','3'].includes(component_x.promo.reward_type)){
                                                promo_value = ((product.promo_text.split(':')[2]).split(';')[0]).match(/(\d+)/)[0]
                                                if(product.promo_text.includes('^')){
                                                    round_to_nearest = ((product.promo_text.split(':')[2]).split(';')[0]).split('^')[1]
                                                }
                                                //round_to_nearest = ((product.promo_text.split(':')[2]).split(';')[0]).split('^')[1]
                                                if(product.include_field == "all"){
                                                    component_x.include_item = "1"
                                                    component_x.discount = promo_value
                                                    component_x.max_application_all = product.promo_text.split('@')[1].replace(")", "")
                                                    component_x.round_to_nearest = round_to_nearest
                                                    // (1:E1:10%;@2)
                                                }
                                            }
                                                
                                            
                                            // RELATIVE PRICING
                                            else if(component_x.promo.reward_type == 4) {
                                                // product_required_value = 'Relative Pricing'
                                                // (1:E1:R5|150,10|100;@1000)

                                                console.log(">> original product_required_value")
                                                console.log(product.promo_text)

                                                promo_value = product.promo_text.split(':')[2].split(';')[0].split(',')
                                                if(product.promo_text.includes('^')){
                                                    round_to_nearest = ((product.promo_text.split(':')[2]).split(';')[0]).split('^')[1]
                                                }
                                                //round_to_nearest = ((product.promo_text.split(':')[2]).split(';')[0]).split('^')[1]
                                                console.log(">> promo_value")
                                                console.log(promo_value)
                                                // [ R5|150, 10|100 ]
                                                let prev_key = 0
                                                if(component_x.levelData.length > 0){
                                                    prev_key = parseInt(component_x.levelData[component_x.levelData.length - 1].key)
                                                }
                                                console.log("PREV KEY :: " + prev_key)
                                                for(var x = 0; x < promo_value.length; x++){
                                                    if(promo_value[x] != ''){
                                                        let levelValue = promo_value[x].split("|")
                                                        component_x.levelData.push({
                                                            key: prev_key + (x + 1),
                                                            product_id: product.product_id,
                                                            qty: levelValue[0].replace('R', ''),
                                                            price: levelValue[1],
                                                            editable: true
                                                        })
                                                    }

                                                }

                                                console.log(">> Populated Level Data")
                                                console.log(this.levelData)

                                            }

                                            // BUNDLE PRICING
                                            else if(component_x.promo.reward_type == 5){
                                                console.log("Should process bundle pricing....")

                                                //(1:S3:590,5:985,10:1895@1000) 

                                                promo_value = product.promo_text.split('@')[0].split(',')
                                                console.log(">> promo_value")
                                                console.log(promo_value)

                                                // [ R5|150, 10|100 ]
                                                let prev_key = 0
                                                if(component_x.levelData.length > 0){
                                                    prev_key = parseInt(component_x.levelData[component_x.levelData.length - 1].key)
                                                }
                                                console.log("PREV KEY :: " + prev_key)
                                                for(var x = 0; x < promo_value.length; x++){
                                                    if(promo_value[x] != ''){
                                                        let levelValue = promo_value[x].replace('(1:S', '').split(":")
                                                        // (1:S3:590,5:985,10:1895@1000)
                                                        component_x.levelData.push({
                                                            key: prev_key + (x + 1),
                                                            product_id: product.product_id,
                                                            qty: levelValue[0],
                                                            price: levelValue[1],
                                                            editable: true
                                                        })
                                                    }

                                                }

                                                console.log(">> Populated Level Data")
                                                console.log(this.levelData)
                                            } 

                                            // BXTX
                                            else if(component_x.promo.reward_type == 6){
                                                // product_required_value = 'Buy X Take x'
                                                //(1:D1:B2,1;@2)
                                                let promo_parse = product.promo_text.split(':')
                                                product_required_value = promo_parse[2].split(',')[0].replace('B','')
                                                promo_value = promo_parse[2].split(',')[1].split(';')[0]
                                                if(product.promo_text.includes('^')){
                                                    round_to_nearest = ((product.promo_text.split(':')[2]).split(';')[0]).split('^')[1]
                                                }
                                                //round_to_nearest = ((product.promo_text.split(':')[2]).split(';')[0]).split('^')[1]
                                            }

                                            if(product.include_field != "all"){
                                                var product_desc = product.description.split("||")
                                                component_x.selectedProductData.push({
                                                    product_id: product.product_id,
                                                    required_value: product_required_value,
                                                    promo_value: promo_value,
                                                    name: product_desc[1],
                                                    retail_price: product.original_price,
                                                    barcode: product.product.barcode,
                                                    stock_no: product.stock_no,
                                                    round_to_nearest: round_to_nearest,
                                                    max_application: product.quantity
                                                })
                                            }
                                        })

                                    }
                                } 
                                else{

                                   
                                    // component_x.include_item = "6"
                                    //Loop products
                                    component_x.levelData = []
                                    promo_data.promo_lines.map(product => {

                                        

                                        component_x.selectedProd.push(product.product_id)

                                        let promo_value = ''
                                        let product_required_value = ''
                                        let round_to_nearest = 1

                                        //PERCENT, AMOUNt & CHANGE PRICE
                                        if(['1','2','3'].includes(component_x.promo.reward_type)){
                                            promo_value = ((product.promo_text.split(':')[2]).split(';')[0]).match(/(\d+)/)[0]
                                            if(product.promo_text.includes('^')){
                                                round_to_nearest = ((product.promo_text.split(':')[2]).split(';')[0]).split('^')[1]
                                            }
                                            //round_to_nearest = ((product.promo_text.split(':')[2]).split(';')[0]).split('^')[1]
                                            if(product.include_field == "all"){
                                                component_x.include_item = "1"
                                                component_x.discount = promo_value
                                                component_x.max_application_all = product.promo_text.split('@')[1].replace(")", "")
                                                component_x.round_to_nearest = round_to_nearest
                                                // (1:E1:10%;@2)
                                            }
                                        }
                                            
                                        
                                        // RELATIVE PRICING
                                        else if(component_x.promo.reward_type == 4) {
                                            // product_required_value = 'Relative Pricing'
                                            // (1:E1:R5|150,10|100;@1000)

                                            console.log(">> original product_required_value")
                                            console.log(product.promo_text)

                                            promo_value = product.promo_text.split(':')[2].split(';')[0].split(',')
                                            if(product.promo_text.includes('^')){
                                                round_to_nearest = ((product.promo_text.split(':')[2]).split(';')[0]).split('^')[1]
                                            }
                                            //round_to_nearest = ((product.promo_text.split(':')[2]).split(';')[0]).split('^')[1]
                                            console.log(">> promo_value")
                                            console.log(promo_value)
                                            // [ R5|150, 10|100 ]
                                            let prev_key = 0
                                            if(component_x.levelData.length > 0){
                                                prev_key = parseInt(component_x.levelData[component_x.levelData.length - 1].key)
                                            }
                                            console.log("PREV KEY :: " + prev_key)
                                            for(var x = 0; x < promo_value.length; x++){
                                                if(promo_value[x] != ''){
                                                    let levelValue = promo_value[x].split("|")
                                                    component_x.levelData.push({
                                                        key: prev_key + (x + 1),
                                                        product_id: product.product_id,
                                                        qty: levelValue[0].replace('R', ''),
                                                        price: levelValue[1],
                                                        editable: true
                                                    })
                                                }

                                            }

                                            console.log(">> Populated Level Data")
                                            console.log(this.levelData)

                                        }

                                        // BUNDLE PRICING
                                        else if(component_x.promo.reward_type == 5){
                                            console.log("Should process bundle pricing....")

                                            //(1:S3:590,5:985,10:1895@1000) 

                                            promo_value = product.promo_text.split('@')[0].split(',')
                                            console.log(">> promo_value")
                                            console.log(promo_value)

                                            // [ R5|150, 10|100 ]
                                            let prev_key = 0
                                            if(component_x.levelData.length > 0){
                                                prev_key = parseInt(component_x.levelData[component_x.levelData.length - 1].key)
                                            }
                                            console.log("PREV KEY :: " + prev_key)
                                            for(var x = 0; x < promo_value.length; x++){
                                                if(promo_value[x] != ''){
                                                    let levelValue = promo_value[x].replace('(1:S', '').split(":")
                                                    // (1:S3:590,5:985,10:1895@1000)
                                                    component_x.levelData.push({
                                                        key: prev_key + (x + 1),
                                                        product_id: product.product_id,
                                                        qty: levelValue[0],
                                                        price: levelValue[1],
                                                        editable: true
                                                    })
                                                }

                                            }

                                            console.log(">> Populated Level Data")
                                            console.log(this.levelData)
                                        } 

                                        // BXTX
                                        else if(component_x.promo.reward_type == 6){
                                            // product_required_value = 'Buy X Take x'
                                            //(1:D1:B2,1;@2)
                                            let promo_parse = product.promo_text.split(':')
                                            product_required_value = promo_parse[2].split(',')[0].replace('B','')
                                            promo_value = promo_parse[2].split(',')[1].split(';')[0]
                                            if(product.promo_text.includes('^')){
                                                round_to_nearest = ((product.promo_text.split(':')[2]).split(';')[0]).split('^')[1]
                                            }
                                            //round_to_nearest = ((product.promo_text.split(':')[2]).split(';')[0]).split('^')[1]
                                        }

                                        if(product.include_field != "all"){
                                            var product_desc = product.description.split("||")
                                            component_x.selectedProductData.push({
                                                product_id: product.product_id,
                                                required_value: product_required_value,
                                                promo_value: promo_value,
                                                name: product_desc[1],
                                                retail_price: product.original_price,
                                                barcode: product.product.barcode,
                                                stock_no: product.stock_no,
                                                round_to_nearest: round_to_nearest,
                                                max_application: product.quantity
                                            })
                                        }
                                    })

                                }
                              
                            } 

                            // Group Bonus
                            else if(['7'].includes(promo_data.promo_type) ){
                                
                                component_x.promo.promo_text = promo_data.promo_text.replace("@", "")

                                component_x.selectedProd = []
                                component_x.selectedProdB = []

                                promo_data.promo_lines.map(p_line => {

                                    // console.log("Processling line")
                                    // console.log(p_line)
                                    if(p_line.promo_type == "P"){
                                        if(p_line.include_field == "refcode"){
                                            component_x.selectedProdB.push(p_line.product_id)

                                            component_x.selectedProductDataB.push({
                                                product_id: p_line.product_id,
                                                required_value: 1,
                                                promo_value: "",
                                                name: p_line.product.name,
                                                retail_price: p_line.original_price,
                                                barcode: p_line.product.barcode,
                                                stock_no: p_line.stock_no

                                            })
                                        }else{
                                            component_x.promo.reward_trigger_amount = p_line.quantity
                                        }
                                    }else{
                                        if(p_line.include_field == "refcode"){
                                            component_x.selectedProd.push(p_line.product_id)

                                            component_x.selectedProductData.push({
                                                product_id: p_line.product_id,
                                                required_value: 1,
                                                promo_value: "",
                                                name: p_line.product.name,
                                                retail_price: p_line.original_price,
                                                barcode: p_line.product.barcode,
                                                stock_no: p_line.stock_no

                                            })
                                        }else{
                                            // Parse promo text
                                            let reward_type = promo_data.reward_type.split("|")[1]
                                            component_x.promo.reward_type = reward_type

                                            //Get group round
                                            let x_round_to_nearest = component_x.promo.promo_lines.find(x => (x.promo_type === 'B' && x.product_id === null)).promo_text
                                            if(x_round_to_nearest.includes('^')){
                                                component_x.promo.group_round_to_nearest = ((x_round_to_nearest.split(':')[1]).split(';')[0]).split('^')[1]
                                                if(reward_type == "1"){
                                                    component_x.promo.promo_discount = (p_line.promo_text.split(";")[0].split(":")[1].replace("%","")).split('^')[0]
                                                }else if(reward_type == "2"){
                                                    component_x.promo.promo_discount = (p_line.promo_text.split(";")[0].split(":")[1].replace("L","")).split('^')[0]
                                                }else{
                                                    component_x.promo.promo_discount = (p_line.promo_text.split(";")[0].split(":")[1].replace("F","")).split('^')[0]
                                                }
                                            } else {
                                                if(reward_type == "1"){
                                                    component_x.promo.promo_discount = p_line.promo_text.split(";")[0].split(":")[1].replace("%","")
                                                }else if(reward_type == "2"){
                                                    component_x.promo.promo_discount = p_line.promo_text.split(";")[0].split(":")[1].replace("L","")
                                                }else{
                                                    component_x.promo.promo_discount = p_line.promo_text.split(";")[0].split(":")[1].replace("F","")
                                                }
                                            }
                                            
                                            // if(reward_type == "1"){
                                            //     component_x.promo.promo_discount = p_line.promo_text.split(";")[0].split(":")[1].replace("%","")
                                            // }else if(reward_type == "2"){
                                            //     component_x.promo.promo_discount = p_line.promo_text.split(";")[0].split(":")[1].replace("L","")
                                            // }else{
                                            //     component_x.promo.promo_discount = p_line.promo_text.split(";")[0].split(":")[1].replace("F","")
                                            // }
                                            
                                        }
                                    }

                                })

                                console.log("PRE REQ")
                                console.log(component_x.selectedProdB)

                                console.log("BONUS")
                                console.log(component_x.selectedProd)

                                if(promo_data.promo_lines[0].condition_type == "AMOUNT"){
                                    component_x.promo.compute_mode = "every_amt"
                                }else{
                                    component_x.promo.compute_mode = "every_qty"
                                }
                                
                            }
                            
                        // if(component_x.promo.reward_type == 1 )

                        //Populate the customer types
                        //Arvin
                        component_x.customer_type = promo_data.card_type_included
                        if(promo_data.card_type_included.includes("$")){
                            if(["CLPMEMBERLEVEL", "CLPMEMBERTAG"].some(value => promo_data.card_type_included.includes(value))){
                                await this.parseCardType(promo_data.card_type_included)
                                component_x.customer_type = '$MEMBERSONLY$'
                            }
                            else {
                                component_x.customer_type = promo_data.card_type_included
                            }
                        } else {
                            component_x.customer_type = 'S'
                            component_x.customer_card_type_ids = promo_data.card_type_included.split(",");
                        }
                        delete component_x.promo.card_type_included

                        //Populate the payment types
                        //Arvin
                        // if(Object.keys(promo_data.payment_types).length > 0){
                        //     let payment_type = promo_data.payment_types
                        //     component_x.payment_type_ids = payment_type.payment_type_ids
                        // }
                        // delete component_x.promo.payment_types

                        // if(Object.keys(promo_data.additional_options).length > 0){
                        //     let additional_options = promo_data.additional_options
                        //     if(additional_options.max_application == component_x.reward.max_application){
                        //         component_x.is_no_of_times = false
                        //     } else {
                        //         component_x.reward.max_application = additional_options.max_application
                        //         component_x.is_no_of_times = true
                        //     }

                        //     if(additional_options.round_to_nearest == component_x.reward.round_to_nearest){
                        //         component_x.is_round_result = false
                        //     } else {
                        //         component_x.is_round_result = true
                        //         component_x.reward.round_to_nearest = additional_options.round_to_nearest
                        //     }
                        //     component_x.apply_discount = additional_options.reward_applied_to
                        //     component_x.is_compute_progressively = additional_options.is_compute_progressively
                        // }
                        // delete component_x.promo.additional_options

                        component_x.selectedRowKeys = [];

                        component_x.selectedRowKeys = promo_data.site_ids

                        let sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites", null);
                        component_x.locationTreelength = sites.length
                        if(component_x.selectedRowKeys.length < component_x.locationTreelength){
                            component_x.site_selection = "S"
                        }

                        // compare this later with the new params
                        component_x.oldPromoSites = promo_data.site_ids
 
                        delete component_x.promo.site_ids

                    } else {
                        try {
                            this.errors = promo_data["error"].split(",");
                        } catch (error) {
                            
                        }
                    }
                    }
                }
                this.spinning = false
            }

          this.checkImportJobs();
        },
        watch: {

            selectedRowKeys(newKeys) {
                // debug - log the new selected keys whenever they change
                console.log("selected keys updated wasup: ", newKeys);
            },

            // Watch options arrays, update selects when they arrive
            clpLevelOptions(newOptions) {
            this.clp_level_ids = [...this.clp_level_ids];
            },
            clpTagOptions(newOptions) {
            this.clp_tag_ids = [...this.clp_tag_ids];
            },
            is_specify_date: function() {
                if(this.is_specify_date == false){
                    this.valid_days = { sun: true, mon: true, tue: true,
                        wed: true, thu: true, fri: true, sat: true}
                }
            },
            activeKey: function(){
                if (this.activeKey == 1 || this.activeKey == '1'){
                    this.allProductsData()
                }
            },
            is_specify_time: function() {
                if(this.is_specify_time == false){
                    this.picker_date = {
                        valid_start_time: moment().startOf('day'),
                        valid_end_time: moment().endOf('day'),
                    }
                }
            },
            is_coupon_limit_printing: function(){
                if(this.is_coupon_limit_printing == false){
                    this.coupon.coupon_maximum = null
                    this.coupon.is_coupon_print_one = false
                } else {
                    if(this.coupon.coupon == ""){
                        this.coupon.coupon_maximum = 1
                    }
                }
            },
            get_y_type: function() {
                if(this.get_y_type == 'FB'){
                    this.reward.get_y_la = 0;
                    this.reward.get_y_po = 0;
                    this.reward.get_y_lp = 0;
                    this.reward.get_y_lp_round = 0;
                } else if(this.get_y_type == 'LA'){
                    this.reward.get_y_po = 0;
                    this.reward.get_y_lp = 0;
                    this.reward.get_y_lp_round = 0;
                } else if(this.get_y_type == 'PO'){
                    this.reward.get_y_la = 0;
                    this.reward.get_y_lp = 0;
                    this.reward.get_y_lp_round = 0;
                } else {
                    this.reward.get_y_la = 0;
                    this.reward.get_y_po = 0;
                }
            },
            get_x_type: function() {
                if(this.get_x_type == 'LSP'){
                    this.reward.get_x_la = 0
                    this.reward.get_x_po = 0
                } else if(this.get_x_type == 'LSA'){
                    this.reward.get_x_lp = 0
                    this.reward.get_x_po = 0
                } else {
                    this.reward.get_x_lp = 0
                    this.reward.get_x_la = 0
                }
            },
            'reward.apply_level': function(){
                if (this.reward.apply_level == 'IL'){
                    this.isUpdatePromoRewardAndCondition = true;
                    this.reward.apply_discount = "IL"
                }
            },
            // 'promo.compute_mode': function(){
            //     this.promo.reward_trigger_amount = null
            //     this.promo.reward_trigger_frequency = null
            // },
            promo: {
              handler(val){
                if (val.status == 'A' && this.$refs.uploadProductKey.fileList[0]) {
                  this.$refs.uploadProductKey.removeFile();
                  this.openNotificationWithIcon('error', "Upload product CSV file has been removed. You can't upload product for active promotions.")
                }
                this.canUploadProduct = this.showUploadCSVButton();
              },
              deep: true
            },
            include_item:  async function(){
                if (this.promo.promo_type == '1' && this.include_item == '6') {
                    this.canUploadProduct = this.showUploadCSVButton();
                }
                if(this.include_item == '5'){
                    if(this.supplierOptions.length == 0 ){
                      let suppliers = await HTTPRequest.getRequest(this.endPoint + "/suppliers/get_valid_suppliers", null, null)
                      this.supplierOptions = suppliers
                      this.sort(this.supplierOptions);
                    }

                    if(this.brandOptions.length == 0 ){
                        let brands = await HTTPRequest.getRequest(this.endPoint + "/brands/get_valid_brands?mode=all", null, null)
                        this.brandOptions = brands
                        this.sort(this.brandOptions);
                    }

                    if(this.categoriesOptions.length == 0){
                    //   let options = await HTTPRequest.getRequest(this.endPoint + 'categories/cascader_view_2', null);
                        let options = await HTTPRequest.getRequest(this.endPoint + 'categories/cascader_view', null);
                        this.updateCategoriesOptions(options)
                    }
                }else if(this.include_item == '4'){

                    if(this.categoriesOptions.length == 0){
                    
                        let options = await HTTPRequest.getRequest(this.endPoint + 'categories/cascader_view', null);
                        this.categoriesOptions = options
                        this.updateCategoriesOptions(options)
                    }
                }
            }
        },
        data: function () {
            return {
                promoExceptionKey: 0,
                promoExceptions: [],
                inputCategoryKey: 0,
                includeItemOptionsKey: 0,
                discountLabel: "Group Discount - Less Percent",
                groupRoundToNearestLabel: "Group Discount - Round",
                selectedProductBRefKey: 0,
                searchQuery: '',
                filteredLocationData: [],
                siteCodesInput: [],
                notifMessage: [],
                selectedSites: [],
                isModalVisible: false,
                promoData: {},
                filterKey: 0,
                filterParams: {},
                toggleAdvanceFilter: false,
                toggleLabel: "Advanced Filter",
                currentFilter: "category_id",
                massUpdateMode: false,
                parentParams: {},
                tags: [],
                advanceFilterParamsText: '',
                canUploadProduct: false,
                canExportProduct: false,
                openUploadProductsDrawer: false,
                openPromoExceptionsDrawer: false,
                showAddedProductTabulator: true,
                include_3p_items: false,
                include_mark_down_items: false,

                modalVisible: false,
                modalAvailableFields: false,
                confirmLoading: false,
                massDiscount: '',
                massLimit: '',
                massRound: 1,
                massRequired: '',
                locationTreelength: 0,
                refKey: 0,
                keyComp: 0,
                levelData: [],
                levelDataFilter: [],
                levelColumns: [
                    {
                        title: 'QUANTITY',
                        dataIndex: 'qty',
                        width: '35%',
                        scopedSlots: {
                            customRender: 'qty'
                        },
                    },
                    {
                        title: 'PRICE IS',
                        dataIndex: 'price',
                        width: '35%',
                        scopedSlots: {
                            customRender: 'price'
                        },
                    },
                    {
                        title: '',
                        dataIndex: 'operation',
                        scopedSlots: {
                            customRender: 'operation'
                        },
                    }
                ],
                levelGDCount: 1,
                levelGDData: [],
                levelGDDataFilter: [],
                levelGDColumns: [
                    {
                        title: '',
                        dataIndex: 'amount',
                        width: '35%',
                        scopedSlots: {
                            customRender: 'amount'
                        },
                    },
                    {
                        title: '',
                        dataIndex: 'percentOrAmount',
                        width: '35%',
                        scopedSlots: {
                            customRender: 'percentOrAmount'
                        },
                    },
                    {
                        title: '',
                        dataIndex: 'operation',
                        scopedSlots: {
                            customRender: 'operation'
                        },
                    }
                ],
                checkboxGDLabel:"",
                gbCheckboxValue:false,
                changeDisplayB: false,
                searchTextB:'',
                filterCaptionB: "Search by Name",
                filterFieldB: "name",

                changeDisplay: false,
                searchText:'',
                filterCaption: "Search by Name",
                filterField: "name",

                changeDisplay1: false,
                searchText1:'',
                filterCaption1: "Search by Name",
                filterField1: "name",

                levelCount: 1,
                activeProductId: 0,
                activeProductName: "",
                coupon: {
                    coupon_required: "1",
                    coupon_amount: "100",
                    coupon_expired: moment().endOf('day'),
                    coupon_maximum: "",
                    coupon_message: "****************************************\nCongratulations!  You have won a free\ngift certificate worth {egc_amount}.\n\nThis coupon is valid until: {coupon_expiry}\n\n{coupon_barcode}\n\nNo. {site_code}-{terminal_code}-{or_no}-{seq_no}\n{date}/{time}\n****************************************\n",
                    is_coupon_print_one: false
                },
                is_coupon_limit_printing: false,
                coupon_description: "Enter quantity required to activate promo",
                spinning: false,
                promo: {
                    reward_type: '1',
                    priority_level: 1,
                    promo_type: this.$attrs.promoType,
                    start_at: moment().startOf('day'),
                    end_at: moment().endOf('day'),
                    status: 'A',
                    apply_level: "exclusive",
                    payment_type_code: 'CASH',
                    compute_mode: 'every'
                },
                reward: {
                    max_application: 1000,
                    round_to_nearest: 0,
                    apply_discount: "IL",
                    apply_level: "IL",
                    apply_header: "IL",
                    required_value: 1,
                    get_y_lp: 0,
                    get_y_lp_round: 0,
                    get_y_la: 0,
                    get_y_po: 0,
                    get_x_lp: 0,
                    get_x_lp_round: 0,
                    get_x_la: 0,
                    get_x_po: 0
                },
                get_y_type: 'LP',
                get_x_type: 'LSP',
                allItem: {
                    supplier_id: [],
                    brand_id: []
                },
                reward_type_description: "",
                picker_date: {
                    valid_start_time: moment().startOf('day'),
                    valid_end_time: moment().endOf('day'),
                },
                exceptBrand: [],
                exceptSupplier: [],
                exceptCategory: [],
                discount: "1",
                max_application_all: 0,
                typeVisible: false,
                site_selection: 'A',
                site_ids: [],
                productLocationData: [],
                oldPromoSites: [],
                isUpdatePromoSite: false,
                isUpdatePromoRewardAndCondition: false,
                selectedRowKeys: [],
                siteOptions: [],
                customer_card_type_ids: [],
                customerCardTypeOptions: [],
                clp_level_ids: [],
                clpLevelOptions: [{ "id" : 32, "name" : "Bronze" }, { "id" : 34, "name" : "Gold" }, { "id" : 35, "name" : "Platinum" }, { "id" : 33, "name" : "Silver" }],
                clp_tag_ids: [],
                clpTagOptions: [{ "id" : 24,"name" : "The BratPack All-Stars" }, { "id" : 25,"name" : "The Varsity Pack" }, { "id" : 26,"name" : "The Heritage Crew" }, { "id" : 27,"name" : "The Rockport Regatta" }, { "id" : 28,"name" : "The World Traveller" }, { "id" : 29,"name" : "The Asphalt Alchemists" }, { "id" : 30,"name" : "The Fox Syndicate" }, { "id" : 31,"name" : "Employee" }],
                customer_type: '$ALL$',
                is_specify_time: false,
                is_specify_date: false,
                is_no_of_times: false,
                is_round_result: false,
                is_compute_progressively:false,
                valid_days: {
                    mon: true,
                    tue: true,
                    wed: true,
                    thu: true,
                    fri: true,
                    sat: true,
                    sun: true
                },
                include_item: "1",
                includeItemOptions: [
                    {key: "1", value: "All Items"},
                    {key: "2", value: "All Items from a Specific Supplier"},
                    {key: "3", value: "All Items from a Specific Brand"},
                    {key: "4", value: "All Items from a Specific Category"},
                    {key: "5", value: "All Items Except"},
                    {key: "6", value: "Select Specific Items"}
                ],
                coupleType: "",
                coupleTypeOptions: [
                    {key: "", value: " - "},
                    {key: "1", value: "Higher - Lower"},
                    {key: "2", value: "First - Second"}
                ],
                inputCategory: [],
                showAdvancedInfo: false,
                dateFormat: "MM/DD/YYYY",
                itemPoolOptions: [
                    {key: "1", value: "Percent Discount"},
                    {key: "2", value: "Amount Discount"},
                    {key: "3", value: "Change Price"},
                    // {key: "5", value: "Buy X Take Y"},
                    {key: "4", value: "Relative Pricing"},
                    {key: "5", value: "Bundle Pricing"},
                    {key: "6", value: "Buy X Take X"}
                ],
                pwpOptions: [
                    {key: "1", value: "Percent Discount"},
                    {key: "2", value: "Amount Discount"},
                    {key: "3", value: "Change Price"}
                ],
                multiLevelTypeOptions: [
                    {key: "1", value: "Discount with No Requirements (Default)"},
                    {key: "2", value: "Discount with Minimum Amount"},
                    {key: "3", value: "Discount with Required Quantity"},
                ],
                buyXOptions: [
                    // {key: "1", value: "Buy X Take X"},
                    {key: "2", value: "Buy X Take Y"}
                ],
                pricingOptions: [
                    {key: "1", value: "Tiered Pricing"},
                    {key: "2", value: "Volume Pricing"},
                    {key: "3", value: "Bundle Pricing"}
                ],
                couponOptions: [
                    {key: "1", value: "Generate Coupon with Required Quantity"},
                    {key: "2", value: "Generate Coupon with Required Amount"}
                ],
                condtionalOptions: [
                    {key: "1", value: "Buy all get X"},
                    {key: "2", value: "Buy any get any"},
                    {key: "3", value: "Pool"}
                ],
                groupDiscountOptions: [
                    {key: "1", value: "Simple Percentage Discount"},
                    {key: "2", value: "Percentage Discount based on Bracket"},
                    {key: "3", value: "Amount Discount For Every Sold Value"}
                ],
                replaceDiscountKey:null,
                PoolOptionKey:"TQ",
                PoolOptionValue:null,
                exceptionText: "CA",
                exceptionOptions: [
                    {key: 'CA', value: 'Category'},
                    {key: 'SP', value: 'Supplier'},
                    {key: 'BR', value: 'Brand'}
                ],
                exceptionValue: null,
                supplierOptions: [],
                brandOptions: [],
                selectedProd: [],
                selectedProdB: [],
                productData: [],
                productDataB: [],

                promoExceptionsOptions: [
                  { title: 'Exception Type', dataIndex: 'exception_type_display', key: 'exception_type_display' },
                  { title: "Exception Value", dataIndex: "exception_type_display", key: "exception_value", scopedSlots: { customRender: "render-select" } },
                  { title: "Action", dataIndex: "exception_value", key: "action", scopedSlots: { customRender: "render-action" } }
                ],

                // promoExceptionsOptions:{
                //     height: "100%",
                //     pagination:"remote",
                //     paginationDataSent:{
                //         "page":"page",
                //         "size":"per_page"
                //     },
                //     paginationSize:10,
                //     columns: [
                //         {
                //             title:'Type',
                //             field:'exception_type_display',
                //             width:"50%",
                //             headerSort: false
                //         },
                //         {
                //             title:'Value',
                //             field:'exception_value_display',
                //             width:"50%",
                //             headerSort: false 
                //         },
                //     ]
                // },
                productOptions: {
                    height: "100%",
                    pagination:"remote",
                    paginationDataSent:{
                        "page":"page",
                        "size":"per_page"
                    },
                    paginationSize:10,
                    columns: [
                        {
                            title:'NAME',
                            field:'name',
                            width:"30%",
                            headerSort: false
                        },
                        {
                            title: 'BARCODE',
                            field: 'barcode',
                            width: "15%",
                            headerSort: false
                        },
                        {
                            title: 'STOCK NO.',
                            field: 'stock_no',
                            width: "15%",
                            headerSort: false
                        },
                        {
                            title: 'BRAND',
                            field: 'brand_name',
                            width: "20%",
                            headerSort: false
                        },
                        {
                            title: 'RETAIL PRICE',
                            field: 'retail_price',
                            width: "10%",
                            headerSort: false,
                            formatter: this.retailPrice,
                            align:'right'
                        },
                        {
                            title: '',
                            width: "10%",
                            headerSort: false,
                            formatter: this.addButton,
                            cellClick: this.selectProduct,
                            align:'center'
                        }
                    ]
                },
                productOptionsB2: {
                    height: "100%",
                    pagination:"remote",
                    paginationDataSent:{
                        "page":"page",
                        "size":"per_page"
                    },
                    paginationSize:10,
                    columns: [
                        {
                            title:'NAME',
                            field:'name',
                            width:"30%",
                            headerSort: false
                        },
                        {
                            title: 'BARCODE',
                            field: 'barcode',
                            width: "20%",
                            headerSort: false
                        },
                        {
                            title: 'STOCK NO.',
                            field: 'stock_no',
                            width: "20%",
                            headerSort: false
                        },
                        {
                            title: 'RETAIL PRICE',
                            field: 'retail_price',
                            width: "20%",
                            headerSort: false,
                            formatter: this.retailPrice,
                            align:'right'
                        },
                        {
                            title: '',
                            width: "10%",
                            headerSort: false,
                            formatter: this.addButtonB,
                            cellClick: this.selectProductB,
                            align:'center'
                        }
                    ]
                },
                productOptionsB: {
                    height: "100%",
                    pagination:"remote",
                    paginationDataSent:{
                        "page":"page",
                        "size":"per_page"
                    },
                    paginationSize:10,
                    columns: [
                        {
                            title:'NAME',
                            field:'name',
                            width:"30%",
                            headerSort: false
                        },
                        {
                            title: 'BARCODE',
                            field: 'barcode',
                            width: "20%",
                            headerSort: false
                        },
                        {
                            title: 'STOCK NO.',
                            field: 'stock_no',
                            width: "20%",
                            headerSort: false
                        },
                        {
                            title: 'RETAIL PRICE',
                            field: 'retail_price',
                            width: "20%",
                            headerSort: false,
                            formatter: this.retailPrice,
                            align:'right'
                        },
                        {
                            title: '',
                            width: "10%",
                            headerSort: false,
                            formatter: this.addButtonB,
                            cellClick: this.selectProductB,
                            align:'center'
                        }
                    ]
                },
                schemeOptions: {
                    height:"100%",
                    selectable: 1,
                    paginationSize: 10,
                    pagination:"local",
                    columns: [
                        {
                            formatter:"rowSelection", 
                            titleFormatter:"rowSelection", 
                            hozAlign:"center", 
                            headerSort:false, 
                            titleFormatterParams:{
                                rowRange:"active" //only toggle the values of the active filtered rows
                            },
                            cellClick:function(e, cell){
                                cell.getRow().toggleSelect();
                            },
                        },
                        {
                            title:'NAME',
                            field:'name',
                            width:"30%",
                            headerSort: false
                        },
                        {
                            title: 'BARCODE',
                            field: 'barcode',
                            width: "20%",
                            headerSort: false
                        },
                        {
                            title: 'RETAIL PRICE',
                            field: 'retail_price',
                            width: "15%",
                            headerSort: false,
                            formatter: this.retailPrice,
                            align:'right'
                        },
                        {
                            title: 'LIMIT',
                            field: 'max_application',
                            width: "15%",
                            headerSort: false,
                            editor: "input"
                        },
                        {
                            title: 'ROUND',
                            field: 'round_to_nearest',
                            width: "15%",
                            headerSort: false,
                            editor: "input"
                        },
                        {
                            title: 'ACTION',
                            align:'center',
                            formatter: this.addDeleteButton,
                            width: "10%",
                            cellClick: this.selectProductAction,
                            headerSort: false
                        },
                        {
                            formatter: this.printIcon,
                            field: 'action',
                            width: "15%",
                            headerSort: false
                        },
                    ],
                    rowSelectionChanged:function(data, rows){
                        //update selected row counter on selection change
                        component_x.selectedRowCount = data.length;
                    },
                },

                preReqOptions: {
                    height:"100%",
                    selectable: 1,
                    paginationSize: 10,
                    pagination:"local",
                    columns: [
                        {
                            title:'NAME',
                            field:'name',
                            width:"40%",
                            headerSort: false
                        },
                        {
                            title: 'BARCODE',
                            field: 'barcode',
                            width: "30%",
                            headerSort: false
                        },
                        {
                            title: 'RETAIL PRICE',
                            field: 'retail_price',
                            width: "30%",
                            headerSort: false,
                            formatter: this.retailPrice,
                            align:'right'
                        }
                    ]
                },
                couponHeaderOptions: {
                    height:"100%",
                    paginationSize: 10,
                    pagination:"local",
                    columns: [
                        {
                            formatter:"rowSelection", 
                            titleFormatter:"rowSelection", 
                            hozAlign:"center", 
                            headerSort:false, 
                            titleFormatterParams:{
                                rowRange:"active" //only toggle the values of the active filtered rows
                            },
                            cellClick:function(e, cell){
                                cell.getRow().toggleSelect();
                            },
                        },
                        {
                            title:'NAME',
                            field:'name',
                            width:"50%",
                            headerSort: false
                        },
                        {
                            title: 'BARCODE',
                            field: 'barcode',
                            width: "30%",
                            headerSort: false
                        },
                        {
                            title: 'RETAIL PRICE',
                            field: 'retail_price',
                            width: "20%",
                            headerSort: false,
                            formatter: this.retailPrice,
                            align:'right'
                        },
                        {
                            title: 'ACTION',
                            align:'center',
                            formatter: this.addDeleteButton,
                            width: "10%",
                            cellClick: this.selectProductAction,
                            headerSort: false
                        },
                    ],
                    rowSelectionChanged:function(data, rows){
                        //update selected row counter on selection change
                        component_x.selectedRowCount = data.length;
                    },
                },
                couponLineOptions: {
                    height:"100%",
                    paginationSize: 10,
                    pagination:"local",
                    columns: [
                        {
                            formatter:"rowSelection", 
                            titleFormatter:"rowSelection", 
                            hozAlign:"center", 
                            headerSort:false, 
                            titleFormatterParams:{
                                rowRange:"active" //only toggle the values of the active filtered rows
                            },
                            cellClick:function(e, cell){
                                cell.getRow().toggleSelect();
                            },
                        },
                        {
                            title:'NAME',
                            field:'name',
                            width:"30%",
                            headerSort: false
                        },
                        {
                            title: 'BARCODE',
                            field: 'barcode',
                            width: "15%",
                            headerSort: false
                        },
                        {
                            title: 'RETAIL PRICE',
                            field: 'retail_price',
                            width: "15%",
                            headerSort: false,
                            formatter: this.retailPrice,
                            align:'right'
                        },
                        {
                            title: 'QUANTITY',
                            field: 'required_value',
                            width: "10%",
                            headerSort: false,
                            editor: "input"
                        },
                        {
                            title: 'ACTION',
                            align:'center',
                            formatter: this.addDeleteButton,
                            width: "10%",
                            cellClick: this.selectProductAction,
                            headerSort: false
                        },
                    ],
                    rowSelectionChanged:function(data, rows){
                        //update selected row counter on selection change
                        component_x.selectedRowCount = data.length;
                    },
                },
                selectedProductData: [],
                selectedProductDataB: [],
                selectedProductOptions: {
                    height: "100%",
                    paginationSize: 10,
                    pagination:"local",
                    paginationSizeSelector: [10,20,30,40,50],
                    columns: [
                        {
                            formatter:"rowSelection", 
                            titleFormatter:"rowSelection", 
                            hozAlign:"center", 
                            headerSort:false, 
                            titleFormatterParams:{
                                rowRange:"active" //only toggle the values of the active filtered rows
                            },
                            cellClick:function(e, cell){
                                cell.getRow().toggleSelect();
                            },
                        },
                        {
                            title:'NAME',
                            field:'name',
                            width:"35%",
                            headerSort: false
                        },
                        {
                            title: 'BARCODE',
                            field: 'barcode',
                            width: "10%",
                            headerSort: false
                        },
                        {
                            title: 'RETAIL PRICE',
                            field: 'retail_price',
                            width: "10%",
                            headerSort: false,
                            formatter: this.retailPrice,
                            align:'right'
                        },
                        {
                            title: 'PERCENT DISCOUNT',
                            field: 'promo_value',
                            width: "10%",
                            headerSort: false,
                            editor: "input",
                            align:'center'
                        },
                        {
                            title: 'LIMIT',
                            field: 'max_application',
                            width: "10%",
                            headerSort: false,
                            editor: "input",
                            align:'center'
                        },
                        {
                            title: 'ROUND',
                            field: 'round_to_nearest',
                            width: "10%",
                            headerSort: false,
                            editor: "input",
                            align:'center'
                        },
                        {
                            title: 'ACTION',
                            align:'center',
                            formatter: this.addDeleteButton,
                            width: "10%",
                            cellClick: this.selectProductAction,
                            headerSort: false,
                            align:'center'
                        },
                        {
                            title: '',
                            field: '',
                            width: "5%",
                            headerSort: false
                        }
                    ],
                    rowSelectionChanged:function(data, rows){
                        //update selected row counter on selection change
                        component_x.selectedRowCount = data.length;
                    },
                },
                selectedInlineProductOptions: {
                    height: "100%",
                    paginationSize: 10,
                    pagination:"local",
                    columns: [
                        {
                            formatter:"rowSelection", 
                            titleFormatter:"rowSelection", 
                            hozAlign:"center", 
                            headerSort:false, 
                            titleFormatterParams:{
                                rowRange:"active" //only toggle the values of the active filtered rows
                            },
                            cellClick:function(e, cell){
                                cell.getRow().toggleSelect();
                            },
                        },
                        {
                            title:'NAME',
                            field:'name',
                            width:"30%",
                            headerSort: false
                        },
                        {
                            title: 'Barcode',
                            field: 'barcode',
                            width: "20%",
                            headerSort: false
                        },
                        {
                            title: 'RETAIL PRICE',
                            field: 'retail_price',
                            width: "10%",
                            headerSort: false,
                            formatter: this.retailPrice,
                            align:'right'
                        },
                        {
                            title: 'PERCENT DISCOUNT',
                            field: 'promo_value',
                            width: "20%",
                            headerSort: false,
                            editor: "input",
                            align:'center'
                        },
                        {
                            title: 'ROUND',
                            field: 'round_to_nearest',
                            width: "10%",
                            headerSort: false,
                            editor: "input",
                            align:'center'
                        },
                        {
                            title: 'ACTION',
                            align:'center',
                            formatter: this.addDeleteButton,
                            width: "10%",
                            cellClick: this.selectProductAction,
                            headerSort: false,
                            align:'center'
                        },
                        {
                            title: '',
                            field: '',
                            width: "5%",
                            headerSort: false
                        }
                    ],
                    rowSelectionChanged:function(data, rows){
                        //update selected row counter on selection change
                        component_x.selectedRowCount = data.length;
                    },
                },
                selectedBuyXGetXProductOptions: {
                    height: "100%",
                    paginationSize: 10,
                    pagination:"local",
                    columns: [
                        {
                            formatter:"rowSelection", 
                            titleFormatter:"rowSelection", 
                            hozAlign:"center", 
                            headerSort:false, 
                            titleFormatterParams:{
                                rowRange:"active" //only toggle the values of the active filtered rows
                            },
                            cellClick:function(e, cell){
                                cell.getRow().toggleSelect();
                            },
                        },
                        {
                            title: 'NAME',
                            field: 'name',
                            width: "25%",
                            headerSort: false
                        },
                        {
                            title: 'Barcode',
                            field: 'barcode',
                            width: "10%",
                            headerSort: false
                        },
                        {
                            title: 'RETAIL PRICE',
                            field: 'retail_price',
                            width: "15%",
                            headerSort: false,
                            formatter: this.retailPrice,
                            align:'right'
                        },
                        {
                            title: 'BUY QTY',
                            field: 'required_value',
                            width: "15%",
                            headerSort: false,
                            editor: "input"
                        },
                        {
                            title: 'TAKE QTY',
                            field: 'promo_value',
                            width: "15%",
                            headerSort: false,
                            editor: "input"
                        },
                        {
                            title: 'LIMIT',
                            field: 'max_application',
                            width: "10%",
                            headerSort: false,
                            editor: "input"
                        },
                        {
                            title: 'ROUND',
                            field: 'round_to_nearest',
                            width: "5%",
                            headerSort: false,
                            editor: "input"
                        },
                        {
                            title: 'ACTION',
                            align:'center',
                            formatter: this.addDeleteButton,
                            width: "10%",
                            cellClick: this.selectProductAction,
                            headerSort: false
                        },
                        {
                            title: '',
                            field: '',
                            width: "5%",
                            headerSort: false
                        }
                    ],
                    rowSelectionChanged:function(data, rows){
                        //update selected row counter on selection change
                        component_x.selectedRowCount = data.length;
                    },
                },
                selectedListBProductOptions: {
                    height: "100%",
                    paginationSize: 10,
                    pagination:"local",
                    columns: [
                        {
                            title:'NAME',
                            field:'name',
                            width:"30%",
                            headerSort: false
                        },
                        {
                            title: 'BARCODE',
                            field: 'barcode',
                            width: "25%",
                            headerSort: false
                        },
                        {
                            title: 'RETAIL PRICE',
                            field: 'retail_price',
                            width: "20%",
                            headerSort: false,
                            formatter: this.retailPrice,
                            align:'right'
                        },
                        {
                            title: 'QUANTITY',
                            field: 'required_value',
                            width: "15%",
                            headerSort: false,
                            editor: "input"
                        },
                        {
                            title: '',
                            field: '',
                            width: "10%",
                            headerSort: false
                        }
                    ]
                },
                selectedBuyXGetYProductOptions: {
                    height: "100%",
                    paginationSize: 10,
                    pagination:"local",
                    columns: [
                        {
                            formatter:"rowSelection", 
                            titleFormatter:"rowSelection", 
                            hozAlign:"center", 
                            headerSort:false, 
                            titleFormatterParams:{
                                rowRange:"active" //only toggle the values of the active filtered rows
                            },
                            cellClick:function(e, cell){
                                cell.getRow().toggleSelect();
                            },
                        },
                        {
                            title:'NAME',
                            field:'name',
                            width:"30%",
                            headerSort: false
                        },
                        {
                            title: 'Barcode',
                            field: 'barcode',
                            width: "15%",
                            headerSort: false
                        },
                        {
                            title: 'RETAIL PRICE',
                            field: 'retail_price',
                            width: "25%",
                            headerSort: false,
                            formatter: this.retailPrice,
                            align:'right'
                        },
                        {
                            title: 'QUANTITY',
                            field: 'required_value',
                            width: "25%",
                            headerSort: false,
                            editor: "input"
                        },
                        {
                            title: 'ACTION',
                            align:'center',
                            formatter: this.addDeleteButton,
                            width: "10%",
                            cellClick: this.selectProductAction,
                            headerSort: false
                        },
                        {
                            title: '',
                            field: '',
                            width: "5%",
                            headerSort: false
                        }
                    ],
                    rowSelectionChanged:function(data, rows){
                        //update selected row counter on selection change
                        component_x.selectedRowCount = data.length;
                    },
                },
                selectedGetYProductOptions: {
                    height: "100%",
                    pagination:"local",
                    paginationSize: 10,
                    columns: [
                        {
                            title:'NAME',
                            field:'name',
                            width:"50%",
                            headerSort: false
                        },
                        {
                            title: 'RETAIL PRICE',
                            field: 'retail_price',
                            width: "50%",
                            headerSort: false,
                            formatter: this.retailPrice,
                            align:'right'
                        },
                    ]
                },
                exceptData: [],
                JsonData:[],
                exceptOptions: {
                    height: "100%",
                    paginationSize: 10,
                    pagination:"local",
                    columns: [
                        {
                            title: 'EXCEPTION',
                            field: 'field_text',
                            width: "25%",
                            headerSort: false
                        },
                        {
                            title: '',
                            field: 'id_text',
                            width: "25%",
                            headerSort: false
                        },
                        {
                            title: '',
                            field: '',
                            width: "5%",
                            headerSort: false
                        }
                    ]
                },
                couponAvailableFieldsData: [
                    { fields: 'terminal_id', description: "Terminal Id" },
                    { fields: 'terminal_code', description: "Terminal No." },
                    { fields: 'trans_number', description: "Transaction No." },
                    { fields: 'trans_date', description: "Transaction Date" },
                    { fields: 'trans_time', description: "Transaction Time" },
                    { fields: 'or_no', description: "Receipt No." },
                    { fields: 'site_code', description: "Site Code" },
                    { fields: 'cashier', description: "Cashier Name" },
                    { fields: 'customer_code', description: "Card No." },
                    { fields: 'customer_name', description: "Customer Name" },
                    { fields: 'amount_due', description: "Amount Due" },
                    { fields: 'reprinted', description: "If Coupon is reprinted" },
                    { fields: 'expiry_date', description: "Expiry Date of coupon" }
                ],
                couponAvailableFieldsOption:{
                    columns: [
                        {
                            title:'Field Name',
                            field:'fields',
                            width:"50%",
                            headerSort: false
                        },
                        {
                            title:'Description',
                            field:'description',
                            width:"50%",
                            headerSort: false
                        }]
                },
                authHeaders: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") },
                searchFilter: "name",
                current: 0,
                fetching: false,
                getYData: [],
                payment_type_code: "ALL",
                payment_type_ids: [],
                paymentTypeOptions: [],
                is_ref_code: false,
                viewOnly: false,
                errors: [],
                doneLoading:false,
                promotionId: 0,
                exportFileName: `${'Promotion'}-${moment().format('YYYYMMDDHHmmss')}`,
                csvHeaders: {},
                exportData: [],
                tempItemListData: [],
                selectedRowCount: 0,
                activeKey: '1',
                activeKey2: '100', 
                gBonusKey1: '100',
                gBonusKey2: '101',
                gBonusKey3: '102',
                gBonusKey4: '103',
            }
        },
        methods: {
            ...mapActions(['updateCategoriesOptions']),
            moment,

            async loadClpOptions() {
                    // try {
                    //     let clp_levels = await HTTPRequest.getRequest(
                    //         "https://18.140.99.137:8002/api/v1/clp_membership_levels?sort=id&page=1&per_page=99999&source=bxi",
                    //         null
                    //     );
                    //     this.notifMessage = []
                    //     // Validate response structure
                    //     if (clp_levels && Array.isArray(clp_levels.data)) {
                    //         this.clpLevelOptions = clp_levels.data;
                    //     } else {
                    //         this.notifMessage.push('Invalid CLP response. Using default membership.');
                    //         this.promoActionNotification('Opps...', 'error');    
                    //         this.spinning = false
                    //     }

                    // } catch (error) {
                    //     this.notifMessage.push('Error fetching CLP levels.');
                    //     this.promoActionNotification('Opps...', 'error');    
                    //     this.spinning = false;
                    //     // Default fallback value
                    //     // this.clpLevelOptions = [];
                    // }


                    // try {
                    //         let clp_tags = await HTTPRequest.getRequest(
                    //             "https://18.140.99.137:8002/api/v1/clp_member_tags?sort=id&page=1&per_page=99999&source=bxi",
                    //             null
                    //         );
                    //         this.notifMessage = []
                    //         if (clp_tags && Array.isArray(clp_tags.data)) {
                    //             this.clpTagOptions = clp_tags.data;
                    //         } else {
                    //             this.notifMessage.push('Invalid CLP response. Using default clp tags.');
                    //             this.promoActionNotification('Opps...', 'error');
                    //             this.spinning = false;
                    //         }

                    //     } catch (error) {
                    //         this.notifMessage.push('Error fetching CLP tags.');
                    //         this.promoActionNotification('Opps...', 'error');    
                    //         this.spinning = false;
                    //         // this.clpTagOptions = [];
                    //     }
                        
                        try {
                            const res = await axios.get('https://alb.hotfix.primergroup.bartermms.com/clp/clp_tags', {
                            headers: { Authorization: `Bearer ${secureStorage.getItem("accessToken")}` }
                            });
                            this.clpTagOptions = res.data['data'].map(tag => ({
                            id: tag.id,
                            name: tag.name
                            }));

                            
                        } catch (err) {
                            console.error('Failed to fetch tags:', err);
                        }

                        try {
                            const res = await axios.get('https://alb.hotfix.primergroup.bartermms.com/clp/clp_levels', {
                            headers: { Authorization: `Bearer ${secureStorage.getItem("accessToken")}` }
                            });
                    
                            this.clpLevelOptions = res.data['data'].map(tag => ({
                            id: tag.id,
                            name: tag.name
                            }));
                        } catch (err) {
                            console.error('Failed to fetch tags:', err);
                        }
                },
            async parseCardType(card_type_included) {
                const raw = card_type_included || '';
                const sections = raw.split(';');

                sections.forEach(section => {
                    if (section.startsWith('$CLPMEMBERLEVEL$')) {
                    this.clp_level_ids = section
                        .replace('$CLPMEMBERLEVEL$', '')
                        .split('|')
                        .filter(v => v.trim() !== '')
                        .map(v => Number(v)); // convert to number;
                    }
                    if (section.startsWith('$CLPMEMBERTAG$')) {
                    this.clp_tag_ids = section
                        .replace('$CLPMEMBERTAG$', '')
                        .split('|')
                        .filter(v => v.trim() !== '')
                        .map(v => Number(v)); // convert to number;
                    }
                });
                },
            
            changeParams(params, actualParams, mode){
                this.tags = []
                var parametersCopy = this.parentParams
                var mergedParameters = Object.assign({}, parametersCopy, params);

                this.params = mergedParameters
                this.filterParams = actualParams
                this.massUpdateMode = mode
                const defaultFilters = ["status", "is_non_trade", "stock_status", "category_name",
                    "supplier_name", "start_at", "brand_names", "tag_names", "sub_brand_names", "product_group_names",
                    "inputCategory", "inputBrand", "inputSubBrand", "inputProductGroup", "inputSupplierType", "inputSupplier", "inputDate",
                    "statusFilter", "inputTag", "dateString", "isNonTrade", "stockStatus","inputProductSeriesName", "product_series_name", "inputProductSeriesDate", "product_series_date"]

                if(Object.keys(this.parentParams)[0] != undefined){
                    this.tags.push(Object.keys(this.parentParams)[0] + ":" + Object.values(this.parentParams)[0])
                }

                this.advanceFilterParamsText = ''
                Object.keys(params).forEach(function (key) {
                    if(!defaultFilters.includes(key)){
                        component_x.tags.push(`${key}: ${params[key]}`)
                        component_x.advanceFilterParamsText += `&${key}=${params[key]}`
                    }
                })

                if(params["status"] != undefined){
                    switch(params["status"]){
                        case "A":
                            this.tags.push("Status: Active")
                            break;
                        case "I":
                            this.tags.push("Status: Inactive")
                            break;
                        case "P":
                            this.tags.push("Status: Phased Out")
                            break;
                    }
                }

                if(params["is_non_trade"] != undefined){
                    this.tags.push("Non-trade: " + params["is_non_trade"])
                }

                if(params["stock_status"] != undefined){
                    switch(params["stock_status"]){
                        case "1":
                            this.tags.push("Stock: Out of Stock")
                            break;
                        case "2":
                            this.tags.push("Stock: On Stock")
                            break;
                        case "3":
                            this.tags.push("Stock: Negative Stock")
                            break;
                    }
                }

                if(params["category_name"] != undefined){
                    this.tags.push("Category: " + params["category_name"])
                }

                if(params["supplier_name"] != undefined){
                    this.tags.push("Supplier: " + params["supplier_name"])
                }

                if(params["start_at"] != undefined){
                    this.tags.push("Price Change Date: " + params["start_at"] + " to " + params["end_at"])
                }

                if(params["brand_names"] != undefined){
                    for(var i=0; i < params["brand_names"].length; i++){
                        this.tags.push("Brand: " + params["brand_names"][i] )
                    }
                }

                if(params["tag_names"] != undefined){
                    for(var j=0; j < params["tag_names"].length; j++){
                        this.tags.push("Tag: " + params["tag_names"][j] )
                    }
                }

                if(actualParams == null){
                    this.params = {}
                    this.parentParams = {}
                    this.tags = []
                }

                if(this.promo.promo_type == 7){
                    if(this.activeKey2 == this.gBonusKey3){
                        this.allProductsDataB()
                    }else{
                        this.allProductsDataGB()
                    }
                    
                }else{
                    this.allProductsData()
                } 
                this.advanceFilter(false);
            },
            closeFilter(){
                this.advanceFilter(false)
            },
            advanceFilter(value){
                this.toggleAdvanceFilter = value
                if(this.toggleAdvanceFilter == true){
                    this.toggleLabel = "Collapse Filter"
                }else{
                    this.toggleLabel = "Advanced Filter"
                }
            },
            toggleUploadProductsDrawer(bool) {
              if (bool && !(this.promo.status == 'I' || (this.promo.status == 'A' && !this.promo.id))) {
                this.$notification['error']({
                  message: 'Error',
                  description: "Only Inactive Promotions are allowed to upload Products"
                });

                return;
              }

              this.openUploadProductsDrawer = bool;
            },
            togglePromoExceptionsDrawer(bool){
                this.openPromoExceptionsDrawer = bool;
            },
            showUploadCSVButton() {
              const promoType = this.promo.promo_type;
              const rewardType = this.promo.reward_type;

              return (((promoType == '1' && (rewardType == '3' || this.include_item == '6')) ||
                      ['2', '3', '4', '5', '6','7'].includes(promoType)) && !this.viewOnly)
            },
            showExportProductButton() {
              return (this.viewOnly && ([1,2,3,4,5,6,7].includes(parseInt(this.promo.promo_type))));
            },
            clearExportJsonData() {
                this.JsonData = []
            },
            exportProduct() {
              const promoType = parseInt(this.promo.promo_type)
              let specialData = {}

              if (promoType == 2) {
                specialData = { applyLevel: this.reward.apply_level }
              }

              if (promoType == 6) {
                specialData = { coupleType: this.coupleType }
              }


              const data = exportProductCSV(
                promoType,
                this.promo.reward_type,
                this.selectedProductData,
                this.selectedProductDataB,
                specialData
              );

              const { csvHeaders, csvData } = data;

              this.csvHeaders = csvHeaders;
              this.exportData = csvData;

              setTimeout(() => { this.$refs.exportCsvBtn.click() }, 200)
            },
            addMassProducts(products) {
              const productIds = products.map(prod => prod.product_id);
              this.selectedProductData = [...this.selectedProductData, ...products];
              this.selectedProd = [...this.selectedProd, ...productIds];
              this.allProductsData()
            },
            replaceStatus(value){
                this.keyComp++;
                this.promo.status = value;
            },
            validatePromoCodeInput(event){
                const char = String.fromCharCode(event.which);
                if (!/[a-zA-Z0-9]/.test(char)) {
                    event.preventDefault();
                }
            },
            validatePromoCode(){
                this.promo.code = this.promo.code.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
            },
            changeFilter(value){
                this.filterField = value
                this.filterCaption = "Filter By " + _.startCase(this.filterField)
            },
            changeFilter1(value){
                this.filterField1 = value
                value = (value == 'product_id') ? 'id' : value
                this.filterCaption1 = "Filter By " + _.startCase(value)
            },
            changeFilterB(value){
                this.filterFieldB = value
                value = (value == 'product_id') ? 'id' : value
                this.filterCaptionB = "Filter By " + _.startCase(value)
            },
            //levels
            levelOnDelete(key) {
                const dataSource = [...this.levelData];
                const dataFilter = [...this.levelDataFilter];
                this.levelData = dataSource.filter(item => item.key !== key);
                this.levelDataFilter = dataFilter.filter(item => item.key !== key);
                this.isUpdatePromoRewardAndCondition = true
            },
            levelHandleAdd() {
                this.isUpdatePromoRewardAndCondition = true
                if(this.activeProductId > 0){
                    const { levelCount } = this;
                    this.levelData.push({
                        key: levelCount,
                        product_id: this.activeProductId,
                        qty: "",
                        price: ""
                    });

                    this.levelDataFilter.push({
                        key: levelCount,
                        product_id: this.activeProductId,
                        qty: "",
                        price: ""
                    });

                    this.levelEdit(levelCount);
                    this.levelCount = levelCount + 1;
                } else {
                    alert("Please click the product that you want to add level")
                }
            },
            levelEdit(key) {
                const newData = [...this.levelData];
                const newDataFilter = [...this.levelDataFilter];
                const target = newData.filter(item => key === item.key)[0];
                const targetFilter = newDataFilter.filter(item => key === item.key)[0];
                if (target) {
                    target.editable = true;
                    targetFilter.editable = true;
                    this.levelData = newData;
                    this.levelDataFilter = newDataFilter;
                }
            },
            levelHandleChangeTable(value, key, column) {
                const newData = [...this.levelData];
                const newDataFilter = [...this.levelDataFilter];
                const target = newData.filter(item => key === item.key)[0];
                const targetFilter = newDataFilter.filter(item => key === item.key)[0];
                if (target) {
                    target[column] = value;
                    targetFilter[column] = value;
                    this.levelData = newData;
                    this.levelDataFilter = newDataFilter;
                }
                this.isUpdatePromoRewardAndCondition = true
            },
            //end levels
            levelGDOnDelete(key) {
                const dataSource = [...this.levelGDData];
                const dataFilter = [...this.levelGDDataFilter];
                this.levelGDData = dataSource.filter(item => item.key !== key);
                this.levelGDDataFilter = dataFilter.filter(item => item.key !== key);
                this.isUpdatePromoRewardAndCondition = true
            },
            levelGDHandleAdd() {
                this.isUpdatePromoRewardAndCondition = true
                const { levelGDCount } = this;
                this.levelGDData.push({
                    key: levelGDCount,
                    amount: "",
                    percentOrAmount: ""
                });

                this.levelGDDataFilter.push({
                    key: levelGDCount,
                    amount: "",
                    percentOrAmount: ""
                });
                this.levelGDEdit(levelGDCount);
                this.levelGDCount = levelGDCount + 1;
            },
            levelGDEdit(key) {
                const newData = [...this.levelGDData];
                const newDataFilter = [...this.levelGDDataFilter];
                const target = newData.filter(item => key === item.key)[0];
                const targetFilter = newDataFilter.filter(item => key === item.key)[0];
                if (target) {
                    target.editable = true;
                    targetFilter.editable = true;
                    this.levelGDData = newData;
                    this.levelGDDataFilter = newDataFilter;
                }
            },
            levelGDHandleChangeTable(value, key, column) {
                const newData = [...this.levelGDData];
                const newDataFilter = [...this.levelGDDataFilter];
                const target = newData.filter(item => key === item.key)[0];
                const targetFilter = newDataFilter.filter(item => key === item.key)[0];
                if (target) {
                    target[column] = value;
                    targetFilter[column] = value;
                    this.levelGDData = newData;
                    this.levelGDDataFilter = newDataFilter;
                }
                this.isUpdatePromoRewardAndCondition = true
            },

            getProduct: async function(group) {
                let searchProduct = group.selectedObject;
                this.getYData = []
                this.getYData.push({
                    product_id: searchProduct.id,
                    name: searchProduct.name,
                    retail_price: searchProduct.retail_price.replace(',',''),
                    reward_value: 1
                });
            },
            printIcon(cell, formatterParams){
                return "<i class='fas fa-angle-right'></i>";
            },
            setActiveProductId(e, row){
                let product_id = row.getData().product_id
                let name = row.getData().name
                this.activeProductId = product_id
                this.activeProductName = name

                const newData = [...this.levelData];
                this.levelDataFilter = newData.filter(item => item.product_id === product_id);
            },
            productsEndpoint(input) {
                return this.endPoint + 'products?all=0&' + this.searchFilter + '=' + input
            },
            allProductsData(){
                this.changeDisplay = true
                this.productOptions.ajaxURL = this.endPoint + 'products?all=0&' + this.filterField + '=' + this.searchText + this.advanceFilterParamsText
                this.productOptions.ajaxConfig = {
                    method:"GET",
                    headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") },
                }

                this.table = new Tabulator("#product-table", this.productOptions);
            },
            allProductsDataGB(){
                this.changeDisplay = true
                this.productOptionsB2.ajaxURL = this.endPoint + 'products?all=0&' + this.filterField + '=' + this.searchText + this.advanceFilterParamsText
                this.productOptionsB2.ajaxConfig = {
                    method:"GET",
                    headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") },
                }

                this.table = new Tabulator("#product-tableB", this.productOptionsB2);
                var originalTable = document.getElementById('product-tableB-orig');
                originalTable.style.display = 'none'; //or
            },
            allProductsDataB(){
                // this.changeDisplayB = true
                // filterCaptionB
                this.productOptions.ajaxURL = this.endPoint + 'products?all=0&' + this.filterFieldB + '=' + this.searchTextB + this.advanceFilterParamsText
                this.productOptions.ajaxConfig = {
                    method:"GET",
                    headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") },
                }

                this.table = new Tabulator("#product-table", this.productOptions);
                var originalTable = document.getElementById('product-table-orig');
                originalTable.style.display = 'none'; //or
                // this.table = new Tabulator("#product-tableB", this.productOptionsB2);
            },
            formattedDisplay(result) {
                if(this.searchFilter == 'barcode'){
                    return result.barcode
                } else if(this.searchFilter == 'stock_no'){
                    return result.stock_no
                } else if(this.searchFilter == 'reference_code'){
                    return result.reference_code
                } else {
                    return result.name
                }
            },
            // Show available fields
             showAvailableFields() {
                this.modalAvailableFields = true;
            },
            // Advanced Info
            showAdvancedInfoDiv(){
                this.showAdvancedInfo ? this.showAdvancedInfo = false : this.showAdvancedInfo = true
            },
            massAssign() {
                this.modalVisible = true;
            },
            addAllGroupBonus: async function (){
                this.isUpdatePromoRewardAndCondition = true;
                this.spinning = true
                this.showAddedProductTabulator = false;

                let all_products = await HTTPRequest.getRequest(component_x.endPoint + 'products?all=0&' + this.filterField + '=' + this.searchText + this.advanceFilterParamsText, null);
                let last_page = all_products.last_page
                if(all_products.last_page == 1){
                  let array = all_products.data
                  for (let index = 0; index < array.length; index++) {
                    const element = array[index];
                    if (this.selectedProdB.includes(element.id) == false){
                      this.selectedProdB.push(element.id)

                      this.selectedProductDataB.push({
                        product_id: element.id,
                        required_value: 1,
                        name: element.name,
                        retail_price: element.retail_price,
                        barcode: element.barcode,
                        stock_no: element.stock_no
                      })
                    }
                  }

                  this.allProductsDataGB()
                } else if(all_products.last_page > 1){
                  let array = all_products.data
                  for (let index = 0; index < array.length; index++) {
                    const element = array[index];
                    if (this.selectedProdB.includes(element.id) == false){
                      this.selectedProdB.push(element.id)

                      this.selectedProductDataB.push({
                        product_id: element.id,
                        required_value: 1,
                        name: element.name,
                        retail_price: element.retail_price,
                        barcode: element.barcode,
                        stock_no: element.stock_no
                      })
                    }
                  }

                  for (let i = 2; i < all_products.last_page + 1; i++) {
                    let loop_products = await HTTPRequest.getRequest(component_x.endPoint + 'products?all=0&page=' + i + this.filterField + '=' + this.searchText + this.advanceFilterParamsText, null);
                    let array = loop_products.data
                    for (let index = 0; index < array.length; index++) {
                      const element = array[index];
                      if (this.selectedProdB.includes(element.id) == false){
                        this.selectedProdB.push(element.id)

                        this.selectedProductDataB.push({
                          product_id: element.id,
                          required_value: 1,
                          name: element.name,
                          retail_price: element.retail_price,
                          barcode: element.barcode,
                          stock_no: element.stock_no
                        })
                      }
                    }
                  }
                  this.allProductsDataGB()
                }
                this.spinning = false;

                setTimeout(() => { this.showAddedProductTabulator = true; }, 200)
            },
            addAll: async function (){
                this.isUpdatePromoRewardAndCondition = true;
                this.spinning = true
                this.showAddedProductTabulator = false;

                let all_products = await HTTPRequest.getRequest(component_x.endPoint + 'products?all=0&' + this.filterField + '=' + this.searchText + this.advanceFilterParamsText, null);
                let last_page = all_products.last_page
                if(all_products.last_page == 1){
                  let array = all_products.data
                  for (let index = 0; index < array.length; index++) {
                    const element = array[index];
                    if (this.selectedProd.includes(element.id) == false){
                      this.selectedProd.push(element.id)

                      this.selectedProductData.push({
                        product_id: element.id,
                        required_value: 1,
                        name: element.name,
                        retail_price: element.retail_price.replace(',',''),
                        barcode: element.barcode,
                        stock_no: element.stock_no
                      })
                    }
                  }

                  this.allProductsData()
                } else if(all_products.last_page > 1){
                  let array = all_products.data
                  for (let index = 0; index < array.length; index++) {
                    const element = array[index];
                    if (this.selectedProd.includes(element.id) == false){
                      this.selectedProd.push(element.id)

                      this.selectedProductData.push({
                        product_id: element.id,
                        required_value: 1,
                        name: element.name,
                        retail_price: element.retail_price.replace(',',''),
                        barcode: element.barcode,
                        stock_no: element.stock_no
                      })
                    }
                  }

                  for (let i = 2; i < all_products.last_page + 1; i++) {
                    let loop_products = await HTTPRequest.getRequest(component_x.endPoint + 'products?all=0&page=' + i + this.filterField + '=' + this.searchText + this.advanceFilterParamsText, null);
                    let array = loop_products.data
                    for (let index = 0; index < array.length; index++) {
                      const element = array[index];
                      if (this.selectedProd.includes(element.id) == false){
                        this.selectedProd.push(element.id)

                        this.selectedProductData.push({
                          product_id: element.id,
                          required_value: 1,
                          name: element.name,
                          retail_price: element.retail_price.replace(',',''),
                          barcode: element.barcode,
                          stock_no: element.stock_no
                        })
                      }
                    }
                  }
                  this.allProductsData()
                }
                this.spinning = false;

                setTimeout(() => { this.showAddedProductTabulator = true; }, 200)
            },
            handleOk(e) {
                this.isUpdatePromoRewardAndCondition = true
                this.confirmLoading = true;

                for (let s = 0; s < this.selectedProductData.length; s++) {
                    if(this.massDiscount != ''){
                        this.selectedProductData[s].promo_value = this.massDiscount
                    }

                    if(this.massLimit != ''){
                        this.selectedProductData[s].max_application = this.massLimit
                    }

                    if(this.massRound != ''){
                        this.selectedProductData[s].round_to_nearest = this.massRound
                    }

                    if(this.massRequired != ''){
                        this.selectedProductData[s].required_value = this.massRequired
                    }
                }

                this.refKey++

                this.modalVisible = false;
                this.confirmLoading = false;
            },
            handleCancel(e) {
                this.modalVisible = false;
                this.modalAvailableFields = false;
                this.isModalVisible = false;
            },
            
            addButton(cell, formatterParams){
              if (this.viewOnly) { return null; }

              let product_id = cell.getRow().getData().id

              let button = ""
              if (this.selectedProd.includes(product_id) == false){
                button = '<button id="add_' + product_id + '" class="btn btn-sm btn-success" >ADD</button>';
              } else {
                button = '<button id="add_' + product_id + '" class="btn btn-sm btn-default">UNDO</button>';
              }
              return button
            },
            addButtonB(cell, formatterParams){
              if (this.viewOnly) { return null; }

              let product_id = cell.getRow().getData().id

              let button = ""
              if (this.selectedProdB.includes(product_id) == false){
                button = '<button id="addB_' + product_id + '" class="btn btn-sm btn-success" >ADD</button>';
              } else {
                button = '<button id="addB_' + product_id + '" class="btn btn-sm btn-default">UNDO</button>';
              }
              return button
            },
            retailPrice(cell, formatterParams){
                return this.formatMyNumber(cell.getRow().getData().retail_price, 2)
            },
            formatMyNumber(number, decimal) {
                if(isNaN(number)){
                    return '0.00'
                }
                var splitNum;
                number = Math.abs(number);
                number = number.toFixed(decimal);
                splitNum = number.split('.');
                splitNum[0] = splitNum[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                return splitNum.join(".");
            },
            addException(){
                let exception_type_text = this.exceptionOptions.find(x => x.key === this.exceptionText).value
                let exception_type_value = this.exceptionText

                let excepted_text = ""
                let excepted_value = 0
                if(this.exceptionText == 'BR'){
                    excepted_text = this.brandOptions.find(x => x.id === this.exceptBrand).name
                    excepted_value = this.exceptBrand
                } else if(this.exceptionText == 'SP'){
                    excepted_text = this.supplierOptions.find(x => x.id === this.exceptSupplier).name
                    excepted_value = this.exceptSupplier
                } else {
                    if(this.exceptCategory.length > 0){
                        let resultLength = this.exceptCategory.length
                        let divisions = this.categoriesOptions.find(x => x.value === this.exceptCategory[0]).children

                        let departments = []
                        let sections = []
                        let categories = []
                        switch(resultLength) {
                        case 5:
                            departments = divisions.find(x => x.value === this.exceptCategory[1]).children
                            sections = departments.find(x => x.value === this.exceptCategory[2]).children
                            categories = sections.find(x => x.value === this.exceptCategory[3]).children
                            excepted_text = categories.find(x => x.value === this.exceptCategory[4]).label
                            exception_type_text = 'Category'
                            exception_type_value = 'CA'
                            excepted_value = this.exceptCategory[4];
                            break;
                        case 4:
                            departments = divisions.find(x => x.value === this.exceptCategory[1]).children
                            sections = departments.find(x => x.value === this.exceptCategory[2]).children
                            excepted_text = sections.find(x => x.value === this.exceptCategory[3]).label
                            exception_type_text = 'Section'
                            exception_type_value = 'SC'
                            excepted_value = this.exceptCategory[3];
                            break;
                        case 3:
                            departments = divisions.find(x => x.value === this.exceptCategory[1]).children
                            excepted_text = departments.find(x => x.value === this.exceptCategory[2]).label
                            exception_type_text = 'Department'
                            exception_type_value = 'DP'
                            excepted_value = this.exceptCategory[2];
                            break;
                        case 2:
                            alert("Select atleast in department level")
                            break;
                        }
                    }
                }

                if(excepted_value != 0 && excepted_text != ""){
                    this.exceptData.push({
                        field_text: exception_type_text,
                        field_value: exception_type_value,
                        id_text: excepted_text,
                        id_value: excepted_value
                    })
                }
            },
            selectProduct(e, cell){
                this.isUpdatePromoRewardAndCondition = true
                if (e.target.id == '') { return; }

                this.showAddedProductTabulator = false;

                let button = document.getElementById(e.target.id);
                let product_id = cell.getRow().getData().id;
                const stock_no = cell.getRow().getData().stock_no;

                if (this.selectedProd.includes(product_id) == false){
                    this.selectedProd.push(product_id)

                    let promo_value = "0.00"
                    if(this.promo.promo_type == "2" || this.promo.promo_type == "3"){
                        promo_value = "0"
                    } else {
                        if(this.reward_type == "1"){
                            promo_value = "0"
                        }
                    }
                    this.selectedProductData.push({
                      product_id: product_id,
                      name: cell.getRow().getData().name,
                      retail_price: cell.getRow().getData().retail_price.replace(',',''),
                      promo_value: promo_value,
                      barcode: cell.getRow().getData().barcode,
                      reference_code: cell.getRow().getData().reference_code,
                      required_value: 1,
                      stock_no: stock_no
                    })

                    this.checkItemIfMatrix(cell.getRow().getData(),promo_value)

                    button.className = "btn btn-sm btn-default"
                    button.innerHTML = "UNDO"
                } else {
                    const index = this.selectedProd.indexOf(product_id);

                    const dataSource = [...this.selectedProductData];
                    this.selectedProductData = dataSource.filter(item => item.product_id !== product_id);

                    if (index > -1) {
                        this.selectedProd.splice(index, 1);

                        button.className = "btn btn-sm btn-success"
                        button.innerHTML = "ADD"
                    }
                }

                setTimeout(() => { this.showAddedProductTabulator = true; }, 300);
            },
            selectProductB(e, cell){


              console.log("selectProductB")
              this.isUpdatePromoRewardAndCondition = true
              if (e.target.id == '') { return; }

              let button = document.getElementById(e.target.id)
              let product_id = cell.getRow().getData().id
              const stock_no = cell.getRow().getData().stock_no;
              if (this.selectedProdB.includes(product_id) == false){

                console.log("Product NOT YET selected")
                this.selectedProdB.push(product_id)

                let promo_value = "0.00"
                if(this.promo.promo_type == "2" || this.promo.promo_type == "3"){
                  promo_value = "0"
                } else {
                  if(this.reward_type == "1"){
                    promo_value = "0"
                  }
                }

                this.selectedProductDataB.push({
                  product_id: product_id,
                  name: cell.getRow().getData().name,
                  reference_code: cell.getRow().getData().reference_code,
                  retail_price: cell.getRow().getData().retail_price.replace(',',''),
                  promo_value: promo_value,
                  barcode: cell.getRow().getData().barcode,
                  required_value: 1,
                  stock_no: stock_no
                })

                this.selectedProductBRefKey++;

                button.className = "btn btn-sm btn-default"
                button.innerHTML = "UNDO"
              } else {

                console.log("Product ALREADY selected")
                const index = this.selectedProdB.indexOf(product_id);

                const dataSource = [...this.selectedProductDataB];
                this.selectedProductDataB = dataSource.filter(item => item.product_id !== product_id);

                if (index > -1) {
                  this.selectedProdB.splice(index, 1);
                  this.selectedProductBRefKey++;
                  button.className = "btn btn-sm btn-success"
                  button.innerHTML = "ADD"
                }
              }
            },
            openNotificationWithIcon(type, message) {
              this.$notification[type]({
                message: 'Error',
                description: message
              });
            },
            // checkSelectedProductValue(){
            //     if(this.promo.promo_type == '2' || (this.promo.promo_type == '1' && (this.promo.reward_type == '3' || this.include_item == '6'))){
            //         let non_zero = true
            //         for (let s = 0; s < this.selectedProductData.length; s++) {
            //             let product = this.selectedProductData[s]
            //             let promo_value = product.promo_value
            //             if(promo_value== "0" || promo_value == "0.00" || promo_value.trim() == ""){
            //                 non_zero = false
            //             }
            //         }
            //         return non_zero
            //     } else {
            //         return true
            //     }
            // },
            checkIfHasErrors(current) {
              let noError = true;
              let errorMsg = [];

               if(this.promo.name.length > 100){
                    noError=false
                    errorMsg.push('Promotion Name field should not exceed 100 characters.');
                }

                if ((current + 1) == 1) { return { noError, errorMsg }; }

              if (this.promo.promo_type == '6' && this.promo.reward_type == '1') {
                if (this.promo.status == 'A' && this.selectedProductData.length > 0 &&
                    (this.getYData.length == 0 || !this.getYData[0].product_id)) {
                  noError = false;
                  errorMsg.push('Please select a reward product (Item X).');
                }
              }

              if ((['1', '2'].includes(this.promo.promo_type) && (this.promo.reward_type == '3' || this.include_item == '6')) ||
                  (this.promo.promo_type == '3') ||
                  (this.promo.promo_type == '6' && this.promo.reward_type == '1') ||
                  (this.promo.promo_type == '6' && (this.promo.reward_type == '2' || this.promo.reward_type == '3') && [1, 2].includes(parseInt(this.coupleType)))
                ) {
                if (this.selectedProductData.length == 0 && !this.$refs.uploadProductKey.fileList[0]) {
                  noError = false;
                  errorMsg.push('Please select at least 1 product or upload a CSV file to populate the product.');
                }
              } else if (this.promo.promo_type == '6' && (this.promo.reward_type == '2' || this.promo.reward_type == '3') && ![1, 2].includes(parseInt(this.coupleType))) {
                if (this.selectedProductData.length == 0 && !this.$refs.uploadProductKey.fileList[0]) {
                  noError = false;
                  errorMsg.push('Please select at least 1 prerequisite item or upload a CSV file to populate the product.');
                }
              }

              if (this.promo.promo_type == '2' || (this.promo.promo_type == '1' && (this.promo.reward_type == '3' && this.include_item == '6'))){
                for (let s = 0; s < this.selectedProductData.length; s++) {
                  let product = this.selectedProductData[s]
                  let promo_value = product.promo_value
                  console.log(">> promo_value")
                  console.log(promo_value)
                  if(promo_value== "0" || promo_value == "0.00" || promo_value.length == 0){
                    noError = false;
                    errorMsg.push('Please specify discount value of selected products.');

                    break;
                  }
                }
              }

              if (this.promo.promo_type == '3' && this.promo.reward_type != '1' &&
                  this.promo.status == 'A' && !this.$refs.uploadProductKey.fileList[0] &&
                  (this.getYData.length == 0 || !this.getYData[0].product_id) ) {
                noError = false;
                errorMsg.push("You can't activate this promotion without a Reward Product (Item Y). Please specify Item Y.");
              }

              return { noError, errorMsg };
            },

            async nextPage(current) {

                console.log(">>> INCLUDE ITEM <<<")
                console.log(this.include_item)

                let errorMsg = []

                // console.log("CURRENT")
                // console.log(this.current)
                
                if(this.activeKey2 < 103 && this.current == 1 && this.promo.promo_type == '7'){

                    if(this.activeKey2 == "100"){
                        if(this.promo.compute_mode == null){
                        errorMsg.push("Select correct value for computation Mode. ");
                    }

                    if(this.promo.reward_trigger_amount == null || this.promo.reward_trigger_amount == ''){
                        errorMsg.push("Enter valid value for amount/quantity required.");
                    }

                    console.log("Pre-req Items")
                    console.log(this.selectedProductDataB)
                    if(this.selectedProductDataB.length == 0){
                        errorMsg.push("Select pre-requistite item/s");
                    }

                }

                if(this.activeKey2 == "102"){

                    console.log("Bonus Items")
                    console.log(this.selectedProductDataB)
                    if(this.selectedProductData.length == 0){
                        errorMsg.push("Select bonus item/s");
                    }
                }

                if(errorMsg.length > 0){
                  errorMsg.map(error => {
                    this.openNotificationWithIcon('error', error);
                  })
                }else{
                    this.activeKey2 = (parseInt(this.activeKey2) + 1).toString();
                    // console.log("ACTIVE KEY")
                    // console.log(this.activeKey2)
                }
                
                } else {
                    let { noError, errorMsg } = this.checkIfHasErrors(current);

                if(this.activeKey2 == "103"){
                    // console.log(this.selectedProductData)
                    // let p_values = this.selectedProductData.map(x => x.promo_value)

                    // if(p_values.includes("0.00") || p_values.includes("0") || p_values.includes(null)){
                    //     noError = false
                    //     errorMsg.push("Enter valid discount value.");
                    // }

                    if(this.promo.promo_discount == "0.00" || this.promo.promo_discount == "0" || this.promo.promo_discount == null){
                        noError = false
                        errorMsg.push("Enter valid discount value.");
                    }
                }

                if(noError){
                  this.current = current + 1
                  this.spinning = true
                  if(this.current == 1){
                    if(this.supplierOptions.length == 0 && this.include_item == "2" ){
                      let suppliers = await HTTPRequest.getRequest(this.endPoint + "/suppliers/get_valid_suppliers", null, null)
                      this.supplierOptions = suppliers
                      this.sort(this.supplierOptions);
                    }

                  if(this.brandOptions.length == 0 && this.include_item == "3"){
                        // var userBrands = secureStorage.getItem("userBrands") || ""
                        // let brands = await HTTPRequest.getRequest(this.endPoint + "/brands/get_valid_brands?userBrands=" + userBrands, null, null)
                        let brands = await HTTPRequest.getRequest(this.endPoint + "/brands/get_valid_brands?mode=all", null, null)
                        if(brands != null){
                          this.brandOptions = brands
                          this.sort(this.brandOptions);
                        }
                    }

                    // console.log("Categories")
                    // console.log(this.categoriesOptions)

                    // if(this.categoriesOptions.length == 0 && this.include_item == "4"){
                    // //   let options = await HTTPRequest.getRequest(this.endPoint + 'categories/cascader_view_2', null);
                    //     let options = await HTTPRequest.getRequest(this.endPoint + 'categories/cascader_view', null);
                    //     this.categoriesOptions = options
                    //     this.updateCategoriesOptions(options)
                    // }

                  } else if(this.current == 2) {
                    if(this.customerCardTypeOptions.length == 0){
                      let customer_card_types = await HTTPRequest.getRequest(this.endPoint + "customer_card_types/get_valid_customer_card_types", null);
                      this.customerCardTypeOptions = customer_card_types;
                      this.sort(this.customerCardTypeOptions)
                    }

                    //CLP Integration
                    await this.loadClpOptions()

                  } else if(this.current == 3) {
                    if(this.siteOptions.length == 0){
                      let sites = await HTTPRequest.getRequest(this.endPoint + "sites/get_valid_sites", null);
                      this.siteOptions = sites;
                      this.sort(this.siteOptions)
                    }
                  } else if(this.current == 4) {
                    if(this.siteOptions.length == 0){
                      let sites = await HTTPRequest.getRequest(this.endPoint + "sites/get_valid_sites", null);
                      this.siteOptions = sites;
                      this.sort(this.siteOptions)
                    }
                  }
                  this.spinning = false
                } else {
                  errorMsg.map(error => {
                    this.openNotificationWithIcon('error', error);
                  })
                }

              }
              
            },
            async backPage(current){
                console.log("BEFORE ACTIVE KEY 2")
                console.log(this.activeKey2)
                console.log("CURRENT")
                console.log(current)
                if(this.activeKey2 > 100 && this.activeKey < 103 && this.current == 1){
                    this.activeKey2 = (parseInt(this.activeKey2) - 1).toString();
                    console.log("ACTIVE KEY")
                    console.log(this.activeKey2)
                }else{
                    this.current = current - 1
                }
                
            },
            cancel(){
                this.$emit('closeDrawer');
            },
            close() {
                this.$emit('refreshPage', event)
            },
            async done(){
                this.doneLoading = true
                // console.log(this)

                const hasUploadingFile = this.$refs.uploadProductKey.fileList[0];
                const hasOngoingUpload = await this.checkImportJobBeforeSaving();

                if (this.promo.status != 'A' && hasUploadingFile && hasOngoingUpload) {
                  // Checker if User is uploading a file when there's an ongoing upload process
                  this.doneLoading = false;
                  return;
                } else if (this.promo.status == 'A' && hasOngoingUpload) {
                  // Checker if User will activate the promo and there's an ongoing upload process
                  this.doneLoading = false;
                  return;
                }

                let promotion_hash = {}
                let promo_sites = []

                //promo_sites - Arvin //
                //promo_sites - Arvin//
                if(this.site_selection == 'A'){
                    this.siteOptions.forEach((el) => {
                        promo_sites.push(el.id)
                    })
                    // console.log(promo_sites)
                } else {
                    var site_ids = this.selectedRowKeys.filter(
                        (x) => typeof x === "number"
                    );
                    promo_sites = site_ids;
                }

                // check if promo site is updated
                var isUpdatePromoSite = false
                if(_.xor(promo_sites, this.oldPromoSites).length === 0){
                    isUpdatePromoSite = false
                }else{
                    isUpdatePromoSite = true
                }

                let promos = []
                let promo_lines = []


                if(this.is_specify_date == true){
                    let day_arr = []
                    if(this.valid_days.sun == true){ day_arr.push("1") }
                    if(this.valid_days.mon == true){ day_arr.push("2") }
                    if(this.valid_days.tue == true){ day_arr.push("3") }
                    if(this.valid_days.wed == true){ day_arr.push("4") }
                    if(this.valid_days.thu == true){ day_arr.push("5") }
                    if(this.valid_days.fri == true){ day_arr.push("6") }
                    if(this.valid_days.sat == true){ day_arr.push("7") }
                    promos.valid_day = day_arr
                    this.promo.valid_day = day_arr
                } else {
                    promos.valid_day = []
                    this.promo.valid_day = []
                }

                if(this.is_specify_time == true){
                    promos.valid_start_time = this.picker_date.valid_start_time.format("HH:mm")
                    promos.valid_end_time = this.picker_date.valid_end_time.format("HH:mm")
                    this.promo.valid_start_time = this.picker_date.valid_start_time.format("HH:mm")
                    this.promo.valid_end_time = this.picker_date.valid_end_time.format("HH:mm")
                }

                // Promo Type = Item and Pool Discounts //
                //Promo Type = Item and Pool Discounts //
                if(['1', '2'].includes(this.promo.promo_type)){

                    if(this.promo.promo_type == '1'){
                        this.promo.reward_trigger_frequency = 0
                        this.promo.reward_type_desc = "REFCODEBONUS|" + this.promo.reward_type
                    }else if(this.promo.promo_type == '2'){
                        this.promo.reward_type_desc = "PWPWP|" + this.promo.reward_type
                        // inclusive;CASH;every 
                        if( this.promo.reward_trigger_frequency == '' || this.promo.reward_trigger_frequency == null ){
                            this.promo.reward_trigger_frequency = 0
                        }
                        this.promo.promo_text = this.promo.apply_level + ";" + this.promo.payment_type_code + ";" + this.promo.compute_mode
                    }

                    console.log("INCLUDE ITEM")
                    console.log(this.include_item)
                    // START -- Promo Lines Process Saving //

                    if(this.max_application_all == 0){
                        this.max_application_all = 999
                    }

                    //All Items
                    if(this.include_item == "1"){

                        let promo_text = ''
                        let promo_description = ''
                        let round_to_nearest = 1

                        // Percent Discount
                        if (this.promo.reward_type == "1"){ 
                            // promo_text = '(1:E1:' + this.discount + '%;@' + this.max_application_all + ')'
                            let x_round_to_nearest = (round_to_nearest > 0) ? '^'+round_to_nearest : '';
                            promo_text = '(1:E1:' + this.discount + '%'+x_round_to_nearest+';@' + this.max_application_all + ')'
                            promo_description = '^1:Less ' + this.discount + '%, Limit to ' + this.max_application_all + '^' 
                        } 
                        
                        // Amount Discount
                        else if (this.promo.reward_type == "2"){
                            // promo_text = '(1:E1:L' + this.discount+ ';@' + this.max_application_all + ')'
                            let x_round_to_nearest = (round_to_nearest > 0) ? '^'+round_to_nearest : '';
                            promo_text = '(1:E1:L' + this.discount+''+x_round_to_nearest+ ';@' + this.max_application_all + ')'
                            promo_description = '^1:Less ' + this.discount + ', Limit to ' + this.max_application_all + '^'
                        } 

                        promo_lines.push({
                            include_field: "all",
                            include_value: "",
                            exclude_field: "",
                            exclude_value: "",
                            promo_text: promo_text,
                            include_field_ex: "all",
                            include_value_ex: "",
                            exclude_field_ex: "",
                            exclude_value_ex: "",
                            description: promo_description,
                            quantity: "",
                            original_price: "",
                            group_id: "",
                            promo_type: "P",
                            condition_type: "EVERY",
                            status: "A",
                            product_id: -1
                        })

                    //Specific Supplier
                    } 
                    
                    // Supplier
                    else if(this.include_item == "2"){
                        let round_to_nearest = 1
                        let promo_text = ''
                        let promo_description = ''
                        // Percent Discount
                        if (this.promo.reward_type == "1"){ 
                            // promo_text = '(1:E1:' + this.discount + '%;@' + this.max_application_all + ')'
                            let x_round_to_nearest = (round_to_nearest > 0) ? '^'+round_to_nearest : '';
                            promo_text = '(1:E1:' + this.discount + '%'+x_round_to_nearest+';@' + this.max_application_all + ')'
                            promo_description = '^1:Less ' + this.discount + '%, Limit to ' + this.max_application_all + '^' 
                        } 
                        
                        // Amount Discount
                        else if (this.promo.reward_type == "2"){
                            // promo_text = '(1:E1:L' + this.discount+ ';@' + this.max_application_all + ')'
                            let x_round_to_nearest = (round_to_nearest > 0) ? '^'+round_to_nearest : '';
                            promo_text = '(1:E1:L' + this.discount+ ''+x_round_to_nearest+';@' + this.max_application_all + ')'
                            promo_description = '^1:Less ' + this.discount + ', Limit to ' + this.max_application_all + '^'
                        } 
                        

                        promo_lines.push({
                            include_field: "supplierId",
                            include_value: this.allItem.supplier_id,
                            exclude_field: "",
                            exclude_value: "",
                            promo_text: promo_text,
                            description: promo_description,
                            include_field_ex: "supplierId",
                            include_value_ex: this.allItem.supplier_id,
                            exclude_field_ex: "",
                            exclude_value_ex: "",
                            quantity: "",
                            original_price: "",
                            group_id: "",
                            promo_type: "P",
                            condition_type: "EVERY",
                            status: "A",
                            product_id: -1
                        })
                        // Change Price
                        // else if (this.promo.reward_type == "3"){
                        //     promo_text = '(1:E1:F' + this.discount + ';@' + this.max_application_all + ')'
                        //     promo_description = '^1:New Price ' + this.discount + ', Limit to ' + this.max_application_all + '^'
                        // } 
                        
                    //Specific Brand
                    } 
                    
                    // Brand
                    else if(this.include_item == "3"){
                        let brands = this.allItem.brand_id
                        console.log("BRAND ID VALUES")
                        console.log(this.allItem.brand_id)
                        let round_to_nearest = 1

                        let promo_text = ''
                        let promo_description = ''
                        // Percent Discount
                        if (this.promo.reward_type == "1"){ 
                            // promo_text = '(1:E1:' + this.discount + '%;@' + this.max_application_all + ')'
                            let x_round_to_nearest = (round_to_nearest > 0) ? '^'+round_to_nearest : '';
                            promo_text = '(1:E1:' + this.discount + '%'+x_round_to_nearest+';@' + this.max_application_all + ')'
                            promo_description = '^1:Less ' + this.discount + '%, Limit to ' + this.max_application_all + '^' 
                        } 
                        
                        // Amount Discount
                        else if (this.promo.reward_type == "2"){
                            // promo_text = '(1:E1:L' + this.discount+ ';@' + this.max_application_all + ')'
                            let x_round_to_nearest = (round_to_nearest > 0) ? '^'+round_to_nearest : '';
                            promo_text = '(1:E1:L' + this.discount+ ''+x_round_to_nearest+';@' + this.max_application_all + ')'
                            promo_description = '^1:Less ' + this.discount + ', Limit to ' + this.max_application_all + '^'
                        } 

                        brands.forEach(b => {
                            promo_lines.push({
                            include_field: "brandId",
                            include_value: b,
                            exclude_field: "",
                            exclude_value: "",
                            promo_text: promo_text,
                            include_field_ex: "brandId",
                            include_value_ex: b,
                            exclude_field_ex: "",
                            exclude_value_ex: "",
                            description: promo_description,
                            quantity: 1,
                            original_price: "",
                            group_id: 1,
                            promo_type: "P",
                            condition_type: "EVERY",
                            status: "A"
                            })
                        })

                        
                    //Specific Category
                    } 
                    
                    // Categories
                    else if(this.include_item == "4"){

                        if(this.inputCategory.length > 0){
                            let resultLength = this.inputCategory.length
                            let category_id = 0
                            let category_type = ""
                            let round_to_nearest = 1

                            switch(resultLength) {
                            case 5:
                                category_type = "categoryId"
                                category_id = this.inputCategory[4];
                                break;
                            case 4:
                                category_type = "sectionId"
                                category_id = this.inputCategory[3];
                                break;
                            case 3:
                                category_type = "departmentId"
                                category_id = this.inputCategory[2];
                                break;
                            case 2:
                                category_type = "divisionId"
                                category_id = this.inputCategory[1];
                                break;
                            case 1:
                                alert("Select atleast in division level")
                                return
                                break;
                            }

                            let promo_text = ''
                            let promo_description = ''

                            console.log(">>>>Checker Input Category")
                            console.log(this.inputCategory)

                            let cascader_value = this.inputCategory.toString()
                             // Percent Discount
                             if (this.promo.reward_type == "1"){ 
                                 // promo_text = '(1:E1:' + this.discount + '%;@' + this.max_application_all + ')'
                                 let x_round_to_nearest = (round_to_nearest > 0) ? '^'+round_to_nearest : '';
                                 promo_text = '(1:E1:' + this.discount + '%'+x_round_to_nearest+';@' + this.max_application_all + ')'
                                 promo_description = '^1:Less ' + this.discount + '%, Limit to ' + this.max_application_all + '^' 
                             } 

                             // Amount Discount
                             else if (this.promo.reward_type == "2"){
                                 //  promo_text = '(1:E1:L' + this.discount+ ';@' + this.max_application_all + ')'
                                 let x_round_to_nearest = (round_to_nearest > 0) ? '^'+round_to_nearest : '';
                                 promo_text = '(1:E1:L' + this.discount+ ''+x_round_to_nearest+';@' + this.max_application_all + ')'
                                 promo_description = '^1:Less ' + this.discount + ', Limit to ' + this.max_application_all + '^'
                             } 
                        
                            promo_lines.push({
                                include_field: category_type,
                                include_value: category_id,
                                exclude_field: "",
                                exclude_value: "",
                                promo_text: promo_text,
                                include_field_ex: category_type,
                                include_value_ex: category_id,
                                exclude_field_ex: "",
                                exclude_value_ex: "",
                                description: promo_description,
                                quantity: "",
                                original_price: "",
                                group_id: "",
                                promo_type: "P",
                                condition_type: "EVERY",
                                status: "A",
                                integration_settings: "[" + cascader_value + "]"
                                // product_id: ""
                            })

                    
                        } else {
                            alert("No Category Selected")
                            return
                        }
                    //Except Selected Items
                    } 
                    
                    // All Items Except
                    else if(this.include_item == "5"){

                        if(this.promoExceptions.length > 0){
                            let round_to_nearest = 1
                            let promo_text = ''
                            let promo_description = ''
                            // Percent Discount
                            if (this.promo.reward_type == "1"){ 
                                // promo_text = '(1:E1:' + this.discount + '%;@' + this.max_application_all + ')'
                                let x_round_to_nearest = (round_to_nearest > 0) ? '^'+round_to_nearest : '';
                                promo_text = '(1:E1:' + this.discount + '%'+x_round_to_nearest+';@' + this.max_application_all + ')'
                                promo_description = '^1:Less ' + this.discount + '%, Limit to ' + this.max_application_all + '^' 
                            } 

                            console.log("NEW PROMO EXCEPTIONS")
                            console.log(this.promoExceptions)

                            for (let s = 0; s < this.promoExceptions.length; s++) {
                                let exempt = this.promoExceptions[s]

                                let cacscader_value = null
                                if(exempt.exception_type == "ex_supplierId" || exempt.exception_type == "ex_brandId"){
                                    cacscader_value = null
                                }else{
                                    cacscader_value = "[" + exempt.exception_value_display + "]"
                                }

                                promo_lines.push({
                                    include_field: exempt.exception_type,
                                    include_field_ex: exempt.exception_type,
                                    include_value: exempt.exception_value,
                                    include_value_ex: exempt.exception_value,
                                    exclude_field: "",
                                    exclude_value: "",
                                    exclude_field_ex: "",
                                    exclude_value_ex: "",
                                    promo_text: promo_text,
                                    description: promo_description,
                                    quantity: "",
                                    original_price: "",
                                    group_id: "",
                                    promo_type: "P",
                                    condition_type: "EVERY",
                                    status: "A",
                                    integration_settings: cacscader_value
                                })
                               
                            }
                        } else {
                            alert("No Item Selected")
                            return
                        }

                        console.log("PROMO LINES")
                        console.log(promo_lines)
                    } 
                    
                    // Default
                    else {
                        
                        for (let s = 0; s < this.selectedProductData.length; s++) {
                            let product = this.selectedProductData[s]

                            console.log(">> Product")
                            console.log(product)

                            console.log("levelData")
                            console.log(this.levelData)

                            let max_application = product.max_application
                            let round_to_nearest = product.round_to_nearest

                            if (product.max_application == '' || product.max_application == null || product.max_application == undefined){
                                max_application = this.reward.max_application
                            }

                            if (product.round_to_nearest == '' || product.round_to_nearest == null || product.round_to_nearest == undefined){
                                round_to_nearest = this.reward.round_to_nearest
                            }

                            //let product_value = product.barcode
                            let product_value = product.reference_code 
                            if(this.is_ref_code == true){
                                product_value = product.reference_code 
                            }

                            let promo_text = ""
                            let promo_description = ""

                            if(max_application == 0){
                                max_application = 999
                            }

                            // Percent Discount
                            if (this.promo.reward_type == "1"){ 
                                // promo_text = '(1:E1:' + product.promo_value + '%;@' + max_application + ')'
                                let x_round_to_nearest = (round_to_nearest > 0) ? '^'+round_to_nearest : '';
                                promo_text = '(1:E1:' + product.promo_value + '%'+x_round_to_nearest+';@' + max_application + ')'
                                promo_description = '^1:Less ' + product.promo_value + '%, Limit to ' + max_application + '^' 
                            } 
                            
                            // Amount Discount
                            else if (this.promo.reward_type == "2"){
                                // promo_text = '(1:E1:L' + product.promo_value + ';@' + max_application + ')'
                                let x_round_to_nearest = (round_to_nearest > 0) ? '^'+round_to_nearest : '';
                                promo_text = '(1:E1:L' + product.promo_value + ''+x_round_to_nearest+';@' + max_application + ')'
                                promo_description = '^1:Less ' + product.promo_value + ', Limit to ' + max_application + '^'
                            } 
                            
                            // Change Price
                            else if (this.promo.reward_type == "3"){
                                // promo_text = '(1:E1:F' + product.promo_value + ';@' + max_application + ')'
                                let x_round_to_nearest = (round_to_nearest > 0) ? '^'+round_to_nearest : '';
                                promo_text = '(1:E1:F' + product.promo_value + ''+x_round_to_nearest+';@' + max_application + ')'
                                promo_description = '^1:New Price ' + product.promo_value + ', Limit to ' + max_application + '^'
                            } 
                            
                            // Relative Pricing
                            // levelDataFilter
                            else if (this.promo.reward_type == "4"){
                                let level_text = ''
                                for(var x = 0; x < this.levelData.length; x++){
                                    let levelValue = this.levelData[x]
                                    if(product.product_id == levelValue.product_id) {
                                        console.log(levelValue)
                                        level_text += levelValue.qty + '|' + levelValue.price + ","
                                    }
                                }
                                // promo_text = '(1:E1:R' + level_text.slice(0, -1) + ';@' + parseInt(max_application) + ')'
                                let x_round_to_nearest = (round_to_nearest > 0) ? '^'+round_to_nearest : '';
                                promo_text = '(1:E1:R' + level_text.slice(0, -1) + ''+x_round_to_nearest+';@' + parseInt(max_application) + ')'
                                promo_description = '^1:Relative (R' + level_text.slice(0, -1) + '), Limit to ' + parseInt(max_application) + '^'
                            } 
                            
                            // Bundle Pricing
                            else if (this.promo.reward_type == "5"){
                                console.log("Bundle Pricing")
                                // promo_text = '(1:D1:' + product.promo_value + 'L;@' + max_application + ')'
                                // promo_description = '^1:Bundling ' + product.promo_value + ', Limit to ' + max_application + '^'
                                let level_text = ''
                                for(var x = 0; x < this.levelData.length; x++){
                                    let levelValue = this.levelData[x]
                                    if(product.product_id == levelValue.product_id) {
                                        console.log(levelValue)
                                        level_text += levelValue.qty + ':' + levelValue.price + ','
                                    }
                                }

                                // (1:S2:30,4:50)
                                // ^1:Bundling (S2:30,4:50), Limit to 10^

                                promo_text = '(1:S' + level_text.slice(0, -1) + '@' + parseInt(max_application) + ')'
                                promo_description = '^1:Bundling (S' + level_text.slice(0, -1) + '), Limit to ' + parseInt(max_application) + '^'
                            } 

                            // Buy X Take X
                            else if (this.promo.reward_type == "6"){
                                // promo_text = '(1:D1:B' + product.required_value + ',' + product.promo_value + ';@' + max_application + ')'
                                let x_round_to_nearest = (round_to_nearest > 0) ? '^'+round_to_nearest : '';
                                promo_text = '(1:D1:B' + product.required_value + ',' + product.promo_value + ''+x_round_to_nearest+';@' + max_application + ')'
                                promo_description = '^1:Buy ' + product.required_value + ' Take '+  product.promo_value +', Limit to ' + max_application + '^'
                            } 

                            if(this.include_type == '5'){
                                promo_lines.push({
                                    include_field: "refcode",
                                    include_value: product_value,
                                    exclude_field: "refcode",
                                    exclude_value: product_value,
                                    promo_text: promo_text,
                                    include_field_ex: "",
                                    include_value_ex: "",
                                    exclude_field_ex: "refcode",
                                    exclude_value_ex: product_value,
                                    description: promo_description +'||'+ product.name,
                                    quantity: max_application,
                                    original_price: product.retail_price.replace(',',''),
                                    group_id: 1,
                                    promo_type: "P",
                                    condition_type: "EVERY",
                                    status: "A",
                                    product_id: product.product_id
                                })
                            }else{
                                promo_lines.push({
                                    include_field: "refcode",
                                    include_value: product_value,
                                    exclude_field: "",
                                    exclude_value: "",
                                    promo_text: promo_text,
                                    include_field_ex: "refcode",
                                    include_value_ex: product_value,
                                    exclude_field_ex: "",
                                    exclude_value_ex: "",
                                    description: promo_description +'||'+ product.name,
                                    quantity: max_application,
                                    original_price: product.retail_price.replace(',',''),
                                    group_id: 1,
                                    promo_type: "P",
                                    condition_type: "EVERY",
                                    status: "A",
                                    product_id: product.product_id
                                })
                            }
                            
                            
                        }
                    }

                    // END -- Promo Lines Process Saving //

                } 

                // Promo Type = Group Bonus //
                else if(['7'].includes(this.promo.promo_type)){

                    let p_text = this.promo.promo_text
                    if(p_text == "0"){
                        p_text = "999"
                    }
                    this.promo.reward_type_desc = "GROUPBONUS|" + this.promo.reward_type
                    this.promo.promo_text = "@" + p_text

                    if( this.promo.reward_trigger_frequency == '' || this.promo.reward_trigger_frequency == null ){
                            this.promo.reward_trigger_frequency = 0
                    }

                    let p_condition_type="EVERY"
                    if (this.promo.compute_mode == 'every_amt'){
                        p_condition_type="AMOUNT"
                    }

                    // START - Processing of pre-requisite items //
                    // [1.1] Pre-req Item Processing
                    for(var x =0; x < this.selectedProductDataB.length; x++){
                        let pre_req_item = this.selectedProductDataB[x]
            
                        // CONDITION 1
                        promo_lines.push({
                            include_field: "refcode",
                            include_value: pre_req_item.reference_code,
                            exclude_field: null,
                            exclude_value: null,
                            promo_text: "",
                            include_field_ex: "refcode",
                            include_value_ex: pre_req_item.reference_code,
                            exclude_field_ex: null,
                            exclude_value_ex: null,
                            description: "",
                            quantity: 1,
                            original_price: pre_req_item.retail_price.replace(',',''),
                            group_id: 1,
                            promo_type: "P",
                            condition_type: p_condition_type,
                            status: "A",
                            product_id: pre_req_item.product_id
                        })
                    }

                    // CONDITION 2
                    let prereq_p_text= "(1:E1:0%;)(2:E1:0%;)(3:E1:0%;)"
                    let prereq_p_desc= "^1:Less 0%^^2:Less 0%^^3:Less 0%^"

                    promo_lines.push({
                        include_field: "",
                        include_value: "",
                        exclude_field: null,
                        exclude_value: null,
                        promo_text: prereq_p_text,
                        include_field_ex: "",
                        include_value_ex: "",
                        exclude_field_ex: null,
                        exclude_value_ex: null,
                        description: prereq_p_desc,
                        quantity: this.promo.reward_trigger_amount,
                        original_price: 0,
                        group_id: 1,
                        promo_type: "P",
                        condition_type: p_condition_type,
                        status: "A"
                    })
                    //  END - Processing of pre-requisite items //

                    //  START - Processing of bonus items //
                    // [2.1] Bonus Item Processing
                    for(var x =0; x < this.selectedProductData.length; x++){
                        let bonus_item = this.selectedProductData[x]

                        promo_lines.push({
                            include_field: "refcode",
                            include_value: bonus_item.reference_code,
                            exclude_field: null,
                            exclude_value: null,
                            promo_text: "",
                            include_field_ex: "refcode",
                            include_value_ex: bonus_item.reference_code,
                            exclude_field_ex: null,
                            exclude_value_ex: null,
                            description: "",
                            quantity: 1,
                            original_price: bonus_item.retail_price.replace(',',''),
                            group_id: 1,
                            promo_type: "B",
                            condition_type: p_condition_type,
                            status: "A",
                            product_id: bonus_item.product_id
                        })
                    }
                    // [2.2] Discount Processing
                    let bonus_p_text= ""
                    let bonus_p_desc= ""

                    let max_application_gb = this.promo.promo_text.replace("@", "")
                    console.log(">> Max Application Check")
                    console.log(max_application_gb)
                    if(parseInt(max_application_gb) == 0){
                        max_application_gb = "999"
                    }
                    //let round_to_nearest = bonus_item.round_to_nearest
                    //arvs
                    let x_round_to_nearest = (this.promo.group_round_to_nearest > 0) ? '^'+this.promo.group_round_to_nearest : '';

                    console.log('#####')
                    console.log(this.promo.promo_discount)
                    console.log(x_round_to_nearest)
                    console.log(this.promo.promo_text)
                    console.log('#####')
                    // this.$emit('refreshPage', event)
                    // return
                    if(this.promo.reward_type == "2"){
                        bonus_p_text = "E1:L" + this.promo.promo_discount + ""+x_round_to_nearest+";" + this.promo.promo_text
                        bonus_p_desc = "Less " + this.promo.promo_discount + ", Limit to " +  max_application_gb
                    }else if(this.promo.reward_type == "1"){
                        bonus_p_text = "E1:" + this.promo.promo_discount + "%"+x_round_to_nearest+";" + this.promo.promo_text
                        bonus_p_desc = "Less " + this.promo.promo_discount + "%, Limit to " +  max_application_gb
                    }else{
                        bonus_p_text = "E1:F" + this.promo.promo_discount + ""+x_round_to_nearest+";" + this.promo.promo_text
                        bonus_p_desc = "New Price: " + this.promo.promo_discount + ", Limit to " +  max_application_gb
                    }

                    promo_lines.push({
                        include_field: "",
                        include_value: "",
                        exclude_field: null,
                        exclude_value: null,
                        promo_text: bonus_p_text,
                        include_field_ex: "",
                        include_value_ex: "",
                        exclude_field_ex: null,
                        exclude_value_ex: null,
                        description: bonus_p_desc,
                        quantity: 1,
                        original_price: 0,
                        group_id: 1,
                        promo_type: "B",
                        condition_type: p_condition_type,
                        status: "A"
                    })
                    // END - Processing of bonus items //
                }

                //Customer Types - Arvin T//
                //Customer Types - Arvin // 
                if (this.customer_type == 'S' && this.customer_card_type_ids.length > 0){
                    this.promo.card_type_included = this.customer_card_type_ids.toString()
                } else if (this.customer_type == 'S' && this.customer_card_type_ids.length == 0) {
                    var cardtypes = this.customerCardTypeOptions.map(function(item) {
                        return item['id'];
                    });
                    this.promo.card_type_included = cardtypes.toString()
                } else if(this.customer_type == '$CLPMEMBERLEVEL$') {
                    this.promo.card_type_included = '$CLPMEMBERLEVEL$' + (this.clp_level_ids || []).join('|')
                } else if(this.customer_type == '$CLPMEMBERTAG$') {
                    this.promo.card_type_included = '$CLPMEMBERTAG$' + (this.clp_tag_ids || []).join('|')
                } else if(this.clp_tag_ids.length > 0 || this.clp_level_ids.length > 0){ 
                    //$CLPMEMBERLEVEL$22|2;$CLPMEMBERTAG$31
                    this.promo.card_type_included = [
                        this.clp_level_ids.length ? '$CLPMEMBERLEVEL$' + this.clp_level_ids.join('|') : null,
                        this.clp_tag_ids.length ? '$CLPMEMBERTAG$' + this.clp_tag_ids.join('|') : null
                        ].filter(Boolean).join(';');
                } else {
                    this.promo.card_type_included = this.customer_type
                }

                // Process Payment Type Code
                // this.promo.promo_text = this.payment_type_code

                // if(this.payment_type_ids.length > 0){
                //     promo_conditions.push({
                //         is_exception: false,
                //         condition_type: "PT",
                //         operation: "IN",
                //         array_values: this.payment_type_ids,
                //         pair_no: 0
                //     })
                // }

                //Compare promos

                //Compare promo_lines

                //Compare promo_sites

                this.promo.promo_sites_updated = isUpdatePromoSite
                this.promo.promo_reward_and_condition_updated = this.isUpdatePromoRewardAndCondition
                this.promo.promo_sites = promo_sites
                this.promo.promo_lines = promo_lines
                this.promo.include_item = this.include_item
                this.promo.discount = this.discount

                //Apply Include 3P & Mark Down Items condition
                //Reset
                this.promo.promo_text = (this.promo.promo_text || '')
                    .replace(/(^|[^a-zA-Z0-9_])(include_3p_items|include_mark_down_items)(?=[^a-zA-Z0-9_]|$)/g, '$1')
                    .replace(/^[^a-zA-Z0-9_]+|[^a-zA-Z0-9_]+$/g, '')
                //Put 
                this.promo.promo_text +=
                    (this.include_3p_items ? '|include_3p_items' : '') +
                    (this.include_mark_down_items ? '|include_mark_down_items' : '')
                
                const accountId = secureStorage.getItem("accountId");

                let form = new FormData();
                if (this.$refs.uploadProductKey.fileList[0] && this.canUploadProduct) {
                  let fileResponse = null
                  console.log("Should handle s3 uploading")
                  this.promo.upload_mode = "1"
                  fileResponse = {}
                  fileResponse.path = "s3-background-processing"
                  form.append('upload_product_path', fileResponse.path);
                  promotion_hash.upload_product_path = fileResponse.path
                }

                promotion_hash.promo = this.promo;

                console.log("PROMO HASH")
                console.log(promotion_hash)

                // let form = new FormData();
                // objectToFormData(form, promotion_hash);

               
                let request = []
                if(this.profileId > 0){
                   // console.log(this.promo)
                  request = await HTTPRequest.putRequest(this.endPoint + 'promos/' + this.profileId, null, promotion_hash)
                  this.create_action_history("Update")
                } else {
                  request = await HTTPRequest.postRequest(this.endPoint + 'promos', null, promotion_hash)
                  this.promotionId = request.id
                  this.create_action_history("Create")
                }

                if (request == undefined) {
                    this.$emit('refreshPage', event)
                } else {
                    if (request["error"] == undefined) {
                        // Handling of S3 Uploading
                        if (this.$refs.uploadProductKey.fileList[0] && this.canUploadProduct) {
                            const uplodingFile = this.$refs.uploadProductKey.fileList[0];
                            const s3FileName =  `${moment().format('MMDDYYhhmmss')}_promov2_${accountId}_${request.promo_id || this.profileId}_${request.job_id}.csv`
                            const myRenamedFile = new File([uplodingFile], s3FileName);

                            // uploadModeChecker = this.$refs.uploadProductKey.uploadMode
                            // if(uploadModeChecker == "1"){
                            console.log("Should upload in s3")
                            // 1709782510622_document_62_161893_1_0_8.csv
                            let fileResponse = await uploadToS3BackgroundProcess(myRenamedFile, 'promotionsv2')
                            console.log(fileResponse)
                            // }                
                        }
                        this.$emit('refreshPage', event)
                    } else {
                        this.errors = request["error"].split(",")
                    }
                }
                this.doneLoading = false
            },
            async create_action_history(action) {
                var id = 0
                if(this.profileId){
                    id = this.profileId
                }else {
                    id = this.promotionId
                }
                var actionHistoryPayload = {
                    action: action,
                    action_at: moment(new Date()),
                    action_by: secureStorage.getItem("userName"),
                    promotion_id: id,
                    status: "A"
                }
                await HTTPRequest.postRequest(this.endPoint + 'promotions_action_histories/', null, actionHistoryPayload)
            },

            replaceDiscount(value){

                console.log("Value >> " + value)
                console.log("Promo >> ")
                console.log(this.promo)


                this.isUpdatePromoRewardAndCondition = true;
              

                if(this.promo.promo_type == "3"){
                    if(value == "1"){
                        this.reward_type_description = "Buy quantity of item X to receive a specified quantity of the same item (e.g Buy 2 of T-Shirt, Get 1 Free)"
                    } else {
                        this.reward_type_description = "Buy quantity of item X to item Y for new price, for a discount, or for free (Buy T-Shirt, Get Umbrella for Free)"
                    }
                } 

                // Item & Pool Discount
                else if(["1", "2"].includes(this.promo.promo_type)){

                    if(this.promo.promo_type == "2"){
                        console.log("PWP")
                        if(value == "1"){
                            this.reward_type_description = "Apply PWP percent discount"
                            this.selectedProductOptions.columns[4].title = "PERCENT DISCOUNT"
                            this.selectedInlineProductOptions.columns[4].title = "PERCENT DISCOUNT"
                        } else if(value == "2"){
                            this.reward_type_description = "Apply PWP amount discount"
                            // this.selectedInlineProductOptions.columns[5].title = "MINIMUM AMOUNT"
                            this.selectedInlineProductOptions.columns[4].title = "AMOUNT DISCOUNT"
                        } else {
                            this.reward_type_description = "Apply PWP change price discount"
                            // this.selectedInlineProductOptions.columns[5].title = "REQUIRED QUANTITY"
                            this.include_item = "6"
                            this.selectedInlineProductOptions.columns[4].title = "NEW PRICE"
                        }
                    } else{
                        console.log("Item & Pool Discount")
                        // PERCENT
                        if(value == "1"){
                            this.reward_type_description = "Apply a discount to an item by percentage (e.g 10%)"
                            this.selectedProductOptions.columns[4].title = "PERCENT DISCOUNT"
                        } 

                        // AMOUNT DISCOUNT
                        else if(value == '2') {
                            this.reward_type_description = "Apply a discount to an item by amount (e.g P100 off)"
                            this.selectedProductOptions.columns[4].title = "AMOUNT DISCOUNT"   
                        } 

                        // NEW PRICE
                        else if(value == '3') {
                            this.reward_type_description = "Apply a discount to an item by giving it new price upon purchase"
                            this.selectedProductOptions.columns[4].title = "NEW PRICE"
                        }

                        // RELATIVE
                        else if(value == "4"){
                            this.reward_type_description = "When quantity is greater than or equal to X, price is X"
                            this.levelColumns[0].title = "QTY >="
                            this.levelColumns[1].title = "PRICE IS"
                        } 

                        // BUNDLE
                        else if(value == "5"){
                            this.reward_type_description = "For a bundle of X, subtotal is X (e.g for every 5 items, subtotal is P20.00)"
                            this.levelColumns[0].title = "BUNDLE OF"
                            this.levelColumns[1].title = "SUBTOTAL IS"
                        }
                        //  BUY X TAKE X
                        else if(value == "6"){
                            this.reward_type_description = "Buy quantity of item X to receive a specified quantity of the same item (e.g Buy 2 of T-Shirt, Get 1 Free)"
                        }
                    }

                    // Handle Include Item Options
                    if(value > 1){
                        this.includeItemOptions = [
                            // {key: "1", value: "All Items"},
                            // {key: "2", value: "All Items from a Specific Supplier"},
                            // {key: "3", value: "All Items from a Specific Brand"},
                            // {key: "4", value: "All Items from a Specific Category"},
                            // {key: "5", value: "All Items Except"},
                            {key: "6", value: "Select Specific Items"}
                        ]
                        this.includeItemOptionsKey++;
                        this.include_item = "6"
                    }else{
                        this.includeItemOptions = [
                            {key: "1", value: "All Items"},
                            {key: "2", value: "All Items from a Specific Supplier"},
                            {key: "3", value: "All Items from a Specific Brand"},
                            {key: "4", value: "All Items from a Specific Category"},
                            {key: "5", value: "All Items Except"},
                            {key: "6", value: "Select Specific Items"}
                        ]
                        this.includeItemOptionsKey++;
                    }
                    
                } 
                
                else if(this.promo.promo_type == "5"){
                    if(value == "1"){
                        this.reward_type_description = "Coupon will be printed if the customer purchases a minimum or specific quantity of items listed (e.g. Buy 2 Shirts, Get 200 Reward Points)"
                        this.coupon_description = "Enter quantity required to activate promo"
                    } else {
                        this.reward_type_description = "Coupon will be printed if the transaction meets the amount criteria specified (e.g. For a minimum purchase of P2000, Get 200 Reward Points)"
                        this.coupon_description = "Enter amount required to activate promo"
                    }
                } 
                
                else if(this.promo.promo_type == "6"){
                    if(value == "1"){
                        this.reward_type_description = "Buy all item on list get item X (e.g Buy all item on the list, Get Discounted or Free Umbrella)"
                    }else if (value == "3"){
                        this.reward_type_description = `Buy target ${(this.PoolOptionKey == "TQ") ? "quantity" : "amount"} get item X (e.g Buy all item on the list, Get Discounted or Free Umbrella)`
                    }else {
                        this.reward_type_description = "Buy any item on list get any item  (e.g Buy any item on the list, Get Discounted or Free Item on the list)"
                    }
                    if (value == "3"){
                        this.selectedBuyXGetYProductOptions.columns[4].visible = false
                    }else{
                        this.selectedBuyXGetYProductOptions.columns[4].visible = true
                    }
                }
                
                else if(this.promo.promo_type == "7"){

                    console.log("PROMO TYPE 7")
                    let label_str = ""
                    if(value == "1"){
                        label_str = "Group Discount - Less Percent"
                        // this.selectedProductOptions.columns[4].title = "PERCENT DISCOUNT"
                    } else if(value == '2') {
                        label_str = "Group Discount - Less Amount"
                        // this.selectedProductOptions.columns[4].title = "AMOUNT DISCOUNT"
                    } else {
                        label_str = "Group Discount - New Price"
                        // this.selectedProductOptions.columns[4].title = "NEW PRICE"
                    }
                    this.reward_type_description = label_str
                    this.discountLabel = label_str
                } 
                
                else {
                    if(value == "1"){
                        this.reward_type_description = "Apply a discount to an item by percentage (e.g 10%)"
                        this.selectedProductOptions.columns[4].title = "PERCENT DISCOUNT"
                    } else if(value == '2') {
                        this.reward_type_description = "Apply a discount to an item by amount (e.g P100 off)"
                        this.selectedProductOptions.columns[4].title = "AMOUNT DISCOUNT"
                    } else if(value == '4') {
                        this.reward_type_description = "Relative Pricing"
                        // this.selectedProductOptions.columns[4].title = "AMOUNT DISCOUNT"
                    } else if(value == '5') {
                        this.reward_type_description = "Bundle Pricing"
                        // this.selectedProductOptions.columns[4].title = "AMOUNT DISCOUNT"
                    } else if(value == '6') {
                        this.reward_type_description = "Buy X Take X"
                        // this.selectedProductOptions.columns[4].title = "AMOUNT DISCOUNT"
                    }
                    else {
                        this.reward_type_description = "Apply a discount to an item by giving it new price upon purchase"
                        this.selectedProductOptions.columns[4].title = "NEW PRICE"
                    }
                }
                this.replaceDiscountKey = value
                this.refKey++
            },
            showDrawer() {
                this.typeVisible = true;
            },
            onClose() {
                this.typeVisible = false;
            },
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            async filter(inputValue) {
                if (inputValue.length >= 3) {
                    this.categoriesOptions = await HTTPRequest.getRequest(this.endPoint + 'categories/cascader_view?name=' + inputValue, null);
                }
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            async searchSupplier(value){
                this.fetching = true;

                let suppliers = await HTTPRequest.getRequest(this.endPoint + "/suppliers/get_valid_suppliers?name=" + value , null, null)
                if(suppliers != null){
                    this.supplierOptions = suppliers
                    this.sort(this.supplierOptions);
                } else {
                    this.supplierOptions = []
                }

                this.fetching = false;
            },
            async searchBrand(value){
                this.fetching = true;

                // Start
                // [Easyday Plus] Searching for brand name is not working under Promotion Management
                // https://tools.iripple.com/barter-11/bxi-backend/-/issues/1732
                // var userBrands = secureStorage.getItem("userBrands") || ""
                let brands = await HTTPRequest.getRequest(this.endPoint + "/brands/get_valid_brands?name=" + value + "&userBrands=true" , null, null)
                // let brands = await HTTPRequest.getRequest(this.endPoint + "/brands/get_valid_brands?name=" + value + "&userBrands=" + userBrands , null, null)

                // [Easyday Plus] Searching for brand name is not working under Promotion Management
                // https://tools.iripple.com/barter-11/bxi-backend/-/issues/1732
                // End

                if(brands != null){
                    this.brandOptions = brands
                    this.sort(this.brandOptions);
                } else {
                    this.brandOptions = []
                }

                this.fetching = false;
            },
            validateForm(){
                this.errors = [];
                // this.errors.push(ValidateField.required('Code', this.inputCode));
                // this.errors.push(ValidateField.alphanumericWithSpecialChars('Code', this.inputCode));
                // this.errors.push(ValidateField.charMinAndMax('Code', this.inputCode, 0, 30));
                // this.errors.push(ValidateField.required('Name', this.inputName));
                // this.errors.push(ValidateField.alphanumericWithSpecialChars('Name', this.inputName));
                // this.errors.push(ValidateField.charMinAndMax('Name', this.inputName, 0, 50));
                // this.errors = this._.compact(this.errors);
                document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
                return this.errors.length;
            },
            checkImportJobBeforeSaving: async function() {
              const importJob = await HTTPRequest.getRequest(`${this.endPoint}import_jobs?profile_name=PromotionUploadProduct-${this.profileId}`, null)
              if(!importJob || importJob.data.length == 0){
                return false;
              }

              const hasUploadingFile = this.$refs.uploadProductKey.fileList[0];

              const errMsg = hasUploadingFile ? "Can't upload another file when there's an Ongoing upload of Products" : "Can't activate a promotion with Ongoing upload of Products";

              if(importJob.data[0].formatted_status == 'Ongoing') {
                this.$notification['warning']({
                  message: 'Ongoing Upload',
                  duration: 0,
                  description: `${errMsg} [PromotionUploadProduct-${this.profileId}]. Click 'View Jobs' to review uploading process.`,
                  btn: h => {
                    return h(
                    'base-button',
                    {
                      props: {
                      type: 'warning',
                      class: 'btn-sm',
                      },
                      on: {
                      click: () => component_x.$router.push("/jobs"),
                      },
                    },
                    'View Jobs',
                    );
                  },
                });

                return true;
              }

              return false;
            },
            async getLocationTreeData(){
                // component_x.productLocationData = [];
                var apiData = await HTTPRequest.getRequest(this.endPoint + "sites/get_valid_tree_sites?by=concept", null);
                // var apiData = await HTTPRequest.getRequest(this.endPoint + "sites/get_valid_tree_sites", null);

        
                let treeSites = (data, root) => {
                    var r = [], o = {};
                    data.forEach(a => {
                        if (o[a.key] && o[a.key].children) {
                            a.children = o[a.key].children;
                        }
                        o[a.key] = a;
                        if (a.parent_id === root) {
                            r.push(a);
                        } else {
                            o[a.parent_id] = o[a.parent_id] || {};
                            o[a.parent_id].children = o[a.parent_id].children || [];
                            o[a.parent_id].children.push(a);
                        }
                    });
                    return r;
                };
                
                let treeData = treeSites(apiData, null);

                // console.log("==TREE SITES")
                // console.log(treeData)
                let noLocationSites = [];

                treeData.forEach(el => {
                    if (el.children) {
                        el.children.forEach(child => {
                            //arvs refcode
                            child.title = `${child.refcode} - ${child.title}`;
                            if (child.children) {
                                child.children.forEach(grandChild => {
                                    grandChild.title = `${grandChild.code} - ${grandChild.title}`;
                                    if (grandChild.children) {
                                        grandChild.children.forEach(greatGrandChild => {
                                            greatGrandChild.title = `${greatGrandChild.code} - ${greatGrandChild.title}`;
                                        });
                                    }
                                });
                            }
                        });
                    } else if (!el.location) {
                        noLocationSites.push(el); // collect sites with no location
                    }

                    if (el.code && el.title) {
                        el.title = `${el.code} - ${el.title}`;
                    }

                    if (el.children || el.code) {
                        this.productLocationData.push({
                            id: el.id,
                            key: el.key,
                            title: el.title,
                            children: el.children
                        });
                    }
                });

                // console.log("==TREE SITES PROCESSEDS")
                // console.log(treeData)
                
                const removeKeyAndRenameToID = (object, deleteKey) => {
                // if object
                // delete object[deleteKey];
                    if (object["key"] != null && object["key"] != undefined && !object["key"].includes("ST", 0)) {
                        object["key"] = parseInt(object["key"]);
                    }
                    
                    delete object["id"];
                    
                    Object.values(object).forEach(val => {
                        if (typeof val !== 'object') return;
                        removeKeyAndRenameToID(val, deleteKey);
                    });
                };
                
                removeKeyAndRenameToID(this.productLocationData, 'key');

                // sort so that unspecified first
                this.productLocationData.sort((a, b) =>
                    a.title < b.title ? -1 : Number(a.title > b.title)
                );

                // console.log(this.productData)
                // end location tagging convert children and parent || tree data for site products

                // add a separate tree view/node for sites w/ no location at the top of the list
                if (noLocationSites.length > 0) {
                    this.productLocationData.unshift({
                        id: 'no-location',
                        key: 'no-location',
                        title: 'Sites with No Site Concept',
                        children: noLocationSites.map(site => ({
                            id: site.id,
                            key: parseInt(site.key), // ensure key is an integer
                            title: `${site.title}`,
                            children: site.children || []
                        }))
                    });
                }

                // remove duplicates from the main list
                this.productLocationData = this.productLocationData.filter(el => el.location || (el.children && el.children.length > 0));
                this.filteredLocationData = [...this.productLocationData];

                // console.log(">>>>>>>")
                // console.log(this.filteredLocationData)
            },
            processSiteCodesInput() {
                // split the input by commas and trim whitespace
                this.notifMessage = [];
                if(this.siteCodesInput.length == 0){
                    this.notifMessage.push('No inputed site code!');
                    this.promoActionNotification('Opps...', 'error');    
                    return
                }
                const siteCodes = this.siteCodesInput.split(',').map(code => code.trim());
                const newSelectedRowKeys = [];
                this.notifMessage = [];
                this.selectedSites = [];

                console.log("haha: ", siteCodes);

                // iterate over the site codes and find corresponding nodes
                siteCodes.forEach(siteCode => {
                    // console.log(">>>>>>>>")
                    // console.log(this.productLocationData)
                    const node = this.findNodeBySiteCode(this.productLocationData, siteCode);
                    if (node) {
                        // valid site codes
                        if (!newSelectedRowKeys.includes(node.key)) {
                            console.log("node: ", node);
                            // add the node's key to selectedRowKeys if not already present
                            newSelectedRowKeys.push(node.key);
                            if(node.children){
                                node.children.forEach(childSite =>{
                                    if (!newSelectedRowKeys.includes(childSite.key)) {
                                        newSelectedRowKeys.push(childSite.key);
                                    }
                                })
                            }
                        }
                        this.selectedSites.push(node); // store selected site
                    } else {
                        // invalid site codes - show validation error notif message
                        this.notifMessage.push(`Site code "${siteCode}" does not exist.`);
                    }
                });

                if (this.notifMessage.length) {
                    this.promoActionNotification('Invalid site codes', 'error');    
                } else {
                    this.promoActionNotification('Site codes added', 'success');
                    this.isModalVisible = true;
                }

                // update selectedRowKeys to reflect the new valid site codes
                this.selectedRowKeys = newSelectedRowKeys;

                // use $nextTick for DOM updates
                this.$nextTick(() => {
                    // force update to ensure DOM is updated
                    this.$forceUpdate();
                });
            },
            handleOk_() {
                this.isModalVisible = false;
            },
            showSelectedSites() {
                this.selectedSites = [];
                const collectSelectedSites = (nodes) => {
                    nodes.forEach(node => {
                        if (this.selectedRowKeys.includes(node.key)) {
                            this.selectedSites.push(node);
                        }
                        if (node.children) {
                            collectSelectedSites(node.children);
                        }
                    });
                };
                collectSelectedSites(this.productLocationData);
                this.isModalVisible = true;
            },
            clearSiteCodes() {
                // clear all selected data
                this.siteCodesInput = ''; // for input
                this.selectedRowKeys = []; // selected keys
                this.searchQuery = ''; // for search
                this.filteredLocationData = this.productLocationData; // reset to original tree data

                // use $nextTick for DOM updates
                this.$nextTick(() => {
                    // force update to ensure DOM is updated
                    this.$forceUpdate();
                });
            },
            // find a node by site code
            findNodeBySiteCode(data, siteCode) {
                let foundNode = null;
                for (const node of data) {
                    if (node.title.startsWith(siteCode + ' -')) {
                        foundNode = node;
                        break;
                    }
                    if (node.children && node.children.length > 0) {
                        foundNode = this.findNodeBySiteCode(node.children, siteCode);
                        if (foundNode) break;
                    }
                }
                return foundNode;
            },
            filterSites() {
                const query = this.searchQuery.toLowerCase().trim();

                if (query === '') {
                    this.filteredLocationData = this.productLocationData;
                    return;
                }
                const filterTree = (data) => {
                    return data.map(item => {
                        const newItem = { ...item };
                        if (newItem.children) {
                            newItem.children = filterTree(newItem.children);
                        }
                        return newItem;
                    }).filter(item => {
                        const childrenWithMatch = item.children && item.children.length > 0;
                        const matchesQuery = item.title.toLowerCase().includes(query);
                        if (matchesQuery || childrenWithMatch) {
                            return true;
                        } else if (item.children) {
                            return filterTree(item.children).length > 0;
                        }
                        return false;
                    });
                };
                this.filteredLocationData = filterTree(this.productLocationData);

                // if (this.filteredLocationData.length === 0) {
                //     this.promoActionNotification('No results found for the given search query', 'error');
                // }
            },
            onCheckSiteId(selectedRowKeys, event) {
                this.selectedRowKeys = selectedRowKeys;
            },
            getNotificationStyle(type) { // helper function for notification styles
                return {
                    success: {
                        color: 'rgba(0, 0, 0, 0.65)',
                        border: '1px solid #b7eb8f',
                        backgroundColor: '#f6ffed'
                    },
                    warning: {
                        color: 'rgba(0, 0, 0, 0.65)',
                        border: '1px solid #ffe58f',
                        backgroundColor: '#fffbe6'
                    },
                    error: {
                        color: 'rgba(0, 0, 0, 0.65)',
                        border: '1px solid #ffa39e',
                        backgroundColor: '#fff1f0'
                    },
                    info: {
                        color: 'rgba(0, 0, 0, 0.65)',
                        border: '1px solid #91d5ff',
                        backgroundColor: '#e6f7ff'
                    }
                }[type];
            },
            promoActionNotification(action, type) {
                if (type === 'success') {
                    this.$notification[type]({
                        message: _.startCase(action) + ' action success',
                        style: this.getNotificationStyle(type)
                    });
                } else if (type === 'error') {
                    this.$notification[type]({
                        message: _.startCase(action) + ' action failed',
                        description: h => {
                            return <ul class='m-0 p-0'>
                                {this.notifMessage.map((value, index) => {
                                    return <li key={index}>{value}</li>;
                                })}
                            </ul>;
                        },
                        style: this.getNotificationStyle(type)
                    });
                }
            },
            checkImportJobs: async function() {
              //Check if with ongoing jobs
              const importJob = await HTTPRequest.getRequest(`${this.endPoint}import_jobs?profile_name=PromotionUploadProduct-${this.profileId}`, null)
              if(importJob != undefined && importJob.data.length > 0){
                if(importJob.data[0].formatted_status == 'Ongoing') {
                  this.$notification['success']({
                    message: 'Ongoing Upload',
                    duration: 0,
                    description: "There's an ongoing upload of CSV file for this Promotion. Click 'View Jobs' to review.",
                    btn: h => {
                      return h(
                      'base-button',
                      {
                        props: {
                        type: 'success',
                        class: 'btn-sm',
                        },
                        on: {
                        click: () => component_x.$router.push("/jobs"),
                        },
                      },
                      'View Jobs',
                      );
                    },
                  });
                } else if(importJob.data[0].formatted_status == 'With errors') {
                  this.$notification['warning']({
                    message: 'Upload Error',
                    duration: 0,
                    description: `CSV file uploaded with errors [PromotionUploadProduct-${this.profileId}] but you can ignore it and continue processing the promotion. Click 'View Jobs' button to review.`,
                    btn: h => {
                      return h(
                      'base-button',
                      {
                        props: {
                        type: 'warning',
                        class: 'btn-sm',
                        },
                        on: {
                        click: () => component_x.$router.push("/jobs"),
                        },
                      },
                      'View Jobs',
                      );
                    },
                  });
                }
              }
            },
            async checkItemIfMatrix(data,promo_value){
                if(data.product_type == "M"){
                    var child_items = await HTTPRequest.getRequest(this.endPoint + 'products?search_type=P&matrix_parent_id=' + data.id , null);
                    for(let i = 0; i < child_items.total; i++) {
                        var value = child_items.data[i]
                        if (this.selectedProd.includes(value.id) == false){
                            this.selectedProd.push(value.id)
                            let button = document.getElementById("add_"+value.id);
                            this.selectedProductData.push({
                            product_id: value.id,
                            name:value.name,
                            retail_price: value.retail_price.replace(',',''),
                            promo_value: promo_value,
                            barcode: value.barcode,
                            reference_code: value.reference_code,
                            required_value: 1,
                            stock_no: value.stock_no
                            })
                            if(button != undefined && button != null){
                                button.className = "btn btn-sm btn-default"
                                button.innerHTML = "UNDO"
                            }
                        }
                    }
                }
            },
            addDeleteButton (cell, formatterParams){
              if (this.viewOnly) { return null; }
              let product_id = cell.getRow().getData().product_id
              let button = '<button id="' + product_id + '" class="btn btn-sm btn-danger">Delete</button>';
              return button
            },
            searchItemListProduct: function(){
                const tabulatorInstance = this.$refs.addedProductTabulator.getInstance()
                if (tabulatorInstance){
                    if (this.tempItemListData.length == 0){
                        this.tempItemListData = tabulatorInstance.getData()
                    }
                }
                var filteredData = this.filter(this.searchText1,this.tempItemListData)
                tabulatorInstance.setData(filteredData)
            },
            updateExceptions(value){
                this.promoExceptions = [...this.promoExceptions, ...value]
                this.promoExceptionKey++;
                this.togglePromoExceptionsDrawer(false)
            },
            deleteException(record){
                console.log("Should delete record...")
                let checker = this.promoExceptions.findIndex(element => (element["exception_type"] === record["exception_type"] && element["exception_value"] === record["exception_value"]) );
                if (checker >= 0)
                this.promoExceptions.splice(checker, 1);
            },
            filter(inputValue, path) {
                return path.filter( (item) => {
                    var i;
                    if (this.filterField1 == "product_id"){
                        i = item[`${this.filterField1}`].toString()
                    }else{
                        i = item[`${this.filterField1}`]
                    }
                    return i.toLowerCase().indexOf(inputValue.toLowerCase()) != -1
                });
                
            },
            selectProductAction: function(e, cell){
                this.isUpdatePromoRewardAndCondition = true
                if (e.target.id == '') { return; }
                const index = this.selectedProd.indexOf(parseInt(e.target.id));
                const dataSource = [...this.selectedProductData];
                this.selectedProductData = dataSource.filter(item => item.product_id !== e.target.id);
                if (index > -1) {
                    cell.getRow().delete();
                    this.selectedProd.splice(index, 1);
                    this.tempItemListData.splice(index, 1);
                    this.selectedProductData.splice(index, 1);
                }
            },
            DeleteAll: function(e, cell){
                const tabulatorInstance = this.$refs.addedProductTabulator.getInstance()
                if (tabulatorInstance){
                    var selectedRows = tabulatorInstance.getSelectedRows()
                    var selectedData = tabulatorInstance.getSelectedData()
                    for(var i=0;i<selectedRows.length;i++)
                    {
                        const index = this.selectedProd.indexOf(parseInt(selectedData[i].product_id));
                        if (index > -1) {
                            this.selectedProductData.splice(index, 1);
                            this.selectedProd.splice(index, 1);
                            this.tempItemListData.splice(index, 1);
                            selectedRows[i].delete();
                        }
                    }
                }
            },
            async exportExcel(){
                this.JsonData = []
                console.log(this.promo)
                this.formatHeader("PROMO NAME",this.promo.name,null,null,null,null,null,"STATUS",this.promo.duration_status,null,null)
                this.formatHeader("PROMO CODE",this.promo.code,null,null,null,null,null,null,null,null,null)
                this.formatHeader("PROMO DURATION","START DATE:",this.promo.start_at.format(this.dateFormat),null,"END DATE:",this.promo.end_at.format(this.dateFormat),null,"CREATED BY",this.promo.created_by,null,null)
                this.formatHeader(null,"START TIME:",this.promo.start_at.format("hh:mm A"),null,"END TIME:",this.promo.end_at.format("hh:mm A"),null,"UPDATED BY",this.promo.updated_by,null,null)
                this.formatHeader(null,"VALID DAY/S:",this.promo.valid_day,null,null,null,null,null,null,null,null)
                this.formatHeader(null,"VALID TIME:",`${this.promo.valid_start_time || ''} - ${this.promo.valid_end_time || ''}`,null,null,null,null,null,null,null,null)
                var reward_types = []
                var value1 = null
                var header2 = null
                var value2 = null
                var value3 = null
                var cvalue1 = null
                var cheader2 = null
                var cvalue2 = null
                var cvalue3 = null
                var payment_type = null
                if(this.promo.promo_type == '7'){
                    value1 = "FOR EVERY AMT/ QTY OF"
                    header2 = this.promo.reward_trigger_amount
                    value2 = "LIMIT"
                    value3 = this.promo.promo_text
                    reward_types = this.pwpOptions
                    cvalue1 = "GROUP DISCOUNT"
                    cheader2 = this.promo.promo_discount
                    cvalue2 = "GROUP DISCOUNT ROUND"
                    cvalue3 = this.promo.group_round_to_nearest
                    payment_type = this.payment_type_code
                }else if (this.promo.promo_type == '2'){
                    payment_type = this.promo.payment_type_code
                    reward_types = this.pwpOptions
                }else {
                    payment_type = this.payment_type_code
                    reward_types = this.itemPoolOptions
                }
                var index = reward_types.findIndex(n => n.key == component_x.promo.reward_type)
                this.formatHeader("PROMOTION TYPE",reward_types[index].value,null,value1,header2,value2,null,value3,null,null,null)
                this.formatHeader("CUSTOMER",this.customer_type.replaceAll("$",""),null,cvalue1,cheader2,cvalue2,null,cvalue3,null,null,null)
                this.formatHeader("PAYMENT TYPE",payment_type,null,null,null,null,null,null,null,null,null)
                this.JsonData.push({})
                if(this.promo.promo_type == '7'){
                    console.log(this.selectedProductData,
                    this.selectedProductDataB)
                    this.formatHeader(null,null,null,null,"PRE-REQUISITE ITEM LIST",null,null,null,null,null,null)
                    this.formatHeader(null,null,"DESCRIPTION",null,null,"BARCODE","RETAIL PRICE",null,null,null,null)
                    this.selectedProductData.forEach(function (data, index) {
                        component_x.formatHeader(data.name,null,null,null,null,data.barcode,data.retail_price,null,null,null,null)
                    });
                    this.JsonData.push({})
                    this.formatHeader(null,null,null,null,"PROMOTION ITEM LIST",null,null,null,null,null,null)
                    this.formatHeader(null,null,"DESCRIPTION",null,null,"BARCODE","RETAIL PRICE",null,null,null,null)
                    this.selectedProductDataB.forEach(function (data, index) {
                        component_x.formatHeader(data.name,null,null,null,null,data.barcode,data.retail_price,null,null,null,null)
                    });
                }else{
                    this.formatHeader(null,null,null,null,"ITEM LIST",null,null,null,null,null,null)
                    const promoType = parseInt(this.promo.promo_type)
                    let specialData = {}

                    if (promoType == 2) {
                        specialData = { applyLevel: this.reward.apply_level }
                    }

                    if (promoType == 6) {
                        specialData = { coupleType: this.coupleType }
                    }


                    const data = exportProductCSV(
                        promoType,
                        this.promo.reward_type,
                        this.selectedProductData,
                        this.selectedProductDataB,
                        specialData
                    );

                    const { csvHeaders, csvData } = data;

                    var table_col1 = null
                    var table_col2 = null
                    if (parseInt(this.promo.reward_type) <=3){
                        table_col1 = "DISCOUNT"
                    }else if (parseInt(this.promo.reward_type) == 4 || parseInt(this.promo.reward_type) == 5){
                        table_col1 = "LEVELS"
                        table_col2 = "SUBTOTAL IS"
                    } else {
                        table_col1 = "BUY QTY"
                        table_col2 = "TAKE QTY"
                    }
                    this.formatHeader(null,null,"DESCRIPTION",null,null,csvHeaders.barcode.title,csvHeaders.retailPrice.title,"LIMIT","ROUND",table_col1,table_col2)
                    csvData.forEach(function (data, index) {
                        if (parseInt(component_x.promo.reward_type) <=3){
                            component_x.formatHeader(data.name,null,null,null,null,data.barcode,data.retailPrice,data.limit,data.round,data.discount,null)
                        } else if(parseInt(component_x.promo.reward_type) ==6){
                            component_x.formatHeader(data.name,null,null,null,null,data.barcode,data.retailPrice,data.limit,data.round,data.requiredValue,data.discount.replace("^1",""))
                        } else {
                            data.discount.forEach(function (d, i) {
                                if (parseInt(component_x.promo.reward_type) ==5){
                                    d = d.replace('(1:S',"")
                                    var dd = d.split(":")
                                }else{
                                    d = d.replace('R',"")
                                    var dd = d.split("|")
                                }
                                if(i==0){
                                    component_x.formatHeader(data.name,null,null,null,null,data.barcode,data.retailPrice,data.limit,data.round,dd[0].replace("^1",""),dd[1].replace("^1",""))
                                }else{
                                    component_x.formatHeader(null,null,null,null,null,null,null,null,null,dd[0].replace("^1",""),dd[1].replace("^1",""))
                                }
                            })
                        }
                    });
                }
                this.formatHeader(null,null,null,null,null,null,null,null,null,null,null)
                this.formatHeader(null,null,null,null,null,null,null,null,null,null,null)
                this.formatHeader(null,null,null,null,"SITES",null,null,null,null,null,null)
                
                if(this.site_selection == 'A'){
                    this.formatHeader("ALL",null,null,null,null,null,null,null,null,null,null)
                }else{
                    await this.showSelectedSites()
                    this.selectedSites.forEach(function (data, index) {
                        component_x.formatHeader(data.title,null,null,null,null,null,null,null,null,null,null)
                    });
                    console.log(this.selectedSites)
                }
                this.formatHeader(null,null,null,null,null,null,null,null,null,null,null)
                this.formatHeader(`Generated on: ${moment().format(`${component_x.dateFormat} hh:mm A`)}`,null,null,null,null,null,null,null,null,null,null)
                this.formatHeader(`Generated on: ${secureStorage.getItem("userName")}`,null,null,null,null,null,null,null,null,null,null)
                setTimeout(() => { this.$refs.exportExcelBtn.click() }, 200)
            },
            formatHeader(header,value,header1,value1,header2,value2,header3,value3,header4,value4,remark){
                var data = {
                    " ":header,
                    "  ":value,
                    "   ":header1,
                    "    ":value1,
                    "     ":header2,
                    "      ":value2,
                    "       ":header3,
                    "        ":value3,
                    "         ":header4,
                    "          ":value4,
                    "           ":remark
                }
                this.JsonData.push(data)
            }
        }
    }
</script>

<style scoped>
  .ant-table-fixed-header .ant-table-scroll .ant-table-header {
    overflow: hidden;
  }
  .ant-steps-item-process .ant-steps-item-icon{
    background: #65CB8F;
    border: #65CB8F;
  }
  .ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item-description {
    white-space: nowrap;
    max-width: 100%;
  }
  .ant-steps-item-finish .ant-steps-item-icon {
    border-color: #AFB5BC;
    background-color: #fff;
  }
  .ant-steps-item-finish > .ant-steps-item-content > .ant-steps-item-title:after {
    background-color: #AFB5BC;
  }

  .numberCircle {
    display:inline-block;
    border-radius:50%;
    border:2px solid;
    font-size:18px;
    background: #65CB8F;
    border: #65CB8F;
    color: #ffffff;
  }

  .numberCircle:before,
  .numberCircle:after {
    content:'\200B';
    display:inline-block;
    line-height:0px;
    padding-top:50%;
    padding-bottom:50%;
  }

  .numberCircle:before {
    padding-left:8px;
  }
  .numberCircle:after {
    padding-right:8px;
  }

  .filter-cont {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 20px;
  }

  .ellisis-cont .dropdown-menu .dropdown-item {
    cursor: pointer;
  }
</style>
